import { randomNormal } from 'd3-random';

function genDateValue(n) {
  return Array(n).fill(1).map(function (d, i) {
    return {
      date: new Date(Date.now() - i * 3600000),
      value: Math.max(250, Math.random() * 3000 | 0)
    };
  });
}

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var random = randomNormal(0, 0.2);
var sqrt3 = Math.sqrt(3);

function range(n) {
  return Array(n).fill(1);
}

function genPointsRange(n, _ref) {
  var _ref2 = slicedToArray(_ref, 3),
      offsetX = _ref2[0],
      offsetY = _ref2[1],
      index = _ref2[2];

  return range(n).map(function () {
    return [random() + offsetX, random() + offsetY, index];
  });
}

function genPoints() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

  return [].concat(toConsumableArray(genPointsRange(count, [sqrt3, 1, 0])), toConsumableArray(genPointsRange(count, [-sqrt3, 1, 1])), toConsumableArray(genPointsRange(count, [0, -1, 2])));
}

var defaultCount = function defaultCount(i, n) {
  return Math.random() * (25 * (n - i));
};

var defaultBin = function defaultBin(i, n) {
  return i * 150;
};

function genBin(n) {
  var bin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultBin;
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultCount;

  return Array(n).fill(1).reduce(function (data, d, i) {
    return data.concat([{
      bin: bin(i, n),
      count: count(i, n)
    }]);
  }, []);
}

function genBins(x, y, bin, count) {
  return Array(x).fill(1).reduce(function (data, d, i) {
    return data.concat([{
      bin: i,
      bins: genBin(y, bin, count)
    }]);
  }, []);
}

var random$1 = randomNormal(4, 3);
var randomOffset = function randomOffset() {
  return Math.random() * 10;
};
var sampleSize = 1000;

function genStats(number) {
  var data = [];
  var i = void 0;

  var _loop = function _loop() {
    var points = [];
    var j = void 0;
    var offset = randomOffset();
    for (j = 0; j < sampleSize; j += 1) {
      points.push(offset + random$1());
    }

    points.sort(function (a, b) {
      return a - b;
    });

    var firstQuartile = points[Math.round(sampleSize / 4)];
    var thirdQuartile = points[Math.round(3 * sampleSize / 4)];
    var IQR = thirdQuartile - firstQuartile;

    var min = firstQuartile - 1.5 * IQR;
    var max = thirdQuartile + 1.5 * IQR;

    var outliers = points.filter(function (p) {
      return p < min || p > max;
    });
    var binWidth = 2 * IQR * Math.pow(sampleSize - outliers.length, -1 / 3);
    var binNum = Math.round((max - min) / binWidth);
    var actualBinWidth = (max - min) / binNum;

    var bins = Array(binNum + 2).fill(0);
    var values = Array(binNum + 2).fill(min);

    for (var _i = 1; _i <= binNum; _i += 1) {
      values[_i] += actualBinWidth * (_i - 0.5);
    }

    values[values.length - 1] = max;

    points.filter(function (p) {
      return p >= min && p <= max;
    }).forEach(function (p) {
      bins[Math.floor((p - min) / actualBinWidth) + 1] += 1;
    });

    var binData = values.map(function (v, i) {
      return {
        value: v,
        count: bins[i]
      };
    });

    var boxPlot = {
      x: 'Statistics ' + i,
      min: min,
      firstQuartile: firstQuartile,
      median: points[Math.round(sampleSize / 2)],
      thirdQuartile: thirdQuartile,
      max: max,
      outliers: outliers
    };

    data.push({
      boxPlot: boxPlot,
      binData: binData
    });
  };

  for (i = 0; i < number; i += 1) {
    _loop();
  }
  return data;
}

var appleStock = [{ date: '2007-04-24T07:00:00.000Z', close: 93.24 }, { date: '2007-04-25T07:00:00.000Z', close: 95.35 }, { date: '2007-04-26T07:00:00.000Z', close: 98.84 }, { date: '2007-04-27T07:00:00.000Z', close: 99.92 }, { date: '2007-04-30T07:00:00.000Z', close: 99.8 }, { date: '2007-05-01T07:00:00.000Z', close: 99.47 }, { date: '2007-05-02T07:00:00.000Z', close: 100.39 }, { date: '2007-05-03T07:00:00.000Z', close: 100.4 }, { date: '2007-05-04T07:00:00.000Z', close: 100.81 }, { date: '2007-05-07T07:00:00.000Z', close: 103.92 }, { date: '2007-05-08T07:00:00.000Z', close: 105.06 }, { date: '2007-05-09T07:00:00.000Z', close: 106.88 }, { date: '2007-05-10T07:00:00.000Z', close: 107.34 }, { date: '2007-05-11T07:00:00.000Z', close: 108.74 }, { date: '2007-05-14T07:00:00.000Z', close: 109.36 }, { date: '2007-05-15T07:00:00.000Z', close: 107.52 }, { date: '2007-05-16T07:00:00.000Z', close: 107.34 }, { date: '2007-05-17T07:00:00.000Z', close: 109.44 }, { date: '2007-05-18T07:00:00.000Z', close: 110.02 }, { date: '2007-05-21T07:00:00.000Z', close: 111.98 }, { date: '2007-05-22T07:00:00.000Z', close: 113.54 }, { date: '2007-05-23T07:00:00.000Z', close: 112.89 }, { date: '2007-05-24T07:00:00.000Z', close: 110.69 }, { date: '2007-05-25T07:00:00.000Z', close: 113.62 }, { date: '2007-05-29T07:00:00.000Z', close: 114.35 }, { date: '2007-05-30T07:00:00.000Z', close: 118.77 }, { date: '2007-05-31T07:00:00.000Z', close: 121.19 }, { date: '2007-06-01T07:00:00.000Z', close: 118.4 }, { date: '2007-06-04T07:00:00.000Z', close: 121.33 }, { date: '2007-06-05T07:00:00.000Z', close: 122.67 }, { date: '2007-06-06T07:00:00.000Z', close: 123.64 }, { date: '2007-06-07T07:00:00.000Z', close: 124.07 }, { date: '2007-06-08T07:00:00.000Z', close: 124.49 }, { date: '2007-06-11T07:00:00.000Z', close: 120.19 }, { date: '2007-06-12T07:00:00.000Z', close: 120.38 }, { date: '2007-06-13T07:00:00.000Z', close: 117.5 }, { date: '2007-06-14T07:00:00.000Z', close: 118.75 }, { date: '2007-06-15T07:00:00.000Z', close: 120.5 }, { date: '2007-06-18T07:00:00.000Z', close: 125.09 }, { date: '2007-06-19T07:00:00.000Z', close: 123.66 }, { date: '2007-06-20T07:00:00.000Z', close: 121.55 }, { date: '2007-06-21T07:00:00.000Z', close: 123.9 }, { date: '2007-06-22T07:00:00.000Z', close: 123 }, { date: '2007-06-25T07:00:00.000Z', close: 122.34 }, { date: '2007-06-26T07:00:00.000Z', close: 119.65 }, { date: '2007-06-27T07:00:00.000Z', close: 121.89 }, { date: '2007-06-28T07:00:00.000Z', close: 120.56 }, { date: '2007-06-29T07:00:00.000Z', close: 122.04 }, { date: '2007-07-02T07:00:00.000Z', close: 121.26 }, { date: '2007-07-03T07:00:00.000Z', close: 127.17 }, { date: '2007-07-05T07:00:00.000Z', close: 132.75 }, { date: '2007-07-06T07:00:00.000Z', close: 132.3 }, { date: '2007-07-09T07:00:00.000Z', close: 130.33 }, { date: '2007-07-10T07:00:00.000Z', close: 132.35 }, { date: '2007-07-11T07:00:00.000Z', close: 132.39 }, { date: '2007-07-12T07:00:00.000Z', close: 134.07 }, { date: '2007-07-13T07:00:00.000Z', close: 137.73 }, { date: '2007-07-16T07:00:00.000Z', close: 138.1 }, { date: '2007-07-17T07:00:00.000Z', close: 138.91 }, { date: '2007-07-18T07:00:00.000Z', close: 138.12 }, { date: '2007-07-19T07:00:00.000Z', close: 140 }, { date: '2007-07-20T07:00:00.000Z', close: 143.75 }, { date: '2007-07-23T07:00:00.000Z', close: 143.7 }, { date: '2007-07-24T07:00:00.000Z', close: 134.89 }, { date: '2007-07-25T07:00:00.000Z', close: 137.26 }, { date: '2007-07-26T07:00:00.000Z', close: 146 }, { date: '2007-07-27T07:00:00.000Z', close: 143.85 }, { date: '2007-07-30T07:00:00.000Z', close: 141.43 }, { date: '2007-07-31T07:00:00.000Z', close: 131.76 }, { date: '2007-08-01T07:00:00.000Z', close: 135 }, { date: '2007-08-02T07:00:00.000Z', close: 136.49 }, { date: '2007-08-03T07:00:00.000Z', close: 131.85 }, { date: '2007-08-06T07:00:00.000Z', close: 135.25 }, { date: '2007-08-07T07:00:00.000Z', close: 135.03 }, { date: '2007-08-08T07:00:00.000Z', close: 134.01 }, { date: '2007-08-09T07:00:00.000Z', close: 126.39 }, { date: '2007-08-10T07:00:00.000Z', close: 125 }, { date: '2007-08-13T07:00:00.000Z', close: 127.79 }, { date: '2007-08-14T07:00:00.000Z', close: 124.03 }, { date: '2007-08-15T07:00:00.000Z', close: 119.9 }, { date: '2007-08-16T07:00:00.000Z', close: 117.05 }, { date: '2007-08-17T07:00:00.000Z', close: 122.06 }, { date: '2007-08-20T07:00:00.000Z', close: 122.22 }, { date: '2007-08-21T07:00:00.000Z', close: 127.57 }, { date: '2007-08-22T07:00:00.000Z', close: 132.51 }, { date: '2007-08-23T07:00:00.000Z', close: 131.07 }, { date: '2007-08-24T07:00:00.000Z', close: 135.3 }, { date: '2007-08-27T07:00:00.000Z', close: 132.25 }, { date: '2007-08-28T07:00:00.000Z', close: 126.82 }, { date: '2007-08-29T07:00:00.000Z', close: 134.08 }, { date: '2007-08-30T07:00:00.000Z', close: 136.25 }, { date: '2007-08-31T07:00:00.000Z', close: 138.48 }, { date: '2007-09-04T07:00:00.000Z', close: 144.16 }, { date: '2007-09-05T07:00:00.000Z', close: 136.76 }, { date: '2007-09-06T07:00:00.000Z', close: 135.01 }, { date: '2007-09-07T07:00:00.000Z', close: 131.77 }, { date: '2007-09-10T07:00:00.000Z', close: 136.71 }, { date: '2007-09-11T07:00:00.000Z', close: 135.49 }, { date: '2007-09-12T07:00:00.000Z', close: 136.85 }, { date: '2007-09-13T07:00:00.000Z', close: 137.2 }, { date: '2007-09-14T07:00:00.000Z', close: 138.81 }, { date: '2007-09-17T07:00:00.000Z', close: 138.41 }, { date: '2007-09-18T07:00:00.000Z', close: 140.92 }, { date: '2007-09-19T07:00:00.000Z', close: 140.77 }, { date: '2007-09-20T07:00:00.000Z', close: 140.31 }, { date: '2007-09-21T07:00:00.000Z', close: 144.15 }, { date: '2007-09-24T07:00:00.000Z', close: 148.28 }, { date: '2007-09-25T07:00:00.000Z', close: 153.18 }, { date: '2007-09-26T07:00:00.000Z', close: 152.77 }, { date: '2007-09-27T07:00:00.000Z', close: 154.5 }, { date: '2007-09-28T07:00:00.000Z', close: 153.47 }, { date: '2007-10-01T07:00:00.000Z', close: 156.34 }, { date: '2007-10-02T07:00:00.000Z', close: 158.45 }, { date: '2007-10-03T07:00:00.000Z', close: 157.92 }, { date: '2007-10-04T07:00:00.000Z', close: 156.24 }, { date: '2007-10-05T07:00:00.000Z', close: 161.45 }, { date: '2007-10-08T07:00:00.000Z', close: 167.91 }, { date: '2007-10-09T07:00:00.000Z', close: 167.86 }, { date: '2007-10-10T07:00:00.000Z', close: 166.79 }, { date: '2007-10-11T07:00:00.000Z', close: 162.23 }, { date: '2007-10-12T07:00:00.000Z', close: 167.25 }, { date: '2007-10-15T07:00:00.000Z', close: 166.98 }, { date: '2007-10-16T07:00:00.000Z', close: 169.58 }, { date: '2007-10-17T07:00:00.000Z', close: 172.75 }, { date: '2007-10-18T07:00:00.000Z', close: 173.5 }, { date: '2007-10-19T07:00:00.000Z', close: 170.42 }, { date: '2007-10-22T07:00:00.000Z', close: 174.36 }, { date: '2007-10-23T07:00:00.000Z', close: 186.16 }, { date: '2007-10-24T07:00:00.000Z', close: 185.93 }, { date: '2007-10-25T07:00:00.000Z', close: 182.78 }, { date: '2007-10-26T07:00:00.000Z', close: 184.7 }, { date: '2007-10-29T07:00:00.000Z', close: 185.09 }, { date: '2007-10-30T07:00:00.000Z', close: 187 }, { date: '2007-10-31T07:00:00.000Z', close: 189.95 }, { date: '2007-11-01T07:00:00.000Z', close: 187.44 }, { date: '2007-11-02T07:00:00.000Z', close: 187.87 }, { date: '2007-11-05T08:00:00.000Z', close: 186.18 }, { date: '2007-11-06T08:00:00.000Z', close: 191.79 }, { date: '2007-11-07T08:00:00.000Z', close: 186.3 }, { date: '2007-11-08T08:00:00.000Z', close: 175.47 }, { date: '2007-11-09T08:00:00.000Z', close: 165.37 }, { date: '2007-11-12T08:00:00.000Z', close: 153.76 }, { date: '2007-11-13T08:00:00.000Z', close: 169.96 }, { date: '2007-11-14T08:00:00.000Z', close: 166.11 }, { date: '2007-11-15T08:00:00.000Z', close: 164.3 }, { date: '2007-11-16T08:00:00.000Z', close: 166.39 }, { date: '2007-11-19T08:00:00.000Z', close: 163.95 }, { date: '2007-11-20T08:00:00.000Z', close: 168.85 }, { date: '2007-11-21T08:00:00.000Z', close: 168.46 }, { date: '2007-11-23T08:00:00.000Z', close: 171.54 }, { date: '2007-11-26T08:00:00.000Z', close: 172.54 }, { date: '2007-11-27T08:00:00.000Z', close: 174.81 }, { date: '2007-11-28T08:00:00.000Z', close: 180.22 }, { date: '2007-11-29T08:00:00.000Z', close: 184.29 }, { date: '2007-11-30T08:00:00.000Z', close: 182.22 }, { date: '2007-12-03T08:00:00.000Z', close: 178.86 }, { date: '2007-12-04T08:00:00.000Z', close: 179.81 }, { date: '2007-12-05T08:00:00.000Z', close: 185.5 }, { date: '2007-12-06T08:00:00.000Z', close: 189.95 }, { date: '2007-12-07T08:00:00.000Z', close: 194.3 }, { date: '2007-12-10T08:00:00.000Z', close: 194.21 }, { date: '2007-12-11T08:00:00.000Z', close: 188.54 }, { date: '2007-12-12T08:00:00.000Z', close: 190.86 }, { date: '2007-12-13T08:00:00.000Z', close: 191.83 }, { date: '2007-12-14T08:00:00.000Z', close: 190.39 }, { date: '2007-12-17T08:00:00.000Z', close: 184.4 }, { date: '2007-12-18T08:00:00.000Z', close: 182.98 }, { date: '2007-12-19T08:00:00.000Z', close: 183.12 }, { date: '2007-12-20T08:00:00.000Z', close: 187.21 }, { date: '2007-12-21T08:00:00.000Z', close: 193.91 }, { date: '2007-12-24T08:00:00.000Z', close: 198.8 }, { date: '2007-12-26T08:00:00.000Z', close: 198.95 }, { date: '2007-12-27T08:00:00.000Z', close: 198.57 }, { date: '2007-12-28T08:00:00.000Z', close: 199.83 }, { date: '2007-12-31T08:00:00.000Z', close: 198.08 }, { date: '2008-01-02T08:00:00.000Z', close: 194.84 }, { date: '2008-01-03T08:00:00.000Z', close: 194.93 }, { date: '2008-01-04T08:00:00.000Z', close: 180.05 }, { date: '2008-01-07T08:00:00.000Z', close: 177.64 }, { date: '2008-01-08T08:00:00.000Z', close: 171.25 }, { date: '2008-01-09T08:00:00.000Z', close: 179.4 }, { date: '2008-01-10T08:00:00.000Z', close: 178.02 }, { date: '2008-01-11T08:00:00.000Z', close: 172.69 }, { date: '2008-01-14T08:00:00.000Z', close: 178.78 }, { date: '2008-01-15T08:00:00.000Z', close: 169.04 }, { date: '2008-01-16T08:00:00.000Z', close: 159.64 }, { date: '2008-01-17T08:00:00.000Z', close: 160.89 }, { date: '2008-01-18T08:00:00.000Z', close: 161.36 }, { date: '2008-01-22T08:00:00.000Z', close: 155.64 }, { date: '2008-01-23T08:00:00.000Z', close: 139.07 }, { date: '2008-01-24T08:00:00.000Z', close: 135.6 }, { date: '2008-01-25T08:00:00.000Z', close: 130.01 }, { date: '2008-01-28T08:00:00.000Z', close: 130.01 }, { date: '2008-01-29T08:00:00.000Z', close: 131.54 }, { date: '2008-01-30T08:00:00.000Z', close: 132.18 }, { date: '2008-01-31T08:00:00.000Z', close: 135.36 }, { date: '2008-02-01T08:00:00.000Z', close: 133.75 }, { date: '2008-02-04T08:00:00.000Z', close: 131.65 }, { date: '2008-02-05T08:00:00.000Z', close: 129.36 }, { date: '2008-02-06T08:00:00.000Z', close: 122 }, { date: '2008-02-07T08:00:00.000Z', close: 121.24 }, { date: '2008-02-08T08:00:00.000Z', close: 125.48 }, { date: '2008-02-11T08:00:00.000Z', close: 129.45 }, { date: '2008-02-12T08:00:00.000Z', close: 124.86 }, { date: '2008-02-13T08:00:00.000Z', close: 129.4 }, { date: '2008-02-14T08:00:00.000Z', close: 127.46 }, { date: '2008-02-15T08:00:00.000Z', close: 124.63 }, { date: '2008-02-19T08:00:00.000Z', close: 122.18 }, { date: '2008-02-20T08:00:00.000Z', close: 123.82 }, { date: '2008-02-21T08:00:00.000Z', close: 121.54 }, { date: '2008-02-22T08:00:00.000Z', close: 119.46 }, { date: '2008-02-25T08:00:00.000Z', close: 119.74 }, { date: '2008-02-26T08:00:00.000Z', close: 119.15 }, { date: '2008-02-27T08:00:00.000Z', close: 122.96 }, { date: '2008-02-28T08:00:00.000Z', close: 129.91 }, { date: '2008-02-29T08:00:00.000Z', close: 125.02 }, { date: '2008-03-03T08:00:00.000Z', close: 121.73 }, { date: '2008-03-04T08:00:00.000Z', close: 124.62 }, { date: '2008-03-05T08:00:00.000Z', close: 124.49 }, { date: '2008-03-06T08:00:00.000Z', close: 120.93 }, { date: '2008-03-07T08:00:00.000Z', close: 122.25 }, { date: '2008-03-10T07:00:00.000Z', close: 119.69 }, { date: '2008-03-11T07:00:00.000Z', close: 127.35 }, { date: '2008-03-12T07:00:00.000Z', close: 126.03 }, { date: '2008-03-13T07:00:00.000Z', close: 127.94 }, { date: '2008-03-14T07:00:00.000Z', close: 126.61 }, { date: '2008-03-17T07:00:00.000Z', close: 126.73 }, { date: '2008-03-18T07:00:00.000Z', close: 132.82 }, { date: '2008-03-19T07:00:00.000Z', close: 129.67 }, { date: '2008-03-20T07:00:00.000Z', close: 133.27 }, { date: '2008-03-24T07:00:00.000Z', close: 139.53 }, { date: '2008-03-25T07:00:00.000Z', close: 140.98 }, { date: '2008-03-26T07:00:00.000Z', close: 145.06 }, { date: '2008-03-27T07:00:00.000Z', close: 140.25 }, { date: '2008-03-28T07:00:00.000Z', close: 143.01 }, { date: '2008-03-31T07:00:00.000Z', close: 143.5 }, { date: '2008-04-01T07:00:00.000Z', close: 149.53 }, { date: '2008-04-02T07:00:00.000Z', close: 147.49 }, { date: '2008-04-03T07:00:00.000Z', close: 151.61 }, { date: '2008-04-04T07:00:00.000Z', close: 153.08 }, { date: '2008-04-07T07:00:00.000Z', close: 155.89 }, { date: '2008-04-08T07:00:00.000Z', close: 152.84 }, { date: '2008-04-09T07:00:00.000Z', close: 151.44 }, { date: '2008-04-10T07:00:00.000Z', close: 154.55 }, { date: '2008-04-11T07:00:00.000Z', close: 147.14 }, { date: '2008-04-14T07:00:00.000Z', close: 147.78 }, { date: '2008-04-15T07:00:00.000Z', close: 148.38 }, { date: '2008-04-16T07:00:00.000Z', close: 153.7 }, { date: '2008-04-17T07:00:00.000Z', close: 154.49 }, { date: '2008-04-18T07:00:00.000Z', close: 161.04 }, { date: '2008-04-21T07:00:00.000Z', close: 168.16 }, { date: '2008-04-22T07:00:00.000Z', close: 160.2 }, { date: '2008-04-23T07:00:00.000Z', close: 162.89 }, { date: '2008-04-24T07:00:00.000Z', close: 168.94 }, { date: '2008-04-25T07:00:00.000Z', close: 169.73 }, { date: '2008-04-28T07:00:00.000Z', close: 172.24 }, { date: '2008-04-29T07:00:00.000Z', close: 175.05 }, { date: '2008-04-30T07:00:00.000Z', close: 173.95 }, { date: '2008-05-01T07:00:00.000Z', close: 180 }, { date: '2008-05-02T07:00:00.000Z', close: 180.94 }, { date: '2008-05-05T07:00:00.000Z', close: 184.73 }, { date: '2008-05-06T07:00:00.000Z', close: 186.66 }, { date: '2008-05-07T07:00:00.000Z', close: 182.59 }, { date: '2008-05-08T07:00:00.000Z', close: 185.06 }, { date: '2008-05-09T07:00:00.000Z', close: 183.45 }, { date: '2008-05-12T07:00:00.000Z', close: 188.16 }, { date: '2008-05-13T07:00:00.000Z', close: 189.96 }, { date: '2008-05-14T07:00:00.000Z', close: 186.26 }, { date: '2008-05-15T07:00:00.000Z', close: 189.73 }, { date: '2008-05-16T07:00:00.000Z', close: 187.62 }, { date: '2008-05-19T07:00:00.000Z', close: 183.6 }, { date: '2008-05-20T07:00:00.000Z', close: 185.9 }, { date: '2008-05-21T07:00:00.000Z', close: 178.19 }, { date: '2008-05-22T07:00:00.000Z', close: 177.05 }, { date: '2008-05-23T07:00:00.000Z', close: 181.17 }, { date: '2008-05-27T07:00:00.000Z', close: 186.43 }, { date: '2008-05-28T07:00:00.000Z', close: 187.01 }, { date: '2008-05-29T07:00:00.000Z', close: 186.69 }, { date: '2008-05-30T07:00:00.000Z', close: 188.75 }, { date: '2008-06-02T07:00:00.000Z', close: 186.1 }, { date: '2008-06-03T07:00:00.000Z', close: 185.37 }, { date: '2008-06-04T07:00:00.000Z', close: 185.19 }, { date: '2008-06-05T07:00:00.000Z', close: 189.43 }, { date: '2008-06-06T07:00:00.000Z', close: 185.64 }, { date: '2008-06-09T07:00:00.000Z', close: 181.61 }, { date: '2008-06-10T07:00:00.000Z', close: 185.64 }, { date: '2008-06-11T07:00:00.000Z', close: 180.81 }, { date: '2008-06-12T07:00:00.000Z', close: 173.26 }, { date: '2008-06-13T07:00:00.000Z', close: 172.37 }, { date: '2008-06-16T07:00:00.000Z', close: 176.84 }, { date: '2008-06-17T07:00:00.000Z', close: 181.43 }, { date: '2008-06-18T07:00:00.000Z', close: 178.75 }, { date: '2008-06-19T07:00:00.000Z', close: 180.9 }, { date: '2008-06-20T07:00:00.000Z', close: 175.27 }, { date: '2008-06-23T07:00:00.000Z', close: 173.16 }, { date: '2008-06-24T07:00:00.000Z', close: 173.25 }, { date: '2008-06-25T07:00:00.000Z', close: 177.39 }, { date: '2008-06-26T07:00:00.000Z', close: 168.26 }, { date: '2008-06-27T07:00:00.000Z', close: 170.09 }, { date: '2008-06-30T07:00:00.000Z', close: 167.44 }, { date: '2008-07-01T07:00:00.000Z', close: 174.68 }, { date: '2008-07-02T07:00:00.000Z', close: 168.18 }, { date: '2008-07-03T07:00:00.000Z', close: 170.12 }, { date: '2008-07-07T07:00:00.000Z', close: 175.16 }, { date: '2008-07-08T07:00:00.000Z', close: 179.55 }, { date: '2008-07-09T07:00:00.000Z', close: 174.25 }, { date: '2008-07-10T07:00:00.000Z', close: 176.63 }, { date: '2008-07-11T07:00:00.000Z', close: 172.58 }, { date: '2008-07-14T07:00:00.000Z', close: 173.88 }, { date: '2008-07-15T07:00:00.000Z', close: 169.64 }, { date: '2008-07-16T07:00:00.000Z', close: 172.81 }, { date: '2008-07-17T07:00:00.000Z', close: 171.81 }, { date: '2008-07-18T07:00:00.000Z', close: 165.15 }, { date: '2008-07-21T07:00:00.000Z', close: 166.29 }, { date: '2008-07-22T07:00:00.000Z', close: 162.02 }, { date: '2008-07-23T07:00:00.000Z', close: 166.26 }, { date: '2008-07-24T07:00:00.000Z', close: 159.03 }, { date: '2008-07-25T07:00:00.000Z', close: 162.12 }, { date: '2008-07-28T07:00:00.000Z', close: 154.4 }, { date: '2008-07-29T07:00:00.000Z', close: 157.08 }, { date: '2008-07-30T07:00:00.000Z', close: 159.88 }, { date: '2008-07-31T07:00:00.000Z', close: 158.95 }, { date: '2008-08-01T07:00:00.000Z', close: 156.66 }, { date: '2008-08-04T07:00:00.000Z', close: 153.23 }, { date: '2008-08-05T07:00:00.000Z', close: 160.64 }, { date: '2008-08-06T07:00:00.000Z', close: 164.19 }, { date: '2008-08-07T07:00:00.000Z', close: 163.57 }, { date: '2008-08-08T07:00:00.000Z', close: 169.55 }, { date: '2008-08-11T07:00:00.000Z', close: 173.56 }, { date: '2008-08-12T07:00:00.000Z', close: 176.73 }, { date: '2008-08-13T07:00:00.000Z', close: 179.3 }, { date: '2008-08-14T07:00:00.000Z', close: 179.32 }, { date: '2008-08-15T07:00:00.000Z', close: 175.74 }, { date: '2008-08-18T07:00:00.000Z', close: 175.39 }, { date: '2008-08-19T07:00:00.000Z', close: 173.53 }, { date: '2008-08-20T07:00:00.000Z', close: 175.84 }, { date: '2008-08-21T07:00:00.000Z', close: 174.29 }, { date: '2008-08-22T07:00:00.000Z', close: 176.79 }, { date: '2008-08-25T07:00:00.000Z', close: 172.55 }, { date: '2008-08-26T07:00:00.000Z', close: 173.64 }, { date: '2008-08-27T07:00:00.000Z', close: 174.67 }, { date: '2008-08-28T07:00:00.000Z', close: 173.74 }, { date: '2008-08-29T07:00:00.000Z', close: 169.53 }, { date: '2008-09-02T07:00:00.000Z', close: 166.19 }, { date: '2008-09-03T07:00:00.000Z', close: 166.96 }, { date: '2008-09-04T07:00:00.000Z', close: 161.22 }, { date: '2008-09-05T07:00:00.000Z', close: 160.18 }, { date: '2008-09-08T07:00:00.000Z', close: 157.92 }, { date: '2008-09-09T07:00:00.000Z', close: 151.68 }, { date: '2008-09-10T07:00:00.000Z', close: 151.61 }, { date: '2008-09-11T07:00:00.000Z', close: 152.65 }, { date: '2008-09-12T07:00:00.000Z', close: 148.94 }, { date: '2008-09-15T07:00:00.000Z', close: 140.36 }, { date: '2008-09-16T07:00:00.000Z', close: 139.88 }, { date: '2008-09-17T07:00:00.000Z', close: 127.83 }, { date: '2008-09-18T07:00:00.000Z', close: 134.09 }, { date: '2008-09-19T07:00:00.000Z', close: 140.91 }, { date: '2008-09-22T07:00:00.000Z', close: 131.05 }, { date: '2008-09-23T07:00:00.000Z', close: 126.84 }, { date: '2008-09-24T07:00:00.000Z', close: 128.71 }, { date: '2008-09-25T07:00:00.000Z', close: 131.93 }, { date: '2008-09-26T07:00:00.000Z', close: 128.24 }, { date: '2008-09-29T07:00:00.000Z', close: 105.26 }, { date: '2008-09-30T07:00:00.000Z', close: 113.66 }, { date: '2008-10-01T07:00:00.000Z', close: 109.12 }, { date: '2008-10-02T07:00:00.000Z', close: 100.1 }, { date: '2008-10-03T07:00:00.000Z', close: 97.07 }, { date: '2008-10-06T07:00:00.000Z', close: 98.14 }, { date: '2008-10-07T07:00:00.000Z', close: 89.16 }, { date: '2008-10-08T07:00:00.000Z', close: 89.79 }, { date: '2008-10-09T07:00:00.000Z', close: 88.74 }, { date: '2008-10-10T07:00:00.000Z', close: 96.8 }, { date: '2008-10-13T07:00:00.000Z', close: 110.26 }, { date: '2008-10-14T07:00:00.000Z', close: 104.08 }, { date: '2008-10-15T07:00:00.000Z', close: 97.95 }, { date: '2008-10-16T07:00:00.000Z', close: 101.89 }, { date: '2008-10-17T07:00:00.000Z', close: 97.4 }, { date: '2008-10-20T07:00:00.000Z', close: 98.44 }, { date: '2008-10-21T07:00:00.000Z', close: 91.49 }, { date: '2008-10-22T07:00:00.000Z', close: 96.87 }, { date: '2008-10-23T07:00:00.000Z', close: 98.23 }, { date: '2008-10-24T07:00:00.000Z', close: 96.38 }, { date: '2008-10-27T07:00:00.000Z', close: 92.09 }, { date: '2008-10-28T07:00:00.000Z', close: 99.91 }, { date: '2008-10-29T07:00:00.000Z', close: 104.55 }, { date: '2008-10-30T07:00:00.000Z', close: 111.04 }, { date: '2008-10-31T07:00:00.000Z', close: 107.59 }, { date: '2008-11-03T08:00:00.000Z', close: 106.96 }, { date: '2008-11-04T08:00:00.000Z', close: 110.99 }, { date: '2008-11-05T08:00:00.000Z', close: 103.3 }, { date: '2008-11-06T08:00:00.000Z', close: 99.1 }, { date: '2008-11-07T08:00:00.000Z', close: 98.24 }, { date: '2008-11-10T08:00:00.000Z', close: 95.88 }, { date: '2008-11-11T08:00:00.000Z', close: 94.77 }, { date: '2008-11-12T08:00:00.000Z', close: 90.12 }, { date: '2008-11-13T08:00:00.000Z', close: 96.44 }, { date: '2008-11-14T08:00:00.000Z', close: 90.24 }, { date: '2008-11-17T08:00:00.000Z', close: 88.14 }, { date: '2008-11-18T08:00:00.000Z', close: 89.91 }, { date: '2008-11-19T08:00:00.000Z', close: 86.29 }, { date: '2008-11-20T08:00:00.000Z', close: 80.49 }, { date: '2008-11-21T08:00:00.000Z', close: 82.58 }, { date: '2008-11-24T08:00:00.000Z', close: 92.95 }, { date: '2008-11-25T08:00:00.000Z', close: 90.8 }, { date: '2008-11-26T08:00:00.000Z', close: 95 }, { date: '2008-11-27T08:00:00.000Z', close: 95 }, { date: '2008-11-28T08:00:00.000Z', close: 92.67 }, { date: '2008-12-01T08:00:00.000Z', close: 88.93 }, { date: '2008-12-02T08:00:00.000Z', close: 92.47 }, { date: '2008-12-03T08:00:00.000Z', close: 95.9 }, { date: '2008-12-04T08:00:00.000Z', close: 91.41 }, { date: '2008-12-05T08:00:00.000Z', close: 94 }, { date: '2008-12-08T08:00:00.000Z', close: 99.72 }, { date: '2008-12-09T08:00:00.000Z', close: 100.06 }, { date: '2008-12-10T08:00:00.000Z', close: 98.21 }, { date: '2008-12-11T08:00:00.000Z', close: 95 }, { date: '2008-12-12T08:00:00.000Z', close: 98.27 }, { date: '2008-12-15T08:00:00.000Z', close: 94.75 }, { date: '2008-12-16T08:00:00.000Z', close: 95.43 }, { date: '2008-12-17T08:00:00.000Z', close: 89.16 }, { date: '2008-12-18T08:00:00.000Z', close: 89.43 }, { date: '2008-12-19T08:00:00.000Z', close: 90 }, { date: '2008-12-22T08:00:00.000Z', close: 85.74 }, { date: '2008-12-23T08:00:00.000Z', close: 86.38 }, { date: '2008-12-24T08:00:00.000Z', close: 85.04 }, { date: '2008-12-25T08:00:00.000Z', close: 85.04 }, { date: '2008-12-26T08:00:00.000Z', close: 85.81 }, { date: '2008-12-29T08:00:00.000Z', close: 86.61 }, { date: '2008-12-30T08:00:00.000Z', close: 86.29 }, { date: '2008-12-31T08:00:00.000Z', close: 85.35 }, { date: '2009-01-01T08:00:00.000Z', close: 85.35 }, { date: '2009-01-02T08:00:00.000Z', close: 90.75 }, { date: '2009-01-05T08:00:00.000Z', close: 94.58 }, { date: '2009-01-06T08:00:00.000Z', close: 93.02 }, { date: '2009-01-07T08:00:00.000Z', close: 91.01 }, { date: '2009-01-08T08:00:00.000Z', close: 92.7 }, { date: '2009-01-09T08:00:00.000Z', close: 90.58 }, { date: '2009-01-12T08:00:00.000Z', close: 88.66 }, { date: '2009-01-13T08:00:00.000Z', close: 87.71 }, { date: '2009-01-14T08:00:00.000Z', close: 85.33 }, { date: '2009-01-15T08:00:00.000Z', close: 83.38 }, { date: '2009-01-16T08:00:00.000Z', close: 82.33 }, { date: '2009-01-20T08:00:00.000Z', close: 78.2 }, { date: '2009-01-21T08:00:00.000Z', close: 82.83 }, { date: '2009-01-22T08:00:00.000Z', close: 88.36 }, { date: '2009-01-23T08:00:00.000Z', close: 88.36 }, { date: '2009-01-26T08:00:00.000Z', close: 89.64 }, { date: '2009-01-27T08:00:00.000Z', close: 90.73 }, { date: '2009-01-28T08:00:00.000Z', close: 94.2 }, { date: '2009-01-29T08:00:00.000Z', close: 93 }, { date: '2009-01-30T08:00:00.000Z', close: 90.13 }, { date: '2009-02-02T08:00:00.000Z', close: 91.51 }, { date: '2009-02-03T08:00:00.000Z', close: 92.98 }, { date: '2009-02-04T08:00:00.000Z', close: 93.55 }, { date: '2009-02-05T08:00:00.000Z', close: 96.46 }, { date: '2009-02-06T08:00:00.000Z', close: 99.72 }, { date: '2009-02-09T08:00:00.000Z', close: 102.51 }, { date: '2009-02-10T08:00:00.000Z', close: 97.83 }, { date: '2009-02-11T08:00:00.000Z', close: 96.82 }, { date: '2009-02-12T08:00:00.000Z', close: 99.27 }, { date: '2009-02-13T08:00:00.000Z', close: 99.16 }, { date: '2009-02-17T08:00:00.000Z', close: 94.53 }, { date: '2009-02-18T08:00:00.000Z', close: 94.37 }, { date: '2009-02-19T08:00:00.000Z', close: 90.64 }, { date: '2009-02-20T08:00:00.000Z', close: 91.2 }, { date: '2009-02-23T08:00:00.000Z', close: 86.95 }, { date: '2009-02-24T08:00:00.000Z', close: 90.25 }, { date: '2009-02-25T08:00:00.000Z', close: 91.16 }, { date: '2009-02-26T08:00:00.000Z', close: 89.19 }, { date: '2009-02-27T08:00:00.000Z', close: 89.31 }, { date: '2009-03-02T08:00:00.000Z', close: 87.94 }, { date: '2009-03-03T08:00:00.000Z', close: 88.37 }, { date: '2009-03-04T08:00:00.000Z', close: 91.17 }, { date: '2009-03-05T08:00:00.000Z', close: 88.84 }, { date: '2009-03-06T08:00:00.000Z', close: 85.3 }, { date: '2009-03-09T07:00:00.000Z', close: 83.11 }, { date: '2009-03-10T07:00:00.000Z', close: 88.63 }, { date: '2009-03-11T07:00:00.000Z', close: 92.68 }, { date: '2009-03-12T07:00:00.000Z', close: 96.35 }, { date: '2009-03-13T07:00:00.000Z', close: 95.93 }, { date: '2009-03-16T07:00:00.000Z', close: 95.42 }, { date: '2009-03-17T07:00:00.000Z', close: 99.66 }, { date: '2009-03-18T07:00:00.000Z', close: 101.52 }, { date: '2009-03-19T07:00:00.000Z', close: 101.62 }, { date: '2009-03-20T07:00:00.000Z', close: 101.59 }, { date: '2009-03-23T07:00:00.000Z', close: 107.66 }, { date: '2009-03-24T07:00:00.000Z', close: 106.5 }, { date: '2009-03-25T07:00:00.000Z', close: 106.49 }, { date: '2009-03-26T07:00:00.000Z', close: 109.87 }, { date: '2009-03-27T07:00:00.000Z', close: 106.85 }, { date: '2009-03-30T07:00:00.000Z', close: 104.49 }, { date: '2009-03-31T07:00:00.000Z', close: 105.12 }, { date: '2009-04-01T07:00:00.000Z', close: 108.69 }, { date: '2009-04-02T07:00:00.000Z', close: 112.71 }, { date: '2009-04-03T07:00:00.000Z', close: 115.99 }, { date: '2009-04-06T07:00:00.000Z', close: 118.45 }, { date: '2009-04-07T07:00:00.000Z', close: 115 }, { date: '2009-04-08T07:00:00.000Z', close: 116.32 }, { date: '2009-04-09T07:00:00.000Z', close: 119.57 }, { date: '2009-04-10T07:00:00.000Z', close: 119.57 }, { date: '2009-04-13T07:00:00.000Z', close: 120.22 }, { date: '2009-04-14T07:00:00.000Z', close: 118.31 }, { date: '2009-04-15T07:00:00.000Z', close: 117.64 }, { date: '2009-04-16T07:00:00.000Z', close: 121.45 }, { date: '2009-04-17T07:00:00.000Z', close: 123.42 }, { date: '2009-04-20T07:00:00.000Z', close: 120.5 }, { date: '2009-04-21T07:00:00.000Z', close: 121.76 }, { date: '2009-04-22T07:00:00.000Z', close: 121.51 }, { date: '2009-04-23T07:00:00.000Z', close: 125.4 }, { date: '2009-04-24T07:00:00.000Z', close: 123.9 }, { date: '2009-04-27T07:00:00.000Z', close: 124.73 }, { date: '2009-04-28T07:00:00.000Z', close: 123.9 }, { date: '2009-04-29T07:00:00.000Z', close: 125.14 }, { date: '2009-04-30T07:00:00.000Z', close: 125.83 }, { date: '2009-05-01T07:00:00.000Z', close: 127.24 }, { date: '2009-05-04T07:00:00.000Z', close: 132.07 }, { date: '2009-05-05T07:00:00.000Z', close: 132.71 }, { date: '2009-05-06T07:00:00.000Z', close: 132.5 }, { date: '2009-05-07T07:00:00.000Z', close: 129.06 }, { date: '2009-05-08T07:00:00.000Z', close: 129.19 }, { date: '2009-05-11T07:00:00.000Z', close: 129.57 }, { date: '2009-05-12T07:00:00.000Z', close: 124.42 }, { date: '2009-05-13T07:00:00.000Z', close: 119.49 }, { date: '2009-05-14T07:00:00.000Z', close: 122.95 }, { date: '2009-05-15T07:00:00.000Z', close: 122.42 }, { date: '2009-05-18T07:00:00.000Z', close: 126.65 }, { date: '2009-05-19T07:00:00.000Z', close: 127.45 }, { date: '2009-05-20T07:00:00.000Z', close: 125.87 }, { date: '2009-05-21T07:00:00.000Z', close: 124.18 }, { date: '2009-05-22T07:00:00.000Z', close: 122.5 }, { date: '2009-05-26T07:00:00.000Z', close: 130.78 }, { date: '2009-05-27T07:00:00.000Z', close: 133.05 }, { date: '2009-05-28T07:00:00.000Z', close: 135.07 }, { date: '2009-05-29T07:00:00.000Z', close: 135.81 }, { date: '2009-06-01T07:00:00.000Z', close: 139.35 }, { date: '2009-06-02T07:00:00.000Z', close: 139.49 }, { date: '2009-06-03T07:00:00.000Z', close: 140.95 }, { date: '2009-06-04T07:00:00.000Z', close: 143.74 }, { date: '2009-06-05T07:00:00.000Z', close: 144.67 }, { date: '2009-06-08T07:00:00.000Z', close: 143.85 }, { date: '2009-06-09T07:00:00.000Z', close: 142.72 }, { date: '2009-06-10T07:00:00.000Z', close: 140.25 }, { date: '2009-06-11T07:00:00.000Z', close: 139.95 }, { date: '2009-06-12T07:00:00.000Z', close: 136.97 }, { date: '2009-06-15T07:00:00.000Z', close: 136.09 }, { date: '2009-06-16T07:00:00.000Z', close: 136.35 }, { date: '2009-06-17T07:00:00.000Z', close: 135.58 }, { date: '2009-06-18T07:00:00.000Z', close: 135.88 }, { date: '2009-06-19T07:00:00.000Z', close: 139.48 }, { date: '2009-06-22T07:00:00.000Z', close: 137.37 }, { date: '2009-06-23T07:00:00.000Z', close: 134.01 }, { date: '2009-06-24T07:00:00.000Z', close: 136.22 }, { date: '2009-06-25T07:00:00.000Z', close: 139.86 }, { date: '2009-06-26T07:00:00.000Z', close: 142.44 }, { date: '2009-06-29T07:00:00.000Z', close: 141.97 }, { date: '2009-06-30T07:00:00.000Z', close: 142.43 }, { date: '2009-07-01T07:00:00.000Z', close: 142.83 }, { date: '2009-07-02T07:00:00.000Z', close: 140.02 }, { date: '2009-07-03T07:00:00.000Z', close: 140.02 }, { date: '2009-07-06T07:00:00.000Z', close: 138.61 }, { date: '2009-07-07T07:00:00.000Z', close: 135.4 }, { date: '2009-07-08T07:00:00.000Z', close: 137.22 }, { date: '2009-07-09T07:00:00.000Z', close: 136.36 }, { date: '2009-07-10T07:00:00.000Z', close: 138.52 }, { date: '2009-07-13T07:00:00.000Z', close: 142.34 }, { date: '2009-07-14T07:00:00.000Z', close: 142.27 }, { date: '2009-07-15T07:00:00.000Z', close: 146.88 }, { date: '2009-07-16T07:00:00.000Z', close: 147.52 }, { date: '2009-07-17T07:00:00.000Z', close: 151.75 }, { date: '2009-07-20T07:00:00.000Z', close: 152.91 }, { date: '2009-07-21T07:00:00.000Z', close: 151.51 }, { date: '2009-07-22T07:00:00.000Z', close: 156.74 }, { date: '2009-07-23T07:00:00.000Z', close: 157.82 }, { date: '2009-07-24T07:00:00.000Z', close: 159.99 }, { date: '2009-07-27T07:00:00.000Z', close: 160.1 }, { date: '2009-07-28T07:00:00.000Z', close: 160 }, { date: '2009-07-29T07:00:00.000Z', close: 160.03 }, { date: '2009-07-30T07:00:00.000Z', close: 162.79 }, { date: '2009-07-31T07:00:00.000Z', close: 163.39 }, { date: '2009-08-03T07:00:00.000Z', close: 166.43 }, { date: '2009-08-04T07:00:00.000Z', close: 165.55 }, { date: '2009-08-05T07:00:00.000Z', close: 165.11 }, { date: '2009-08-06T07:00:00.000Z', close: 163.91 }, { date: '2009-08-07T07:00:00.000Z', close: 165.51 }, { date: '2009-08-10T07:00:00.000Z', close: 164.72 }, { date: '2009-08-12T07:00:00.000Z', close: 165.31 }, { date: '2009-08-13T07:00:00.000Z', close: 168.42 }, { date: '2009-08-14T07:00:00.000Z', close: 166.78 }, { date: '2009-08-17T07:00:00.000Z', close: 159.59 }, { date: '2009-08-18T07:00:00.000Z', close: 164 }, { date: '2009-08-19T07:00:00.000Z', close: 164.6 }, { date: '2009-08-20T07:00:00.000Z', close: 166.33 }, { date: '2009-08-21T07:00:00.000Z', close: 169.22 }, { date: '2009-08-24T07:00:00.000Z', close: 169.06 }, { date: '2009-08-25T07:00:00.000Z', close: 169.4 }, { date: '2009-08-26T07:00:00.000Z', close: 167.41 }, { date: '2009-08-27T07:00:00.000Z', close: 169.45 }, { date: '2009-08-28T07:00:00.000Z', close: 170.05 }, { date: '2009-08-31T07:00:00.000Z', close: 168.21 }, { date: '2009-09-01T07:00:00.000Z', close: 165.3 }, { date: '2009-09-02T07:00:00.000Z', close: 165.18 }, { date: '2009-09-03T07:00:00.000Z', close: 166.55 }, { date: '2009-09-04T07:00:00.000Z', close: 170.31 }, { date: '2009-09-08T07:00:00.000Z', close: 172.93 }, { date: '2009-09-09T07:00:00.000Z', close: 171.14 }, { date: '2009-09-10T07:00:00.000Z', close: 172.56 }, { date: '2009-09-11T07:00:00.000Z', close: 172.16 }, { date: '2009-09-14T07:00:00.000Z', close: 173.72 }, { date: '2009-09-15T07:00:00.000Z', close: 175.16 }, { date: '2009-09-16T07:00:00.000Z', close: 181.87 }, { date: '2009-09-17T07:00:00.000Z', close: 184.55 }, { date: '2009-09-18T07:00:00.000Z', close: 185.02 }, { date: '2009-09-21T07:00:00.000Z', close: 184.02 }, { date: '2009-09-22T07:00:00.000Z', close: 184.48 }, { date: '2009-09-23T07:00:00.000Z', close: 185.5 }, { date: '2009-09-24T07:00:00.000Z', close: 183.82 }, { date: '2009-09-25T07:00:00.000Z', close: 182.37 }, { date: '2009-09-28T07:00:00.000Z', close: 186.15 }, { date: '2009-09-29T07:00:00.000Z', close: 185.38 }, { date: '2009-09-30T07:00:00.000Z', close: 185.35 }, { date: '2009-10-01T07:00:00.000Z', close: 180.86 }, { date: '2009-10-02T07:00:00.000Z', close: 184.9 }, { date: '2009-10-05T07:00:00.000Z', close: 186.02 }, { date: '2009-10-06T07:00:00.000Z', close: 190.01 }, { date: '2009-10-07T07:00:00.000Z', close: 190.25 }, { date: '2009-10-08T07:00:00.000Z', close: 189.27 }, { date: '2009-10-09T07:00:00.000Z', close: 190.47 }, { date: '2009-10-12T07:00:00.000Z', close: 190.81 }, { date: '2009-10-13T07:00:00.000Z', close: 190.02 }, { date: '2009-10-14T07:00:00.000Z', close: 191.29 }, { date: '2009-10-15T07:00:00.000Z', close: 190.56 }, { date: '2009-10-16T07:00:00.000Z', close: 188.05 }, { date: '2009-10-19T07:00:00.000Z', close: 189.86 }, { date: '2009-10-20T07:00:00.000Z', close: 198.76 }, { date: '2009-10-21T07:00:00.000Z', close: 204.92 }, { date: '2009-10-22T07:00:00.000Z', close: 205.2 }, { date: '2009-10-23T07:00:00.000Z', close: 203.94 }, { date: '2009-10-26T07:00:00.000Z', close: 202.48 }, { date: '2009-10-27T07:00:00.000Z', close: 197.37 }, { date: '2009-10-28T07:00:00.000Z', close: 192.4 }, { date: '2009-10-29T07:00:00.000Z', close: 196.35 }, { date: '2009-10-30T07:00:00.000Z', close: 188.5 }, { date: '2009-11-02T08:00:00.000Z', close: 189.31 }, { date: '2009-11-03T08:00:00.000Z', close: 188.75 }, { date: '2009-11-04T08:00:00.000Z', close: 190.81 }, { date: '2009-11-05T08:00:00.000Z', close: 194.03 }, { date: '2009-11-06T08:00:00.000Z', close: 194.34 }, { date: '2009-11-09T08:00:00.000Z', close: 201.46 }, { date: '2009-11-10T08:00:00.000Z', close: 202.98 }, { date: '2009-11-11T08:00:00.000Z', close: 203.25 }, { date: '2009-11-12T08:00:00.000Z', close: 201.99 }, { date: '2009-11-13T08:00:00.000Z', close: 204.45 }, { date: '2009-11-16T08:00:00.000Z', close: 206.63 }, { date: '2009-11-17T08:00:00.000Z', close: 207 }, { date: '2009-11-18T08:00:00.000Z', close: 205.96 }, { date: '2009-11-19T08:00:00.000Z', close: 200.51 }, { date: '2009-11-20T08:00:00.000Z', close: 199.92 }, { date: '2009-11-23T08:00:00.000Z', close: 205.88 }, { date: '2009-11-24T08:00:00.000Z', close: 204.44 }, { date: '2009-11-25T08:00:00.000Z', close: 204.19 }, { date: '2009-11-26T08:00:00.000Z', close: 204.19 }, { date: '2009-11-27T08:00:00.000Z', close: 200.59 }, { date: '2009-11-30T08:00:00.000Z', close: 199.91 }, { date: '2009-12-01T08:00:00.000Z', close: 196.97 }, { date: '2009-12-02T08:00:00.000Z', close: 196.23 }, { date: '2009-12-03T08:00:00.000Z', close: 196.48 }, { date: '2009-12-04T08:00:00.000Z', close: 193.32 }, { date: '2009-12-07T08:00:00.000Z', close: 188.95 }, { date: '2009-12-08T08:00:00.000Z', close: 189.87 }, { date: '2009-12-09T08:00:00.000Z', close: 197.8 }, { date: '2009-12-10T08:00:00.000Z', close: 196.43 }, { date: '2009-12-11T08:00:00.000Z', close: 194.67 }, { date: '2009-12-14T08:00:00.000Z', close: 196.98 }, { date: '2009-12-15T08:00:00.000Z', close: 194.17 }, { date: '2009-12-16T08:00:00.000Z', close: 195.03 }, { date: '2009-12-17T08:00:00.000Z', close: 191.86 }, { date: '2009-12-18T08:00:00.000Z', close: 195.43 }, { date: '2009-12-21T08:00:00.000Z', close: 198.23 }, { date: '2009-12-22T08:00:00.000Z', close: 200.36 }, { date: '2009-12-23T08:00:00.000Z', close: 202.1 }, { date: '2009-12-24T08:00:00.000Z', close: 209.04 }, { date: '2009-12-25T08:00:00.000Z', close: 209.04 }, { date: '2009-12-28T08:00:00.000Z', close: 211.61 }, { date: '2009-12-29T08:00:00.000Z', close: 209.1 }, { date: '2009-12-30T08:00:00.000Z', close: 211.64 }, { date: '2009-12-31T08:00:00.000Z', close: 210.73 }, { date: '2010-01-01T08:00:00.000Z', close: 210.73 }, { date: '2010-01-04T08:00:00.000Z', close: 214.01 }, { date: '2010-01-05T08:00:00.000Z', close: 214.38 }, { date: '2010-01-06T08:00:00.000Z', close: 210.97 }, { date: '2010-01-07T08:00:00.000Z', close: 210.58 }, { date: '2010-01-08T08:00:00.000Z', close: 211.98 }, { date: '2010-01-11T08:00:00.000Z', close: 210.11 }, { date: '2010-01-12T08:00:00.000Z', close: 207.72 }, { date: '2010-01-13T08:00:00.000Z', close: 210.65 }, { date: '2010-01-14T08:00:00.000Z', close: 209.43 }, { date: '2010-01-15T08:00:00.000Z', close: 205.93 }, { date: '2010-01-18T08:00:00.000Z', close: 205.93 }, { date: '2010-01-19T08:00:00.000Z', close: 215.04 }, { date: '2010-01-20T08:00:00.000Z', close: 211.72 }, { date: '2010-01-21T08:00:00.000Z', close: 208.07 }, { date: '2010-01-22T08:00:00.000Z', close: 197.75 }, { date: '2010-01-25T08:00:00.000Z', close: 203.08 }, { date: '2010-01-26T08:00:00.000Z', close: 205.94 }, { date: '2010-01-27T08:00:00.000Z', close: 207.88 }, { date: '2010-01-28T08:00:00.000Z', close: 199.29 }, { date: '2010-01-29T08:00:00.000Z', close: 192.06 }, { date: '2010-02-01T08:00:00.000Z', close: 194.73 }, { date: '2010-02-02T08:00:00.000Z', close: 195.86 }, { date: '2010-02-03T08:00:00.000Z', close: 199.23 }, { date: '2010-02-04T08:00:00.000Z', close: 192.05 }, { date: '2010-02-05T08:00:00.000Z', close: 195.46 }, { date: '2010-02-08T08:00:00.000Z', close: 194.12 }, { date: '2010-02-09T08:00:00.000Z', close: 196.19 }, { date: '2010-02-10T08:00:00.000Z', close: 195.12 }, { date: '2010-02-11T08:00:00.000Z', close: 198.67 }, { date: '2010-02-12T08:00:00.000Z', close: 200.38 }, { date: '2010-02-15T08:00:00.000Z', close: 200.38 }, { date: '2010-02-16T08:00:00.000Z', close: 203.4 }, { date: '2010-02-17T08:00:00.000Z', close: 202.55 }, { date: '2010-02-18T08:00:00.000Z', close: 202.93 }, { date: '2010-02-19T08:00:00.000Z', close: 201.67 }, { date: '2010-02-22T08:00:00.000Z', close: 200.42 }, { date: '2010-02-23T08:00:00.000Z', close: 197.06 }, { date: '2010-02-24T08:00:00.000Z', close: 200.66 }, { date: '2010-02-25T08:00:00.000Z', close: 202 }, { date: '2010-02-26T08:00:00.000Z', close: 204.62 }, { date: '2010-03-01T08:00:00.000Z', close: 208.99 }, { date: '2010-03-02T08:00:00.000Z', close: 208.85 }, { date: '2010-03-03T08:00:00.000Z', close: 209.33 }, { date: '2010-03-04T08:00:00.000Z', close: 210.71 }, { date: '2010-03-05T08:00:00.000Z', close: 218.95 }, { date: '2010-03-08T08:00:00.000Z', close: 219.08 }, { date: '2010-03-09T08:00:00.000Z', close: 223.02 }, { date: '2010-03-10T08:00:00.000Z', close: 224.84 }, { date: '2010-03-11T08:00:00.000Z', close: 225.5 }, { date: '2010-03-12T08:00:00.000Z', close: 226.6 }, { date: '2010-03-15T07:00:00.000Z', close: 223.84 }, { date: '2010-03-16T07:00:00.000Z', close: 224.45 }, { date: '2010-03-17T07:00:00.000Z', close: 224.12 }, { date: '2010-03-18T07:00:00.000Z', close: 224.65 }, { date: '2010-03-19T07:00:00.000Z', close: 222.25 }, { date: '2010-03-22T07:00:00.000Z', close: 224.75 }, { date: '2010-03-23T07:00:00.000Z', close: 228.36 }, { date: '2010-03-24T07:00:00.000Z', close: 229.37 }, { date: '2010-03-25T07:00:00.000Z', close: 226.65 }, { date: '2010-03-26T07:00:00.000Z', close: 230.9 }, { date: '2010-03-29T07:00:00.000Z', close: 232.39 }, { date: '2010-03-30T07:00:00.000Z', close: 235.84 }, { date: '2010-03-31T07:00:00.000Z', close: 235 }, { date: '2010-04-01T07:00:00.000Z', close: 235.97 }, { date: '2010-04-02T07:00:00.000Z', close: 235.97 }, { date: '2010-04-05T07:00:00.000Z', close: 238.49 }, { date: '2010-04-06T07:00:00.000Z', close: 239.54 }, { date: '2010-04-07T07:00:00.000Z', close: 240.6 }, { date: '2010-04-08T07:00:00.000Z', close: 239.95 }, { date: '2010-04-09T07:00:00.000Z', close: 241.79 }, { date: '2010-04-12T07:00:00.000Z', close: 242.29 }, { date: '2010-04-13T07:00:00.000Z', close: 242.43 }, { date: '2010-04-14T07:00:00.000Z', close: 245.69 }, { date: '2010-04-15T07:00:00.000Z', close: 248.92 }, { date: '2010-04-16T07:00:00.000Z', close: 247.4 }, { date: '2010-04-19T07:00:00.000Z', close: 247.07 }, { date: '2010-04-20T07:00:00.000Z', close: 244.59 }, { date: '2010-04-21T07:00:00.000Z', close: 259.22 }, { date: '2010-04-22T07:00:00.000Z', close: 266.47 }, { date: '2010-04-23T07:00:00.000Z', close: 270.83 }, { date: '2010-04-26T07:00:00.000Z', close: 269.5 }, { date: '2010-04-27T07:00:00.000Z', close: 262.04 }, { date: '2010-04-28T07:00:00.000Z', close: 261.6 }, { date: '2010-04-29T07:00:00.000Z', close: 268.64 }, { date: '2010-04-30T07:00:00.000Z', close: 261.09 }, { date: '2010-05-03T07:00:00.000Z', close: 266.35 }, { date: '2010-05-04T07:00:00.000Z', close: 258.68 }, { date: '2010-05-05T07:00:00.000Z', close: 255.98 }, { date: '2010-05-06T07:00:00.000Z', close: 246.25 }, { date: '2010-05-07T07:00:00.000Z', close: 235.86 }, { date: '2010-05-10T07:00:00.000Z', close: 253.99 }, { date: '2010-05-11T07:00:00.000Z', close: 256.52 }, { date: '2010-05-12T07:00:00.000Z', close: 262.09 }, { date: '2010-05-13T07:00:00.000Z', close: 258.36 }, { date: '2010-05-14T07:00:00.000Z', close: 253.82 }, { date: '2010-05-17T07:00:00.000Z', close: 254.22 }, { date: '2010-05-18T07:00:00.000Z', close: 252.36 }, { date: '2010-05-19T07:00:00.000Z', close: 248.34 }, { date: '2010-05-20T07:00:00.000Z', close: 237.76 }, { date: '2010-05-21T07:00:00.000Z', close: 242.32 }, { date: '2010-05-24T07:00:00.000Z', close: 246.76 }, { date: '2010-05-25T07:00:00.000Z', close: 245.22 }, { date: '2010-05-26T07:00:00.000Z', close: 244.11 }, { date: '2010-05-27T07:00:00.000Z', close: 253.35 }, { date: '2010-05-28T07:00:00.000Z', close: 256.88 }, { date: '2010-05-31T07:00:00.000Z', close: 256.88 }, { date: '2010-06-01T07:00:00.000Z', close: 260.83 }, { date: '2010-06-02T07:00:00.000Z', close: 263.95 }, { date: '2010-06-03T07:00:00.000Z', close: 263.12 }, { date: '2010-06-04T07:00:00.000Z', close: 255.96 }, { date: '2010-06-07T07:00:00.000Z', close: 250.94 }, { date: '2010-06-08T07:00:00.000Z', close: 249.33 }, { date: '2010-06-09T07:00:00.000Z', close: 243.2 }, { date: '2010-06-10T07:00:00.000Z', close: 250.51 }, { date: '2010-06-11T07:00:00.000Z', close: 253.51 }, { date: '2010-06-14T07:00:00.000Z', close: 254.28 }, { date: '2010-06-15T07:00:00.000Z', close: 259.69 }, { date: '2010-06-16T07:00:00.000Z', close: 267.25 }, { date: '2010-06-17T07:00:00.000Z', close: 271.87 }, { date: '2010-06-18T07:00:00.000Z', close: 274.07 }, { date: '2010-06-21T07:00:00.000Z', close: 270.17 }, { date: '2010-06-22T07:00:00.000Z', close: 273.85 }, { date: '2010-06-23T07:00:00.000Z', close: 270.97 }, { date: '2010-06-24T07:00:00.000Z', close: 269 }, { date: '2010-06-25T07:00:00.000Z', close: 266.7 }, { date: '2010-06-28T07:00:00.000Z', close: 268.3 }, { date: '2010-06-29T07:00:00.000Z', close: 256.17 }, { date: '2010-06-30T07:00:00.000Z', close: 251.53 }, { date: '2010-07-01T07:00:00.000Z', close: 248.48 }, { date: '2010-07-02T07:00:00.000Z', close: 246.94 }, { date: '2010-07-05T07:00:00.000Z', close: 246.94 }, { date: '2010-07-06T07:00:00.000Z', close: 248.63 }, { date: '2010-07-07T07:00:00.000Z', close: 258.66 }, { date: '2010-07-08T07:00:00.000Z', close: 258.09 }, { date: '2010-07-09T07:00:00.000Z', close: 259.62 }, { date: '2010-07-12T07:00:00.000Z', close: 257.28 }, { date: '2010-07-13T07:00:00.000Z', close: 251.8 }, { date: '2010-07-14T07:00:00.000Z', close: 252.73 }, { date: '2010-07-15T07:00:00.000Z', close: 251.45 }, { date: '2010-07-16T07:00:00.000Z', close: 249.9 }, { date: '2010-07-19T07:00:00.000Z', close: 245.58 }, { date: '2010-07-20T07:00:00.000Z', close: 251.89 }, { date: '2010-07-21T07:00:00.000Z', close: 254.24 }, { date: '2010-07-22T07:00:00.000Z', close: 259.02 }, { date: '2010-07-23T07:00:00.000Z', close: 259.94 }, { date: '2010-07-26T07:00:00.000Z', close: 259.28 }, { date: '2010-07-27T07:00:00.000Z', close: 264.08 }, { date: '2010-07-28T07:00:00.000Z', close: 260.96 }, { date: '2010-07-29T07:00:00.000Z', close: 258.11 }, { date: '2010-07-30T07:00:00.000Z', close: 257.25 }, { date: '2010-08-02T07:00:00.000Z', close: 261.85 }, { date: '2010-08-03T07:00:00.000Z', close: 261.93 }, { date: '2010-08-04T07:00:00.000Z', close: 262.98 }, { date: '2010-08-05T07:00:00.000Z', close: 261.7 }, { date: '2010-08-06T07:00:00.000Z', close: 260.09 }, { date: '2010-08-09T07:00:00.000Z', close: 261.75 }, { date: '2010-08-10T07:00:00.000Z', close: 259.41 }, { date: '2010-08-11T07:00:00.000Z', close: 250.19 }, { date: '2010-08-12T07:00:00.000Z', close: 251.79 }, { date: '2010-08-13T07:00:00.000Z', close: 249.1 }, { date: '2010-08-16T07:00:00.000Z', close: 247.64 }, { date: '2010-08-17T07:00:00.000Z', close: 251.97 }, { date: '2010-08-18T07:00:00.000Z', close: 253.07 }, { date: '2010-08-19T07:00:00.000Z', close: 249.88 }, { date: '2010-08-20T07:00:00.000Z', close: 249.64 }, { date: '2010-08-23T07:00:00.000Z', close: 245.8 }, { date: '2010-08-24T07:00:00.000Z', close: 239.93 }, { date: '2010-08-25T07:00:00.000Z', close: 242.89 }, { date: '2010-08-26T07:00:00.000Z', close: 240.28 }, { date: '2010-08-27T07:00:00.000Z', close: 241.62 }, { date: '2010-08-30T07:00:00.000Z', close: 242.5 }, { date: '2010-08-31T07:00:00.000Z', close: 243.1 }, { date: '2010-09-01T07:00:00.000Z', close: 250.33 }, { date: '2010-09-02T07:00:00.000Z', close: 252.17 }, { date: '2010-09-03T07:00:00.000Z', close: 258.77 }, { date: '2010-09-06T07:00:00.000Z', close: 258.77 }, { date: '2010-09-07T07:00:00.000Z', close: 257.81 }, { date: '2010-09-08T07:00:00.000Z', close: 262.92 }, { date: '2010-09-09T07:00:00.000Z', close: 263.07 }, { date: '2010-09-10T07:00:00.000Z', close: 263.41 }, { date: '2010-09-13T07:00:00.000Z', close: 267.04 }, { date: '2010-09-14T07:00:00.000Z', close: 268.06 }, { date: '2010-09-15T07:00:00.000Z', close: 270.22 }, { date: '2010-09-16T07:00:00.000Z', close: 276.57 }, { date: '2010-09-17T07:00:00.000Z', close: 275.37 }, { date: '2010-09-20T07:00:00.000Z', close: 283.23 }, { date: '2010-09-21T07:00:00.000Z', close: 283.77 }, { date: '2010-09-22T07:00:00.000Z', close: 287.75 }, { date: '2010-09-23T07:00:00.000Z', close: 288.92 }, { date: '2010-09-24T07:00:00.000Z', close: 292.32 }, { date: '2010-09-27T07:00:00.000Z', close: 291.16 }, { date: '2010-09-28T07:00:00.000Z', close: 286.86 }, { date: '2010-09-29T07:00:00.000Z', close: 287.37 }, { date: '2010-09-30T07:00:00.000Z', close: 283.75 }, { date: '2010-10-01T07:00:00.000Z', close: 282.52 }, { date: '2010-10-04T07:00:00.000Z', close: 278.64 }, { date: '2010-10-05T07:00:00.000Z', close: 288.94 }, { date: '2010-10-06T07:00:00.000Z', close: 289.19 }, { date: '2010-10-07T07:00:00.000Z', close: 289.22 }, { date: '2010-10-08T07:00:00.000Z', close: 294.07 }, { date: '2010-10-11T07:00:00.000Z', close: 295.36 }, { date: '2010-10-12T07:00:00.000Z', close: 298.54 }, { date: '2010-10-13T07:00:00.000Z', close: 300.14 }, { date: '2010-10-14T07:00:00.000Z', close: 302.31 }, { date: '2010-10-15T07:00:00.000Z', close: 314.74 }, { date: '2010-10-18T07:00:00.000Z', close: 318 }, { date: '2010-10-19T07:00:00.000Z', close: 309.49 }, { date: '2010-10-20T07:00:00.000Z', close: 310.53 }, { date: '2010-10-21T07:00:00.000Z', close: 309.52 }, { date: '2010-10-22T07:00:00.000Z', close: 307.47 }, { date: '2010-10-25T07:00:00.000Z', close: 308.84 }, { date: '2010-10-26T07:00:00.000Z', close: 308.05 }, { date: '2010-10-27T07:00:00.000Z', close: 307.83 }, { date: '2010-10-28T07:00:00.000Z', close: 305.24 }, { date: '2010-10-29T07:00:00.000Z', close: 300.98 }, { date: '2010-11-01T07:00:00.000Z', close: 304.18 }, { date: '2010-11-02T07:00:00.000Z', close: 309.36 }, { date: '2010-11-03T07:00:00.000Z', close: 312.8 }, { date: '2010-11-04T07:00:00.000Z', close: 318.27 }, { date: '2010-11-05T07:00:00.000Z', close: 317.13 }, { date: '2010-11-08T08:00:00.000Z', close: 318.62 }, { date: '2010-11-09T08:00:00.000Z', close: 316.08 }, { date: '2010-11-10T08:00:00.000Z', close: 318.03 }, { date: '2010-11-11T08:00:00.000Z', close: 316.66 }, { date: '2010-11-12T08:00:00.000Z', close: 308.03 }, { date: '2010-11-15T08:00:00.000Z', close: 307.04 }, { date: '2010-11-16T08:00:00.000Z', close: 301.59 }, { date: '2010-11-17T08:00:00.000Z', close: 300.5 }, { date: '2010-11-18T08:00:00.000Z', close: 308.43 }, { date: '2010-11-19T08:00:00.000Z', close: 306.73 }, { date: '2010-11-22T08:00:00.000Z', close: 313.36 }, { date: '2010-11-23T08:00:00.000Z', close: 308.73 }, { date: '2010-11-24T08:00:00.000Z', close: 314.8 }, { date: '2010-11-26T08:00:00.000Z', close: 315 }, { date: '2010-11-29T08:00:00.000Z', close: 316.87 }, { date: '2010-11-30T08:00:00.000Z', close: 311.15 }, { date: '2010-12-01T08:00:00.000Z', close: 316.4 }, { date: '2010-12-02T08:00:00.000Z', close: 318.15 }, { date: '2010-12-03T08:00:00.000Z', close: 317.44 }, { date: '2010-12-06T08:00:00.000Z', close: 320.15 }, { date: '2010-12-07T08:00:00.000Z', close: 318.21 }, { date: '2010-12-08T08:00:00.000Z', close: 321.01 }, { date: '2010-12-09T08:00:00.000Z', close: 319.76 }, { date: '2010-12-10T08:00:00.000Z', close: 320.56 }, { date: '2010-12-13T08:00:00.000Z', close: 321.67 }, { date: '2010-12-14T08:00:00.000Z', close: 320.29 }, { date: '2010-12-15T08:00:00.000Z', close: 320.36 }, { date: '2010-12-16T08:00:00.000Z', close: 321.25 }, { date: '2010-12-17T08:00:00.000Z', close: 320.61 }, { date: '2010-12-20T08:00:00.000Z', close: 322.21 }, { date: '2010-12-21T08:00:00.000Z', close: 324.2 }, { date: '2010-12-22T08:00:00.000Z', close: 325.16 }, { date: '2010-12-23T08:00:00.000Z', close: 323.6 }, { date: '2010-12-27T08:00:00.000Z', close: 324.68 }, { date: '2010-12-28T08:00:00.000Z', close: 325.47 }, { date: '2010-12-29T08:00:00.000Z', close: 325.29 }, { date: '2010-12-30T08:00:00.000Z', close: 323.66 }, { date: '2010-12-31T08:00:00.000Z', close: 322.56 }, { date: '2011-01-03T08:00:00.000Z', close: 329.57 }, { date: '2011-01-04T08:00:00.000Z', close: 331.29 }, { date: '2011-01-05T08:00:00.000Z', close: 334 }, { date: '2011-01-06T08:00:00.000Z', close: 333.73 }, { date: '2011-01-07T08:00:00.000Z', close: 336.12 }, { date: '2011-01-10T08:00:00.000Z', close: 342.46 }, { date: '2011-01-11T08:00:00.000Z', close: 341.64 }, { date: '2011-01-12T08:00:00.000Z', close: 344.42 }, { date: '2011-01-13T08:00:00.000Z', close: 345.68 }, { date: '2011-01-14T08:00:00.000Z', close: 348.48 }, { date: '2011-01-18T08:00:00.000Z', close: 340.65 }, { date: '2011-01-19T08:00:00.000Z', close: 338.84 }, { date: '2011-01-20T08:00:00.000Z', close: 332.68 }, { date: '2011-01-21T08:00:00.000Z', close: 326.72 }, { date: '2011-01-24T08:00:00.000Z', close: 337.45 }, { date: '2011-01-25T08:00:00.000Z', close: 341.4 }, { date: '2011-01-26T08:00:00.000Z', close: 343.85 }, { date: '2011-01-27T08:00:00.000Z', close: 343.21 }, { date: '2011-01-28T08:00:00.000Z', close: 336.1 }, { date: '2011-01-31T08:00:00.000Z', close: 339.32 }, { date: '2011-02-01T08:00:00.000Z', close: 345.03 }, { date: '2011-02-02T08:00:00.000Z', close: 344.32 }, { date: '2011-02-03T08:00:00.000Z', close: 343.44 }, { date: '2011-02-04T08:00:00.000Z', close: 346.5 }, { date: '2011-02-07T08:00:00.000Z', close: 351.88 }, { date: '2011-02-08T08:00:00.000Z', close: 355.2 }, { date: '2011-02-09T08:00:00.000Z', close: 358.16 }, { date: '2011-02-10T08:00:00.000Z', close: 354.54 }, { date: '2011-02-11T08:00:00.000Z', close: 356.85 }, { date: '2011-02-14T08:00:00.000Z', close: 359.18 }, { date: '2011-02-15T08:00:00.000Z', close: 359.9 }, { date: '2011-02-16T08:00:00.000Z', close: 363.13 }, { date: '2011-02-17T08:00:00.000Z', close: 358.3 }, { date: '2011-02-18T08:00:00.000Z', close: 350.56 }, { date: '2011-02-22T08:00:00.000Z', close: 338.61 }, { date: '2011-02-23T08:00:00.000Z', close: 342.62 }, { date: '2011-02-24T08:00:00.000Z', close: 342.88 }, { date: '2011-02-25T08:00:00.000Z', close: 348.16 }, { date: '2011-02-28T08:00:00.000Z', close: 353.21 }, { date: '2011-03-01T08:00:00.000Z', close: 349.31 }, { date: '2011-03-02T08:00:00.000Z', close: 352.12 }, { date: '2011-03-03T08:00:00.000Z', close: 359.56 }, { date: '2011-03-04T08:00:00.000Z', close: 360 }, { date: '2011-03-07T08:00:00.000Z', close: 355.36 }, { date: '2011-03-08T08:00:00.000Z', close: 355.76 }, { date: '2011-03-09T08:00:00.000Z', close: 352.47 }, { date: '2011-03-10T08:00:00.000Z', close: 346.67 }, { date: '2011-03-11T08:00:00.000Z', close: 351.99 }, { date: '2011-03-14T07:00:00.000Z', close: 353.56 }, { date: '2011-03-15T07:00:00.000Z', close: 345.43 }, { date: '2011-03-16T07:00:00.000Z', close: 330.01 }, { date: '2011-03-17T07:00:00.000Z', close: 334.64 }, { date: '2011-03-18T07:00:00.000Z', close: 330.67 }, { date: '2011-03-21T07:00:00.000Z', close: 339.3 }, { date: '2011-03-22T07:00:00.000Z', close: 341.2 }, { date: '2011-03-23T07:00:00.000Z', close: 339.19 }, { date: '2011-03-24T07:00:00.000Z', close: 344.97 }, { date: '2011-03-25T07:00:00.000Z', close: 351.54 }, { date: '2011-03-28T07:00:00.000Z', close: 350.44 }, { date: '2011-03-29T07:00:00.000Z', close: 350.96 }, { date: '2011-03-30T07:00:00.000Z', close: 348.63 }, { date: '2011-03-31T07:00:00.000Z', close: 348.51 }, { date: '2011-04-01T07:00:00.000Z', close: 344.56 }, { date: '2011-04-04T07:00:00.000Z', close: 341.19 }, { date: '2011-04-05T07:00:00.000Z', close: 338.89 }, { date: '2011-04-06T07:00:00.000Z', close: 338.04 }, { date: '2011-04-07T07:00:00.000Z', close: 338.08 }, { date: '2011-04-08T07:00:00.000Z', close: 335.06 }, { date: '2011-04-11T07:00:00.000Z', close: 330.8 }, { date: '2011-04-12T07:00:00.000Z', close: 332.4 }, { date: '2011-04-13T07:00:00.000Z', close: 336.13 }, { date: '2011-04-14T07:00:00.000Z', close: 332.42 }, { date: '2011-04-15T07:00:00.000Z', close: 327.46 }, { date: '2011-04-18T07:00:00.000Z', close: 331.85 }, { date: '2011-04-19T07:00:00.000Z', close: 337.86 }, { date: '2011-04-20T07:00:00.000Z', close: 342.41 }, { date: '2011-04-21T07:00:00.000Z', close: 350.7 }, { date: '2011-04-25T07:00:00.000Z', close: 353.01 }, { date: '2011-04-26T07:00:00.000Z', close: 350.42 }, { date: '2011-04-27T07:00:00.000Z', close: 350.15 }, { date: '2011-04-28T07:00:00.000Z', close: 346.75 }, { date: '2011-04-29T07:00:00.000Z', close: 350.13 }, { date: '2011-05-02T07:00:00.000Z', close: 346.28 }, { date: '2011-05-03T07:00:00.000Z', close: 348.2 }, { date: '2011-05-04T07:00:00.000Z', close: 349.57 }, { date: '2011-05-05T07:00:00.000Z', close: 346.75 }, { date: '2011-05-06T07:00:00.000Z', close: 346.66 }, { date: '2011-05-09T07:00:00.000Z', close: 347.6 }, { date: '2011-05-10T07:00:00.000Z', close: 349.45 }, { date: '2011-05-11T07:00:00.000Z', close: 347.23 }, { date: '2011-05-12T07:00:00.000Z', close: 346.57 }, { date: '2011-05-13T07:00:00.000Z', close: 340.5 }, { date: '2011-05-16T07:00:00.000Z', close: 333.3 }, { date: '2011-05-17T07:00:00.000Z', close: 336.14 }, { date: '2011-05-18T07:00:00.000Z', close: 339.87 }, { date: '2011-05-19T07:00:00.000Z', close: 340.53 }, { date: '2011-05-20T07:00:00.000Z', close: 335.22 }, { date: '2011-05-23T07:00:00.000Z', close: 334.4 }, { date: '2011-05-24T07:00:00.000Z', close: 332.19 }, { date: '2011-05-25T07:00:00.000Z', close: 336.78 }, { date: '2011-05-26T07:00:00.000Z', close: 335 }, { date: '2011-05-27T07:00:00.000Z', close: 337.41 }, { date: '2011-05-31T07:00:00.000Z', close: 347.83 }, { date: '2011-06-01T07:00:00.000Z', close: 345.51 }, { date: '2011-06-02T07:00:00.000Z', close: 346.1 }, { date: '2011-06-03T07:00:00.000Z', close: 343.44 }, { date: '2011-06-06T07:00:00.000Z', close: 338.04 }, { date: '2011-06-07T07:00:00.000Z', close: 332.04 }, { date: '2011-06-08T07:00:00.000Z', close: 332.24 }, { date: '2011-06-09T07:00:00.000Z', close: 331.49 }, { date: '2011-06-10T07:00:00.000Z', close: 325.9 }, { date: '2011-06-13T07:00:00.000Z', close: 326.6 }, { date: '2011-06-14T07:00:00.000Z', close: 332.44 }, { date: '2011-06-15T07:00:00.000Z', close: 326.75 }, { date: '2011-06-16T07:00:00.000Z', close: 325.16 }, { date: '2011-06-17T07:00:00.000Z', close: 320.26 }, { date: '2011-06-20T07:00:00.000Z', close: 315.32 }, { date: '2011-06-21T07:00:00.000Z', close: 325.3 }, { date: '2011-06-22T07:00:00.000Z', close: 322.61 }, { date: '2011-06-23T07:00:00.000Z', close: 331.23 }, { date: '2011-06-24T07:00:00.000Z', close: 326.35 }, { date: '2011-06-27T07:00:00.000Z', close: 332.04 }, { date: '2011-06-28T07:00:00.000Z', close: 335.26 }, { date: '2011-06-29T07:00:00.000Z', close: 334.04 }, { date: '2011-06-30T07:00:00.000Z', close: 335.67 }, { date: '2011-07-01T07:00:00.000Z', close: 343.26 }, { date: '2011-07-05T07:00:00.000Z', close: 349.43 }, { date: '2011-07-06T07:00:00.000Z', close: 351.76 }, { date: '2011-07-07T07:00:00.000Z', close: 357.2 }, { date: '2011-07-08T07:00:00.000Z', close: 359.71 }, { date: '2011-07-11T07:00:00.000Z', close: 354 }, { date: '2011-07-12T07:00:00.000Z', close: 353.75 }, { date: '2011-07-13T07:00:00.000Z', close: 358.02 }, { date: '2011-07-14T07:00:00.000Z', close: 357.77 }, { date: '2011-07-15T07:00:00.000Z', close: 364.92 }, { date: '2011-07-18T07:00:00.000Z', close: 373.8 }, { date: '2011-07-19T07:00:00.000Z', close: 376.85 }, { date: '2011-07-20T07:00:00.000Z', close: 386.9 }, { date: '2011-07-21T07:00:00.000Z', close: 387.29 }, { date: '2011-07-22T07:00:00.000Z', close: 393.3 }, { date: '2011-07-25T07:00:00.000Z', close: 398.5 }, { date: '2011-07-26T07:00:00.000Z', close: 403.41 }, { date: '2011-07-27T07:00:00.000Z', close: 392.59 }, { date: '2011-07-28T07:00:00.000Z', close: 391.82 }, { date: '2011-07-29T07:00:00.000Z', close: 390.48 }, { date: '2011-08-01T07:00:00.000Z', close: 396.75 }, { date: '2011-08-02T07:00:00.000Z', close: 388.91 }, { date: '2011-08-03T07:00:00.000Z', close: 392.57 }, { date: '2011-08-04T07:00:00.000Z', close: 377.37 }, { date: '2011-08-05T07:00:00.000Z', close: 373.62 }, { date: '2011-08-08T07:00:00.000Z', close: 353.21 }, { date: '2011-08-09T07:00:00.000Z', close: 374.01 }, { date: '2011-08-10T07:00:00.000Z', close: 363.69 }, { date: '2011-08-11T07:00:00.000Z', close: 373.7 }, { date: '2011-08-12T07:00:00.000Z', close: 376.99 }, { date: '2011-08-15T07:00:00.000Z', close: 383.41 }, { date: '2011-08-16T07:00:00.000Z', close: 380.48 }, { date: '2011-08-17T07:00:00.000Z', close: 380.44 }, { date: '2011-08-18T07:00:00.000Z', close: 366.05 }, { date: '2011-08-19T07:00:00.000Z', close: 356.03 }, { date: '2011-08-22T07:00:00.000Z', close: 356.44 }, { date: '2011-08-23T07:00:00.000Z', close: 373.6 }, { date: '2011-08-24T07:00:00.000Z', close: 376.18 }, { date: '2011-08-25T07:00:00.000Z', close: 373.72 }, { date: '2011-08-26T07:00:00.000Z', close: 383.58 }, { date: '2011-08-29T07:00:00.000Z', close: 389.97 }, { date: '2011-08-30T07:00:00.000Z', close: 389.99 }, { date: '2011-08-31T07:00:00.000Z', close: 384.83 }, { date: '2011-09-01T07:00:00.000Z', close: 381.03 }, { date: '2011-09-02T07:00:00.000Z', close: 374.05 }, { date: '2011-09-06T07:00:00.000Z', close: 379.74 }, { date: '2011-09-07T07:00:00.000Z', close: 383.93 }, { date: '2011-09-08T07:00:00.000Z', close: 384.14 }, { date: '2011-09-09T07:00:00.000Z', close: 377.48 }, { date: '2011-09-12T07:00:00.000Z', close: 379.94 }, { date: '2011-09-13T07:00:00.000Z', close: 384.62 }, { date: '2011-09-14T07:00:00.000Z', close: 389.3 }, { date: '2011-09-15T07:00:00.000Z', close: 392.96 }, { date: '2011-09-16T07:00:00.000Z', close: 400.5 }, { date: '2011-09-19T07:00:00.000Z', close: 411.63 }, { date: '2011-09-20T07:00:00.000Z', close: 413.45 }, { date: '2011-09-21T07:00:00.000Z', close: 412.14 }, { date: '2011-09-22T07:00:00.000Z', close: 401.82 }, { date: '2011-09-23T07:00:00.000Z', close: 404.3 }, { date: '2011-09-26T07:00:00.000Z', close: 403.17 }, { date: '2011-09-27T07:00:00.000Z', close: 399.26 }, { date: '2011-09-28T07:00:00.000Z', close: 397.01 }, { date: '2011-09-29T07:00:00.000Z', close: 390.57 }, { date: '2011-09-30T07:00:00.000Z', close: 381.32 }, { date: '2011-10-03T07:00:00.000Z', close: 374.6 }, { date: '2011-10-04T07:00:00.000Z', close: 372.5 }, { date: '2011-10-05T07:00:00.000Z', close: 378.25 }, { date: '2011-10-06T07:00:00.000Z', close: 377.37 }, { date: '2011-10-07T07:00:00.000Z', close: 369.8 }, { date: '2011-10-10T07:00:00.000Z', close: 388.81 }, { date: '2011-10-11T07:00:00.000Z', close: 400.29 }, { date: '2011-10-12T07:00:00.000Z', close: 402.19 }, { date: '2011-10-13T07:00:00.000Z', close: 408.43 }, { date: '2011-10-14T07:00:00.000Z', close: 422 }, { date: '2011-10-17T07:00:00.000Z', close: 419.99 }, { date: '2011-10-18T07:00:00.000Z', close: 422.24 }, { date: '2011-10-19T07:00:00.000Z', close: 398.62 }, { date: '2011-10-20T07:00:00.000Z', close: 395.31 }, { date: '2011-10-21T07:00:00.000Z', close: 392.87 }, { date: '2011-10-24T07:00:00.000Z', close: 405.77 }, { date: '2011-10-25T07:00:00.000Z', close: 397.77 }, { date: '2011-10-26T07:00:00.000Z', close: 400.6 }, { date: '2011-10-27T07:00:00.000Z', close: 404.69 }, { date: '2011-10-28T07:00:00.000Z', close: 404.95 }, { date: '2011-10-31T07:00:00.000Z', close: 404.78 }, { date: '2011-11-01T07:00:00.000Z', close: 396.51 }, { date: '2011-11-02T07:00:00.000Z', close: 397.41 }, { date: '2011-11-03T07:00:00.000Z', close: 403.07 }, { date: '2011-11-04T07:00:00.000Z', close: 400.24 }, { date: '2011-11-07T08:00:00.000Z', close: 399.73 }, { date: '2011-11-08T08:00:00.000Z', close: 406.23 }, { date: '2011-11-09T08:00:00.000Z', close: 395.28 }, { date: '2011-11-10T08:00:00.000Z', close: 385.22 }, { date: '2011-11-11T08:00:00.000Z', close: 384.62 }, { date: '2011-11-14T08:00:00.000Z', close: 379.26 }, { date: '2011-11-15T08:00:00.000Z', close: 388.83 }, { date: '2011-11-16T08:00:00.000Z', close: 384.77 }, { date: '2011-11-17T08:00:00.000Z', close: 377.41 }, { date: '2011-11-18T08:00:00.000Z', close: 374.94 }, { date: '2011-11-21T08:00:00.000Z', close: 369.01 }, { date: '2011-11-22T08:00:00.000Z', close: 376.51 }, { date: '2011-11-23T08:00:00.000Z', close: 366.99 }, { date: '2011-11-25T08:00:00.000Z', close: 363.57 }, { date: '2011-11-28T08:00:00.000Z', close: 376.12 }, { date: '2011-11-29T08:00:00.000Z', close: 373.2 }, { date: '2011-11-30T08:00:00.000Z', close: 382.2 }, { date: '2011-12-01T08:00:00.000Z', close: 387.93 }, { date: '2011-12-02T08:00:00.000Z', close: 389.7 }, { date: '2011-12-05T08:00:00.000Z', close: 393.01 }, { date: '2011-12-06T08:00:00.000Z', close: 390.95 }, { date: '2011-12-07T08:00:00.000Z', close: 389.09 }, { date: '2011-12-08T08:00:00.000Z', close: 390.66 }, { date: '2011-12-09T08:00:00.000Z', close: 393.62 }, { date: '2011-12-12T08:00:00.000Z', close: 391.84 }, { date: '2011-12-13T08:00:00.000Z', close: 388.81 }, { date: '2011-12-14T08:00:00.000Z', close: 380.19 }, { date: '2011-12-15T08:00:00.000Z', close: 378.94 }, { date: '2011-12-16T08:00:00.000Z', close: 381.02 }, { date: '2011-12-19T08:00:00.000Z', close: 382.21 }, { date: '2011-12-20T08:00:00.000Z', close: 395.95 }, { date: '2011-12-21T08:00:00.000Z', close: 396.44 }, { date: '2011-12-22T08:00:00.000Z', close: 398.55 }, { date: '2011-12-23T08:00:00.000Z', close: 403.43 }, { date: '2011-12-27T08:00:00.000Z', close: 406.53 }, { date: '2011-12-28T08:00:00.000Z', close: 402.64 }, { date: '2011-12-29T08:00:00.000Z', close: 405.12 }, { date: '2011-12-30T08:00:00.000Z', close: 405 }, { date: '2012-01-03T08:00:00.000Z', close: 411.23 }, { date: '2012-01-04T08:00:00.000Z', close: 413.44 }, { date: '2012-01-05T08:00:00.000Z', close: 418.03 }, { date: '2012-01-06T08:00:00.000Z', close: 422.4 }, { date: '2012-01-09T08:00:00.000Z', close: 421.73 }, { date: '2012-01-10T08:00:00.000Z', close: 423.24 }, { date: '2012-01-11T08:00:00.000Z', close: 422.55 }, { date: '2012-01-12T08:00:00.000Z', close: 421.39 }, { date: '2012-01-13T08:00:00.000Z', close: 419.81 }, { date: '2012-01-17T08:00:00.000Z', close: 424.7 }, { date: '2012-01-18T08:00:00.000Z', close: 429.11 }, { date: '2012-01-19T08:00:00.000Z', close: 427.75 }, { date: '2012-01-20T08:00:00.000Z', close: 420.3 }, { date: '2012-01-23T08:00:00.000Z', close: 427.41 }, { date: '2012-01-24T08:00:00.000Z', close: 420.41 }, { date: '2012-01-25T08:00:00.000Z', close: 446.66 }, { date: '2012-01-26T08:00:00.000Z', close: 444.63 }, { date: '2012-01-27T08:00:00.000Z', close: 447.28 }, { date: '2012-01-30T08:00:00.000Z', close: 453.01 }, { date: '2012-01-31T08:00:00.000Z', close: 456.48 }, { date: '2012-02-01T08:00:00.000Z', close: 456.19 }, { date: '2012-02-02T08:00:00.000Z', close: 455.12 }, { date: '2012-02-03T08:00:00.000Z', close: 459.68 }, { date: '2012-02-06T08:00:00.000Z', close: 463.97 }, { date: '2012-02-07T08:00:00.000Z', close: 468.83 }, { date: '2012-02-08T08:00:00.000Z', close: 476.68 }, { date: '2012-02-09T08:00:00.000Z', close: 493.17 }, { date: '2012-02-10T08:00:00.000Z', close: 493.42 }, { date: '2012-02-13T08:00:00.000Z', close: 502.6 }, { date: '2012-02-14T08:00:00.000Z', close: 509.46 }, { date: '2012-02-15T08:00:00.000Z', close: 497.67 }, { date: '2012-02-16T08:00:00.000Z', close: 502.21 }, { date: '2012-02-17T08:00:00.000Z', close: 502.12 }, { date: '2012-02-21T08:00:00.000Z', close: 514.85 }, { date: '2012-02-22T08:00:00.000Z', close: 513.04 }, { date: '2012-02-23T08:00:00.000Z', close: 516.39 }, { date: '2012-02-24T08:00:00.000Z', close: 522.41 }, { date: '2012-02-27T08:00:00.000Z', close: 525.76 }, { date: '2012-02-28T08:00:00.000Z', close: 535.41 }, { date: '2012-02-29T08:00:00.000Z', close: 542.44 }, { date: '2012-03-01T08:00:00.000Z', close: 544.47 }, { date: '2012-03-02T08:00:00.000Z', close: 545.18 }, { date: '2012-03-05T08:00:00.000Z', close: 533.16 }, { date: '2012-03-06T08:00:00.000Z', close: 530.26 }, { date: '2012-03-07T08:00:00.000Z', close: 530.69 }, { date: '2012-03-08T08:00:00.000Z', close: 541.99 }, { date: '2012-03-09T08:00:00.000Z', close: 545.17 }, { date: '2012-03-12T07:00:00.000Z', close: 552 }, { date: '2012-03-13T07:00:00.000Z', close: 568.1 }, { date: '2012-03-14T07:00:00.000Z', close: 589.58 }, { date: '2012-03-15T07:00:00.000Z', close: 585.56 }, { date: '2012-03-16T07:00:00.000Z', close: 585.57 }, { date: '2012-03-19T07:00:00.000Z', close: 601.1 }, { date: '2012-03-20T07:00:00.000Z', close: 605.96 }, { date: '2012-03-21T07:00:00.000Z', close: 602.5 }, { date: '2012-03-22T07:00:00.000Z', close: 599.34 }, { date: '2012-03-23T07:00:00.000Z', close: 596.05 }, { date: '2012-03-26T07:00:00.000Z', close: 606.98 }, { date: '2012-03-27T07:00:00.000Z', close: 614.48 }, { date: '2012-03-28T07:00:00.000Z', close: 617.62 }, { date: '2012-03-29T07:00:00.000Z', close: 609.86 }, { date: '2012-03-30T07:00:00.000Z', close: 599.55 }, { date: '2012-04-02T07:00:00.000Z', close: 618.63 }, { date: '2012-04-03T07:00:00.000Z', close: 629.32 }, { date: '2012-04-04T07:00:00.000Z', close: 624.31 }, { date: '2012-04-05T07:00:00.000Z', close: 633.68 }, { date: '2012-04-09T07:00:00.000Z', close: 636.23 }, { date: '2012-04-10T07:00:00.000Z', close: 628.44 }, { date: '2012-04-11T07:00:00.000Z', close: 626.2 }, { date: '2012-04-12T07:00:00.000Z', close: 622.77 }, { date: '2012-04-13T07:00:00.000Z', close: 605.23 }, { date: '2012-04-16T07:00:00.000Z', close: 580.13 }, { date: '2012-04-17T07:00:00.000Z', close: 609.7 }, { date: '2012-04-18T07:00:00.000Z', close: 608.34 }, { date: '2012-04-19T07:00:00.000Z', close: 587.44 }, { date: '2012-04-20T07:00:00.000Z', close: 572.98 }, { date: '2012-04-23T07:00:00.000Z', close: 571.7 }, { date: '2012-04-24T07:00:00.000Z', close: 560.28 }, { date: '2012-04-25T07:00:00.000Z', close: 610 }, { date: '2012-04-26T07:00:00.000Z', close: 607.7 }, { date: '2012-04-27T07:00:00.000Z', close: 603 }, { date: '2012-04-30T07:00:00.000Z', close: 583.98 }, { date: '2012-05-01T07:00:00.000Z', close: 582.13 }];

var letterFrequency = [{ letter: 'A', frequency: 0.08167 }, { letter: 'B', frequency: 0.01492 }, { letter: 'C', frequency: 0.02782 }, { letter: 'D', frequency: 0.04253 }, { letter: 'E', frequency: 0.12702 }, { letter: 'F', frequency: 0.02288 }, { letter: 'G', frequency: 0.02015 }, { letter: 'H', frequency: 0.06094 }, { letter: 'I', frequency: 0.06966 }, { letter: 'J', frequency: 0.00153 }, { letter: 'K', frequency: 0.00772 }, { letter: 'L', frequency: 0.04025 }, { letter: 'M', frequency: 0.02406 }, { letter: 'N', frequency: 0.06749 }, { letter: 'O', frequency: 0.07507 }, { letter: 'P', frequency: 0.01929 }, { letter: 'Q', frequency: 0.00095 }, { letter: 'R', frequency: 0.05987 }, { letter: 'S', frequency: 0.06327 }, { letter: 'T', frequency: 0.09056 }, { letter: 'U', frequency: 0.02758 }, { letter: 'V', frequency: 0.00978 }, { letter: 'W', frequency: 0.0236 }, { letter: 'X', frequency: 0.0015 }, { letter: 'Y', frequency: 0.01974 }, { letter: 'Z', frequency: 0.00074 }];

var browserUsage = [{
  date: '2015 Jun 15',
  'Google Chrome': '48.09',
  'Internet Explorer': '24.14',
  Firefox: '18.82',
  Safari: '7.46',
  'Microsoft Edge': '0.03',
  Opera: '1.32',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 16',
  'Google Chrome': '48',
  'Internet Explorer': '24.19',
  Firefox: '18.96',
  Safari: '7.36',
  'Microsoft Edge': '0.03',
  Opera: '1.32',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 17',
  'Google Chrome': '47.87',
  'Internet Explorer': '24.44',
  Firefox: '18.91',
  Safari: '7.27',
  'Microsoft Edge': '0.03',
  Opera: '1.36',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 18',
  'Google Chrome': '48.22',
  'Internet Explorer': '23.83',
  Firefox: '19.16',
  Safari: '7.24',
  'Microsoft Edge': '0.04',
  Opera: '1.39',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 19',
  'Google Chrome': '47.91',
  'Internet Explorer': '23.86',
  Firefox: '19.35',
  Safari: '7.31',
  'Microsoft Edge': '0.04',
  Opera: '1.41',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 20',
  'Google Chrome': '48.78',
  'Internet Explorer': '21.14',
  Firefox: '19.66',
  Safari: '8.42',
  'Microsoft Edge': '0.05',
  Opera: '1.83',
  Mozilla: '0.1',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 21',
  'Google Chrome': '49.43',
  'Internet Explorer': '20.55',
  Firefox: '19.42',
  Safari: '8.66',
  'Microsoft Edge': '0.05',
  Opera: '1.75',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 22',
  'Google Chrome': '48.98',
  'Internet Explorer': '23.47',
  Firefox: '18.84',
  Safari: '7.25',
  'Microsoft Edge': '0.04',
  Opera: '1.28',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 23',
  'Google Chrome': '48.69',
  'Internet Explorer': '23.76',
  Firefox: '18.89',
  Safari: '7.22',
  'Microsoft Edge': '0.04',
  Opera: '1.27',
  Mozilla: '0.11',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 24',
  'Google Chrome': '49.17',
  'Internet Explorer': '23.35',
  Firefox: '18.91',
  Safari: '7.09',
  'Microsoft Edge': '0.04',
  Opera: '1.32',
  Mozilla: '0.12',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 25',
  'Google Chrome': '49.32',
  'Internet Explorer': '23.39',
  Firefox: '18.76',
  Safari: '7.03',
  'Microsoft Edge': '0.04',
  Opera: '1.34',
  Mozilla: '0.11',
  'Other/Unknown': '0'
}, {
  date: '2015 Jun 26',
  'Google Chrome': '49.39',
  'Internet Explorer': '23.11',
  Firefox: '18.84',
  Safari: '7.14',
  'Microsoft Edge': '0.04',
  Opera: '1.37',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2015 Jun 27',
  'Google Chrome': '49.77',
  'Internet Explorer': '20.68',
  Firefox: '19.23',
  Safari: '8.46',
  'Microsoft Edge': '0.05',
  Opera: '1.71',
  Mozilla: '0.09',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 28',
  'Google Chrome': '50.07',
  'Internet Explorer': '20.41',
  Firefox: '18.91',
  Safari: '8.77',
  'Microsoft Edge': '0.05',
  Opera: '1.69',
  Mozilla: '0.1',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 29',
  'Google Chrome': '49.32',
  'Internet Explorer': '23.3',
  Firefox: '18.54',
  Safari: '7.4',
  'Microsoft Edge': '0.04',
  Opera: '1.27',
  Mozilla: '0.11',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jun 30',
  'Google Chrome': '49.99',
  'Internet Explorer': '22.94',
  Firefox: '18.45',
  Safari: '7.07',
  'Microsoft Edge': '0.07',
  Opera: '1.32',
  Mozilla: '0.13',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 1',
  'Google Chrome': '50.22',
  'Internet Explorer': '22.79',
  Firefox: '18.46',
  Safari: '6.95',
  'Microsoft Edge': '0.07',
  Opera: '1.37',
  Mozilla: '0.12',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 2',
  'Google Chrome': '50.33',
  'Internet Explorer': '22.59',
  Firefox: '18.74',
  Safari: '6.69',
  'Microsoft Edge': '0.07',
  Opera: '1.45',
  Mozilla: '0.12',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 3',
  'Google Chrome': '50.4',
  'Internet Explorer': '21.29',
  Firefox: '19.28',
  Safari: '7.28',
  'Microsoft Edge': '0.08',
  Opera: '1.54',
  Mozilla: '0.11',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 4',
  'Google Chrome': '50.83',
  'Internet Explorer': '20.02',
  Firefox: '19.12',
  Safari: '7.99',
  'Microsoft Edge': '0.08',
  Opera: '1.82',
  Mozilla: '0.11',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 5',
  'Google Chrome': '51.6',
  'Internet Explorer': '19.6',
  Firefox: '18.43',
  Safari: '8.58',
  'Microsoft Edge': '0.07',
  Opera: '1.62',
  Mozilla: '0.1',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 6',
  'Google Chrome': '50.53',
  'Internet Explorer': '22.64',
  Firefox: '18.04',
  Safari: '7.33',
  'Microsoft Edge': '0.07',
  Opera: '1.27',
  Mozilla: '0.11',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 7',
  'Google Chrome': '50.01',
  'Internet Explorer': '23.02',
  Firefox: '18.32',
  Safari: '7.25',
  'Microsoft Edge': '0.07',
  Opera: '1.25',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 8',
  'Google Chrome': '49.52',
  'Internet Explorer': '23.17',
  Firefox: '18.55',
  Safari: '7.31',
  'Microsoft Edge': '0.07',
  Opera: '1.32',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 9',
  'Google Chrome': '49.31',
  'Internet Explorer': '23.24',
  Firefox: '18.7',
  Safari: '7.22',
  'Microsoft Edge': '0.08',
  Opera: '1.39',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 10',
  'Google Chrome': '48.4',
  'Internet Explorer': '23.68',
  Firefox: '18.97',
  Safari: '7.37',
  'Microsoft Edge': '0.09',
  Opera: '1.43',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 11',
  'Google Chrome': '48.87',
  'Internet Explorer': '21.22',
  Firefox: '19.33',
  Safari: '8.65',
  'Microsoft Edge': '0.1',
  Opera: '1.76',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 12',
  'Google Chrome': '49.4',
  'Internet Explorer': '20.87',
  Firefox: '18.84',
  Safari: '8.99',
  'Microsoft Edge': '0.09',
  Opera: '1.73',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 13',
  'Google Chrome': '49.12',
  'Internet Explorer': '23.35',
  Firefox: '18.49',
  Safari: '7.51',
  'Microsoft Edge': '0.07',
  Opera: '1.39',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 14',
  'Google Chrome': '49.36',
  'Internet Explorer': '23.2',
  Firefox: '18.48',
  Safari: '7.48',
  'Microsoft Edge': '0.08',
  Opera: '1.35',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 15',
  'Google Chrome': '48.88',
  'Internet Explorer': '23.73',
  Firefox: '18.46',
  Safari: '7.44',
  'Microsoft Edge': '0.09',
  Opera: '1.34',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 16',
  'Google Chrome': '48.76',
  'Internet Explorer': '23.77',
  Firefox: '18.5',
  Safari: '7.43',
  'Microsoft Edge': '0.09',
  Opera: '1.4',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 17',
  'Google Chrome': '47.58',
  'Internet Explorer': '24.54',
  Firefox: '18.76',
  Safari: '7.53',
  'Microsoft Edge': '0.09',
  Opera: '1.43',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 18',
  'Google Chrome': '48.06',
  'Internet Explorer': '21.89',
  Firefox: '19.14',
  Safari: '8.99',
  'Microsoft Edge': '0.11',
  Opera: '1.74',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 19',
  'Google Chrome': '48.39',
  'Internet Explorer': '21.5',
  Firefox: '19',
  Safari: '9.23',
  'Microsoft Edge': '0.11',
  Opera: '1.7',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 20',
  'Google Chrome': '48.32',
  'Internet Explorer': '23.91',
  Firefox: '18.62',
  Safari: '7.68',
  'Microsoft Edge': '0.09',
  Opera: '1.32',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 21',
  'Google Chrome': '47.81',
  'Internet Explorer': '24.98',
  Firefox: '18.34',
  Safari: '7.52',
  'Microsoft Edge': '0.08',
  Opera: '1.2',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 22',
  'Google Chrome': '48.28',
  'Internet Explorer': '24.4',
  Firefox: '18.45',
  Safari: '7.44',
  'Microsoft Edge': '0.08',
  Opera: '1.29',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 23',
  'Google Chrome': '48.41',
  'Internet Explorer': '24.2',
  Firefox: '18.57',
  Safari: '7.35',
  'Microsoft Edge': '0.08',
  Opera: '1.31',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 24',
  'Google Chrome': '48.22',
  'Internet Explorer': '23.96',
  Firefox: '18.67',
  Safari: '7.55',
  'Microsoft Edge': '0.1',
  Opera: '1.42',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 25',
  'Google Chrome': '48.11',
  'Internet Explorer': '21.86',
  Firefox: '19.28',
  Safari: '8.88',
  'Microsoft Edge': '0.1',
  Opera: '1.65',
  Mozilla: '0.08',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 26',
  'Google Chrome': '48.27',
  'Internet Explorer': '21.57',
  Firefox: '19',
  Safari: '9.38',
  'Microsoft Edge': '0.11',
  Opera: '1.59',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 27',
  'Google Chrome': '48.5',
  'Internet Explorer': '23.72',
  Firefox: '18.59',
  Safari: '7.76',
  'Microsoft Edge': '0.1',
  Opera: '1.27',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Jul 28',
  'Google Chrome': '48.48',
  'Internet Explorer': '23.95',
  Firefox: '18.46',
  Safari: '7.61',
  'Microsoft Edge': '0.12',
  Opera: '1.31',
  Mozilla: '0.07',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 29',
  'Google Chrome': '48.33',
  'Internet Explorer': '23.77',
  Firefox: '18.56',
  Safari: '7.51',
  'Microsoft Edge': '0.42',
  Opera: '1.33',
  Mozilla: '0.06',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 30',
  'Google Chrome': '47.8',
  'Internet Explorer': '24.06',
  Firefox: '18.6',
  Safari: '7.46',
  'Microsoft Edge': '0.7',
  Opera: '1.3',
  Mozilla: '0.07',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Jul 31',
  'Google Chrome': '48.41',
  'Internet Explorer': '22.9',
  Firefox: '18.88',
  Safari: '7.48',
  'Microsoft Edge': '0.84',
  Opera: '1.41',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 1',
  'Google Chrome': '48.8',
  'Internet Explorer': '20.29',
  Firefox: '19.16',
  Safari: '8.75',
  'Microsoft Edge': '1.16',
  Opera: '1.75',
  Mozilla: '0.07',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 2',
  'Google Chrome': '48.95',
  'Internet Explorer': '20.27',
  Firefox: '18.81',
  Safari: '9',
  'Microsoft Edge': '1.23',
  Opera: '1.65',
  Mozilla: '0.08',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 3',
  'Google Chrome': '49.07',
  'Internet Explorer': '22.67',
  Firefox: '18.35',
  Safari: '7.59',
  'Microsoft Edge': '0.93',
  Opera: '1.31',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 4',
  'Google Chrome': '49.18',
  'Internet Explorer': '22.72',
  Firefox: '18.31',
  Safari: '7.44',
  'Microsoft Edge': '0.95',
  Opera: '1.32',
  Mozilla: '0.07',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 5',
  'Google Chrome': '49.56',
  'Internet Explorer': '22.37',
  Firefox: '18.28',
  Safari: '7.38',
  'Microsoft Edge': '0.99',
  Opera: '1.34',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 6',
  'Google Chrome': '49.77',
  'Internet Explorer': '21.81',
  Firefox: '18.28',
  Safari: '7.67',
  'Microsoft Edge': '1.12',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 7',
  'Google Chrome': '48.73',
  'Internet Explorer': '22.63',
  Firefox: '18.42',
  Safari: '7.5',
  'Microsoft Edge': '1.26',
  Opera: '1.39',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 8',
  'Google Chrome': '49.6',
  'Internet Explorer': '18.97',
  Firefox: '19.11',
  Safari: '8.79',
  'Microsoft Edge': '1.69',
  Opera: '1.74',
  Mozilla: '0.09',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 9',
  'Google Chrome': '49.68',
  'Internet Explorer': '18.85',
  Firefox: '18.71',
  Safari: '9.23',
  'Microsoft Edge': '1.72',
  Opera: '1.72',
  Mozilla: '0.08',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 10',
  'Google Chrome': '49.11',
  'Internet Explorer': '22.54',
  Firefox: '17.97',
  Safari: '7.64',
  'Microsoft Edge': '1.28',
  Opera: '1.39',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 11',
  'Google Chrome': '49.21',
  'Internet Explorer': '22.59',
  Firefox: '17.96',
  Safari: '7.56',
  'Microsoft Edge': '1.27',
  Opera: '1.35',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 12',
  'Google Chrome': '48.95',
  'Internet Explorer': '22.68',
  Firefox: '18.21',
  Safari: '7.44',
  'Microsoft Edge': '1.3',
  Opera: '1.35',
  Mozilla: '0.06',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 13',
  'Google Chrome': '49.31',
  'Internet Explorer': '22.28',
  Firefox: '18.19',
  Safari: '7.32',
  'Microsoft Edge': '1.31',
  Opera: '1.51',
  Mozilla: '0.06',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 14',
  'Google Chrome': '49.08',
  'Internet Explorer': '21.98',
  Firefox: '18.38',
  Safari: '7.47',
  'Microsoft Edge': '1.43',
  Opera: '1.56',
  Mozilla: '0.07',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 15',
  'Google Chrome': '49.1',
  'Internet Explorer': '19.47',
  Firefox: '18.77',
  Safari: '8.85',
  'Microsoft Edge': '1.87',
  Opera: '1.86',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 16',
  'Google Chrome': '49.5',
  'Internet Explorer': '19.33',
  Firefox: '18.42',
  Safari: '9.12',
  'Microsoft Edge': '1.83',
  Opera: '1.72',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 17',
  'Google Chrome': '49.42',
  'Internet Explorer': '22.12',
  Firefox: '18.06',
  Safari: '7.5',
  'Microsoft Edge': '1.36',
  Opera: '1.44',
  Mozilla: '0.08',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 18',
  'Google Chrome': '49.46',
  'Internet Explorer': '22.16',
  Firefox: '18.05',
  Safari: '7.43',
  'Microsoft Edge': '1.41',
  Opera: '1.41',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 19',
  'Google Chrome': '49.51',
  'Internet Explorer': '22.21',
  Firefox: '17.93',
  Safari: '7.46',
  'Microsoft Edge': '1.39',
  Opera: '1.42',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 20',
  'Google Chrome': '49.43',
  'Internet Explorer': '22.38',
  Firefox: '17.91',
  Safari: '7.31',
  'Microsoft Edge': '1.42',
  Opera: '1.47',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 21',
  'Google Chrome': '49.44',
  'Internet Explorer': '21.79',
  Firefox: '18.3',
  Safari: '7.39',
  'Microsoft Edge': '1.51',
  Opera: '1.47',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 22',
  'Google Chrome': '49.79',
  'Internet Explorer': '19.29',
  Firefox: '18.51',
  Safari: '8.67',
  'Microsoft Edge': '1.91',
  Opera: '1.74',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 23',
  'Google Chrome': '50.12',
  'Internet Explorer': '18.91',
  Firefox: '18.1',
  Safari: '9.11',
  'Microsoft Edge': '1.89',
  Opera: '1.8',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 24',
  'Google Chrome': '49.34',
  'Internet Explorer': '22.2',
  Firefox: '18.01',
  Safari: '7.62',
  'Microsoft Edge': '1.48',
  Opera: '1.29',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Aug 25',
  'Google Chrome': '49.21',
  'Internet Explorer': '22.51',
  Firefox: '17.91',
  Safari: '7.47',
  'Microsoft Edge': '1.47',
  Opera: '1.38',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 26',
  'Google Chrome': '49.06',
  'Internet Explorer': '22.58',
  Firefox: '17.92',
  Safari: '7.52',
  'Microsoft Edge': '1.47',
  Opera: '1.39',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 27',
  'Google Chrome': '48.89',
  'Internet Explorer': '22.63',
  Firefox: '17.98',
  Safari: '7.57',
  'Microsoft Edge': '1.51',
  Opera: '1.35',
  Mozilla: '0.06',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Aug 28',
  'Google Chrome': '48.69',
  'Internet Explorer': '22.44',
  Firefox: '18.2',
  Safari: '7.56',
  'Microsoft Edge': '1.61',
  Opera: '1.43',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 29',
  'Google Chrome': '48.64',
  'Internet Explorer': '19.87',
  Firefox: '18.43',
  Safari: '9.16',
  'Microsoft Edge': '2.07',
  Opera: '1.74',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 30',
  'Google Chrome': '49.72',
  'Internet Explorer': '18.84',
  Firefox: '17.88',
  Safari: '9.76',
  'Microsoft Edge': '2.03',
  Opera: '1.69',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Aug 31',
  'Google Chrome': '49.43',
  'Internet Explorer': '21.94',
  Firefox: '17.82',
  Safari: '7.87',
  'Microsoft Edge': '1.57',
  Opera: '1.31',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 1',
  'Google Chrome': '49.65',
  'Internet Explorer': '21.91',
  Firefox: '17.95',
  Safari: '7.52',
  'Microsoft Edge': '1.52',
  Opera: '1.39',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 2',
  'Google Chrome': '49.73',
  'Internet Explorer': '21.85',
  Firefox: '18.02',
  Safari: '7.49',
  'Microsoft Edge': '1.53',
  Opera: '1.3',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 3',
  'Google Chrome': '49.59',
  'Internet Explorer': '21.97',
  Firefox: '17.88',
  Safari: '7.6',
  'Microsoft Edge': '1.58',
  Opera: '1.31',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 4',
  'Google Chrome': '49.52',
  'Internet Explorer': '21.64',
  Firefox: '18.06',
  Safari: '7.62',
  'Microsoft Edge': '1.67',
  Opera: '1.41',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 5',
  'Google Chrome': '50.28',
  'Internet Explorer': '18.93',
  Firefox: '18.19',
  Safari: '8.71',
  'Microsoft Edge': '2.13',
  Opera: '1.69',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 6',
  'Google Chrome': '50.25',
  'Internet Explorer': '18.67',
  Firefox: '18.2',
  Safari: '9.04',
  'Microsoft Edge': '2.09',
  Opera: '1.67',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 7',
  'Google Chrome': '49.83',
  'Internet Explorer': '19.8',
  Firefox: '18.39',
  Safari: '8.63',
  'Microsoft Edge': '1.86',
  Opera: '1.43',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 8',
  'Google Chrome': '50',
  'Internet Explorer': '21.8',
  Firefox: '17.62',
  Safari: '7.66',
  'Microsoft Edge': '1.55',
  Opera: '1.31',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 9',
  'Google Chrome': '49.81',
  'Internet Explorer': '21.89',
  Firefox: '17.58',
  Safari: '7.83',
  'Microsoft Edge': '1.59',
  Opera: '1.25',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 10',
  'Google Chrome': '49.65',
  'Internet Explorer': '21.93',
  Firefox: '17.74',
  Safari: '7.82',
  'Microsoft Edge': '1.6',
  Opera: '1.19',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 11',
  'Google Chrome': '49.75',
  'Internet Explorer': '21.71',
  Firefox: '17.88',
  Safari: '7.64',
  'Microsoft Edge': '1.67',
  Opera: '1.29',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 12',
  'Google Chrome': '49.86',
  'Internet Explorer': '19.04',
  Firefox: '17.96',
  Safari: '9.3',
  'Microsoft Edge': '2.21',
  Opera: '1.56',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 13',
  'Google Chrome': '50.1',
  'Internet Explorer': '18.71',
  Firefox: '17.76',
  Safari: '9.69',
  'Microsoft Edge': '2.19',
  Opera: '1.49',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 14',
  'Google Chrome': '49.91',
  'Internet Explorer': '21.55',
  Firefox: '17.87',
  Safari: '7.74',
  'Microsoft Edge': '1.66',
  Opera: '1.21',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 15',
  'Google Chrome': '50.1',
  'Internet Explorer': '21.34',
  Firefox: '17.96',
  Safari: '7.63',
  'Microsoft Edge': '1.66',
  Opera: '1.25',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 16',
  'Google Chrome': '50.6',
  'Internet Explorer': '21.53',
  Firefox: '17.44',
  Safari: '7.56',
  'Microsoft Edge': '1.59',
  Opera: '1.23',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 17',
  'Google Chrome': '50.59',
  'Internet Explorer': '21.59',
  Firefox: '17.55',
  Safari: '7.37',
  'Microsoft Edge': '1.6',
  Opera: '1.24',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 18',
  'Google Chrome': '50.57',
  'Internet Explorer': '21.75',
  Firefox: '17.43',
  Safari: '7.17',
  'Microsoft Edge': '1.7',
  Opera: '1.32',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Sep 19',
  'Google Chrome': '51.33',
  'Internet Explorer': '18.77',
  Firefox: '17.63',
  Safari: '8.37',
  'Microsoft Edge': '2.17',
  Opera: '1.66',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 20',
  'Google Chrome': '51.41',
  'Internet Explorer': '18.15',
  Firefox: '17.55',
  Safari: '9.09',
  'Microsoft Edge': '2.17',
  Opera: '1.58',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 21',
  'Google Chrome': '50.76',
  'Internet Explorer': '21.38',
  Firefox: '17.41',
  Safari: '7.52',
  'Microsoft Edge': '1.67',
  Opera: '1.22',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 22',
  'Google Chrome': '50.6',
  'Internet Explorer': '21.48',
  Firefox: '17.55',
  Safari: '7.41',
  'Microsoft Edge': '1.7',
  Opera: '1.22',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Sep 23',
  'Google Chrome': '50.56',
  'Internet Explorer': '21.5',
  Firefox: '17.52',
  Safari: '7.42',
  'Microsoft Edge': '1.71',
  Opera: '1.25',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Sep 24',
  'Google Chrome': '50.66',
  'Internet Explorer': '21.34',
  Firefox: '17.52',
  Safari: '7.45',
  'Microsoft Edge': '1.7',
  Opera: '1.29',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Sep 25',
  'Google Chrome': '50.87',
  'Internet Explorer': '20.84',
  Firefox: '17.84',
  Safari: '7.24',
  'Microsoft Edge': '1.78',
  Opera: '1.39',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 26',
  'Google Chrome': '51.66',
  'Internet Explorer': '17.77',
  Firefox: '18.01',
  Safari: '8.52',
  'Microsoft Edge': '2.28',
  Opera: '1.71',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 27',
  'Google Chrome': '51.99',
  'Internet Explorer': '17.24',
  Firefox: '17.71',
  Safari: '9.17',
  'Microsoft Edge': '2.25',
  Opera: '1.6',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Sep 28',
  'Google Chrome': '50.77',
  'Internet Explorer': '21.23',
  Firefox: '17.52',
  Safari: '7.49',
  'Microsoft Edge': '1.73',
  Opera: '1.22',
  Mozilla: '0.03',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 29',
  'Google Chrome': '50.75',
  'Internet Explorer': '21.39',
  Firefox: '17.47',
  Safari: '7.38',
  'Microsoft Edge': '1.74',
  Opera: '1.22',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Sep 30',
  'Google Chrome': '50.8',
  'Internet Explorer': '21.34',
  Firefox: '17.4',
  Safari: '7.46',
  'Microsoft Edge': '1.74',
  Opera: '1.23',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 1',
  'Google Chrome': '50.82',
  'Internet Explorer': '21.39',
  Firefox: '17.19',
  Safari: '7.55',
  'Microsoft Edge': '1.78',
  Opera: '1.24',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 2',
  'Google Chrome': '50.93',
  'Internet Explorer': '21.17',
  Firefox: '17.32',
  Safari: '7.38',
  'Microsoft Edge': '1.86',
  Opera: '1.32',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 3',
  'Google Chrome': '51.69',
  'Internet Explorer': '18.12',
  Firefox: '17.51',
  Safari: '8.61',
  'Microsoft Edge': '2.34',
  Opera: '1.68',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 4',
  'Google Chrome': '52.06',
  'Internet Explorer': '17.59',
  Firefox: '17.18',
  Safari: '9.25',
  'Microsoft Edge': '2.32',
  Opera: '1.58',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 5',
  'Google Chrome': '51.4',
  'Internet Explorer': '20.73',
  Firefox: '17.24',
  Safari: '7.56',
  'Microsoft Edge': '1.81',
  Opera: '1.22',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 6',
  'Google Chrome': '51.81',
  'Internet Explorer': '20.35',
  Firefox: '17.31',
  Safari: '7.46',
  'Microsoft Edge': '1.79',
  Opera: '1.25',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 7',
  'Google Chrome': '51.98',
  'Internet Explorer': '20.18',
  Firefox: '17.29',
  Safari: '7.49',
  'Microsoft Edge': '1.76',
  Opera: '1.27',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 8',
  'Google Chrome': '50.97',
  'Internet Explorer': '20.56',
  Firefox: '17.72',
  Safari: '7.63',
  'Microsoft Edge': '1.79',
  Opera: '1.3',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 9',
  'Google Chrome': '50.94',
  'Internet Explorer': '20.42',
  Firefox: '17.8',
  Safari: '7.52',
  'Microsoft Edge': '1.88',
  Opera: '1.4',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 10',
  'Google Chrome': '51.02',
  'Internet Explorer': '17.74',
  Firefox: '18.26',
  Safari: '8.79',
  'Microsoft Edge': '2.38',
  Opera: '1.75',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 11',
  'Google Chrome': '52.07',
  'Internet Explorer': '16.83',
  Firefox: '17.77',
  Safari: '9.23',
  'Microsoft Edge': '2.32',
  Opera: '1.72',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Oct 12',
  'Google Chrome': '50.9',
  'Internet Explorer': '19.94',
  Firefox: '17.55',
  Safari: '8.27',
  'Microsoft Edge': '1.94',
  Opera: '1.35',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Oct 13',
  'Google Chrome': '51.52',
  'Internet Explorer': '19.66',
  Firefox: '17.71',
  Safari: '7.76',
  'Microsoft Edge': '1.78',
  Opera: '1.51',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Oct 14',
  'Google Chrome': '51.75',
  'Internet Explorer': '19.37',
  Firefox: '17.85',
  Safari: '7.72',
  'Microsoft Edge': '1.82',
  Opera: '1.44',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 15',
  'Google Chrome': '51.37',
  'Internet Explorer': '19.66',
  Firefox: '17.92',
  Safari: '7.68',
  'Microsoft Edge': '1.87',
  Opera: '1.46',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 16',
  'Google Chrome': '51.29',
  'Internet Explorer': '19.56',
  Firefox: '18.06',
  Safari: '7.62',
  'Microsoft Edge': '1.91',
  Opera: '1.52',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 17',
  'Google Chrome': '52.47',
  'Internet Explorer': '15.8',
  Firefox: '18.39',
  Safari: '8.96',
  'Microsoft Edge': '2.46',
  Opera: '1.88',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 18',
  'Google Chrome': '51.88',
  'Internet Explorer': '16.03',
  Firefox: '18.07',
  Safari: '9.75',
  'Microsoft Edge': '2.42',
  Opera: '1.79',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 19',
  'Google Chrome': '51.48',
  'Internet Explorer': '19.69',
  Firefox: '17.68',
  Safari: '7.87',
  'Microsoft Edge': '1.83',
  Opera: '1.41',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 20',
  'Google Chrome': '51.58',
  'Internet Explorer': '19.73',
  Firefox: '17.63',
  Safari: '7.85',
  'Microsoft Edge': '1.8',
  Opera: '1.38',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 21',
  'Google Chrome': '52.04',
  'Internet Explorer': '20.14',
  Firefox: '16.99',
  Safari: '7.63',
  'Microsoft Edge': '1.81',
  Opera: '1.34',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 22',
  'Google Chrome': '51.62',
  'Internet Explorer': '20.1',
  Firefox: '17.28',
  Safari: '7.75',
  'Microsoft Edge': '1.86',
  Opera: '1.35',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 23',
  'Google Chrome': '51.87',
  'Internet Explorer': '19.88',
  Firefox: '17.17',
  Safari: '7.64',
  'Microsoft Edge': '1.94',
  Opera: '1.45',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Oct 24',
  'Google Chrome': '52.62',
  'Internet Explorer': '16.25',
  Firefox: '17.52',
  Safari: '9.28',
  'Microsoft Edge': '2.5',
  Opera: '1.78',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 25',
  'Google Chrome': '52.64',
  'Internet Explorer': '16.1',
  Firefox: '17.4',
  Safari: '9.69',
  'Microsoft Edge': '2.46',
  Opera: '1.67',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Oct 26',
  'Google Chrome': '52.29',
  'Internet Explorer': '19.72',
  Firefox: '17',
  Safari: '7.81',
  'Microsoft Edge': '1.88',
  Opera: '1.26',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 27',
  'Google Chrome': '51.88',
  'Internet Explorer': '20.08',
  Firefox: '17.1',
  Safari: '7.73',
  'Microsoft Edge': '1.87',
  Opera: '1.3',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 28',
  'Google Chrome': '51.92',
  'Internet Explorer': '19.48',
  Firefox: '17.49',
  Safari: '7.86',
  'Microsoft Edge': '1.93',
  Opera: '1.28',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 29',
  'Google Chrome': '51.56',
  'Internet Explorer': '19.74',
  Firefox: '17.83',
  Safari: '7.64',
  'Microsoft Edge': '1.9',
  Opera: '1.31',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 30',
  'Google Chrome': '51.8',
  'Internet Explorer': '19.42',
  Firefox: '17.86',
  Safari: '7.5',
  'Microsoft Edge': '1.99',
  Opera: '1.38',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2015 Oct 31',
  'Google Chrome': '52.67',
  'Internet Explorer': '16.22',
  Firefox: '18.22',
  Safari: '8.62',
  'Microsoft Edge': '2.46',
  Opera: '1.76',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 1',
  'Google Chrome': '52.4',
  'Internet Explorer': '15.92',
  Firefox: '17.77',
  Safari: '9.7',
  'Microsoft Edge': '2.48',
  Opera: '1.62',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 2',
  'Google Chrome': '51.9',
  'Internet Explorer': '19.56',
  Firefox: '17.26',
  Safari: '7.93',
  'Microsoft Edge': '1.96',
  Opera: '1.32',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 3',
  'Google Chrome': '51.95',
  'Internet Explorer': '19.83',
  Firefox: '17.41',
  Safari: '7.53',
  'Microsoft Edge': '1.89',
  Opera: '1.33',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 4',
  'Google Chrome': '52.25',
  'Internet Explorer': '19.61',
  Firefox: '17.24',
  Safari: '7.57',
  'Microsoft Edge': '1.83',
  Opera: '1.44',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 5',
  'Google Chrome': '51.98',
  'Internet Explorer': '19.9',
  Firefox: '17.2',
  Safari: '7.63',
  'Microsoft Edge': '1.87',
  Opera: '1.35',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 6',
  'Google Chrome': '51.38',
  'Internet Explorer': '20.09',
  Firefox: '17.39',
  Safari: '7.74',
  'Microsoft Edge': '1.97',
  Opera: '1.36',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 7',
  'Google Chrome': '52.45',
  'Internet Explorer': '16.46',
  Firefox: '17.38',
  Safari: '9.32',
  'Microsoft Edge': '2.6',
  Opera: '1.7',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Nov 8',
  'Google Chrome': '52.61',
  'Internet Explorer': '16.12',
  Firefox: '16.97',
  Safari: '9.97',
  'Microsoft Edge': '2.55',
  Opera: '1.69',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Nov 9',
  'Google Chrome': '51.65',
  'Internet Explorer': '20.18',
  Firefox: '16.67',
  Safari: '8.21',
  'Microsoft Edge': '1.96',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 10',
  'Google Chrome': '51.95',
  'Internet Explorer': '19.99',
  Firefox: '16.46',
  Safari: '8.29',
  'Microsoft Edge': '1.95',
  Opera: '1.29',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Nov 11',
  'Google Chrome': '52.74',
  'Internet Explorer': '18.91',
  Firefox: '16.38',
  Safari: '8.49',
  'Microsoft Edge': '2.04',
  Opera: '1.37',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Nov 12',
  'Google Chrome': '52.16',
  'Internet Explorer': '19.88',
  Firefox: '16.54',
  Safari: '8.03',
  'Microsoft Edge': '1.99',
  Opera: '1.35',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 13',
  'Google Chrome': '52.17',
  'Internet Explorer': '19.7',
  Firefox: '16.65',
  Safari: '7.98',
  'Microsoft Edge': '2.09',
  Opera: '1.35',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 14',
  'Google Chrome': '52.81',
  'Internet Explorer': '16.25',
  Firefox: '17.02',
  Safari: '9.53',
  'Microsoft Edge': '2.71',
  Opera: '1.62',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 15',
  'Google Chrome': '52.89',
  'Internet Explorer': '15.65',
  Firefox: '16.97',
  Safari: '10.25',
  'Microsoft Edge': '2.62',
  Opera: '1.56',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 16',
  'Google Chrome': '52.68',
  'Internet Explorer': '19.59',
  Firefox: '16.23',
  Safari: '8.22',
  'Microsoft Edge': '2',
  Opera: '1.24',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 17',
  'Google Chrome': '52.6',
  'Internet Explorer': '19.62',
  Firefox: '16.38',
  Safari: '8.12',
  'Microsoft Edge': '1.96',
  Opera: '1.28',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 18',
  'Google Chrome': '52.35',
  'Internet Explorer': '19.79',
  Firefox: '16.39',
  Safari: '8.12',
  'Microsoft Edge': '1.99',
  Opera: '1.33',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 19',
  'Google Chrome': '52.37',
  'Internet Explorer': '19.81',
  Firefox: '16.46',
  Safari: '8',
  'Microsoft Edge': '2',
  Opera: '1.31',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 20',
  'Google Chrome': '52.2',
  'Internet Explorer': '19.55',
  Firefox: '16.74',
  Safari: '7.96',
  'Microsoft Edge': '2.11',
  Opera: '1.39',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 21',
  'Google Chrome': '52.7',
  'Internet Explorer': '16.03',
  Firefox: '17.04',
  Safari: '9.83',
  'Microsoft Edge': '2.72',
  Opera: '1.62',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 22',
  'Google Chrome': '52.72',
  'Internet Explorer': '15.75',
  Firefox: '16.9',
  Safari: '10.36',
  'Microsoft Edge': '2.68',
  Opera: '1.54',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 23',
  'Google Chrome': '52.35',
  'Internet Explorer': '19.53',
  Firefox: '16.53',
  Safari: '8.21',
  'Microsoft Edge': '2.04',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 24',
  'Google Chrome': '52.33',
  'Internet Explorer': '19.53',
  Firefox: '16.75',
  Safari: '7.96',
  'Microsoft Edge': '2.03',
  Opera: '1.34',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 25',
  'Google Chrome': '52.34',
  'Internet Explorer': '19.04',
  Firefox: '17.02',
  Safari: '7.82',
  'Microsoft Edge': '2.07',
  Opera: '1.64',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 26',
  'Google Chrome': '53.29',
  'Internet Explorer': '17.12',
  Firefox: '17.42',
  Safari: '8.12',
  'Microsoft Edge': '2.27',
  Opera: '1.7',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 27',
  'Google Chrome': '52.46',
  'Internet Explorer': '17.83',
  Firefox: '17.12',
  Safari: '8.58',
  'Microsoft Edge': '2.49',
  Opera: '1.46',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 28',
  'Google Chrome': '52.84',
  'Internet Explorer': '15.74',
  Firefox: '17.03',
  Safari: '9.7',
  'Microsoft Edge': '2.97',
  Opera: '1.67',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 29',
  'Google Chrome': '52.8',
  'Internet Explorer': '15.57',
  Firefox: '16.72',
  Safari: '10.32',
  'Microsoft Edge': '2.91',
  Opera: '1.63',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Nov 30',
  'Google Chrome': '52.71',
  'Internet Explorer': '19.08',
  Firefox: '16.21',
  Safari: '8.49',
  'Microsoft Edge': '2.22',
  Opera: '1.24',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 1',
  'Google Chrome': '52.41',
  'Internet Explorer': '19.62',
  Firefox: '16.28',
  Safari: '8.11',
  'Microsoft Edge': '2.25',
  Opera: '1.29',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 2',
  'Google Chrome': '52.64',
  'Internet Explorer': '19.41',
  Firefox: '16.18',
  Safari: '8.1',
  'Microsoft Edge': '2.31',
  Opera: '1.31',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 3',
  'Google Chrome': '52.37',
  'Internet Explorer': '19.3',
  Firefox: '16.4',
  Safari: '8.23',
  'Microsoft Edge': '2.31',
  Opera: '1.35',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 4',
  'Google Chrome': '52.15',
  'Internet Explorer': '19.2',
  Firefox: '16.72',
  Safari: '7.98',
  'Microsoft Edge': '2.46',
  Opera: '1.44',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 5',
  'Google Chrome': '52.15',
  'Internet Explorer': '15.77',
  Firefox: '17.33',
  Safari: '9.82',
  'Microsoft Edge': '3.18',
  Opera: '1.68',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 6',
  'Google Chrome': '52.92',
  'Internet Explorer': '15.33',
  Firefox: '16.65',
  Safari: '10.31',
  'Microsoft Edge': '3.06',
  Opera: '1.67',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 7',
  'Google Chrome': '52.59',
  'Internet Explorer': '19.15',
  Firefox: '16.25',
  Safari: '8.36',
  'Microsoft Edge': '2.34',
  Opera: '1.26',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 8',
  'Google Chrome': '52.57',
  'Internet Explorer': '19.12',
  Firefox: '16.38',
  Safari: '8.21',
  'Microsoft Edge': '2.38',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 9',
  'Google Chrome': '52.47',
  'Internet Explorer': '19.47',
  Firefox: '16.41',
  Safari: '7.98',
  'Microsoft Edge': '2.31',
  Opera: '1.3',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 10',
  'Google Chrome': '52.22',
  'Internet Explorer': '20',
  Firefox: '16.4',
  Safari: '7.73',
  'Microsoft Edge': '2.35',
  Opera: '1.25',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 11',
  'Google Chrome': '51.97',
  'Internet Explorer': '19.54',
  Firefox: '16.69',
  Safari: '7.91',
  'Microsoft Edge': '2.49',
  Opera: '1.34',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 12',
  'Google Chrome': '52.03',
  'Internet Explorer': '16.49',
  Firefox: '16.84',
  Safari: '9.67',
  'Microsoft Edge': '3.18',
  Opera: '1.68',
  Mozilla: '0.1',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 13',
  'Google Chrome': '52.17',
  'Internet Explorer': '16.22',
  Firefox: '16.61',
  Safari: '10.18',
  'Microsoft Edge': '3.16',
  Opera: '1.57',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 14',
  'Google Chrome': '51.48',
  'Internet Explorer': '20.71',
  Firefox: '16.04',
  Safari: '8.12',
  'Microsoft Edge': '2.39',
  Opera: '1.21',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 15',
  'Google Chrome': '51.64',
  'Internet Explorer': '20.54',
  Firefox: '16.11',
  Safari: '8.05',
  'Microsoft Edge': '2.37',
  Opera: '1.23',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 16',
  'Google Chrome': '51.32',
  'Internet Explorer': '21.04',
  Firefox: '16.04',
  Safari: '7.9',
  'Microsoft Edge': '2.45',
  Opera: '1.2',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 17',
  'Google Chrome': '51.03',
  'Internet Explorer': '21.29',
  Firefox: '16.13',
  Safari: '7.77',
  'Microsoft Edge': '2.46',
  Opera: '1.25',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 18',
  'Google Chrome': '50.9',
  'Internet Explorer': '20.71',
  Firefox: '16.59',
  Safari: '7.73',
  'Microsoft Edge': '2.6',
  Opera: '1.38',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 19',
  'Google Chrome': '51.36',
  'Internet Explorer': '17.02',
  Firefox: '17.13',
  Safari: '9.36',
  'Microsoft Edge': '3.29',
  Opera: '1.75',
  Mozilla: '0.09',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 20',
  'Google Chrome': '52.24',
  'Internet Explorer': '16.39',
  Firefox: '17.18',
  Safari: '9.39',
  'Microsoft Edge': '3.13',
  Opera: '1.58',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 21',
  'Google Chrome': '51.44',
  'Internet Explorer': '20.62',
  Firefox: '16.64',
  Safari: '7.45',
  'Microsoft Edge': '2.51',
  Opera: '1.28',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 22',
  'Google Chrome': '51.44',
  'Internet Explorer': '20.64',
  Firefox: '16.72',
  Safari: '7.23',
  'Microsoft Edge': '2.58',
  Opera: '1.33',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 23',
  'Google Chrome': '50.69',
  'Internet Explorer': '21.15',
  Firefox: '16.69',
  Safari: '7.24',
  'Microsoft Edge': '2.7',
  Opera: '1.46',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 24',
  'Google Chrome': '50.13',
  'Internet Explorer': '20.14',
  Firefox: '16.68',
  Safari: '8',
  'Microsoft Edge': '3.1',
  Opera: '1.85',
  Mozilla: '0.08',
  'Other/Unknown': '0.02'
}, {
  date: '2015 Dec 25',
  'Google Chrome': '50.55',
  'Internet Explorer': '17.4',
  Firefox: '16.92',
  Safari: '9.19',
  'Microsoft Edge': '3.73',
  Opera: '2.1',
  Mozilla: '0.09',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 26',
  'Google Chrome': '50.12',
  'Internet Explorer': '17.8',
  Firefox: '16.92',
  Safari: '9.44',
  'Microsoft Edge': '3.72',
  Opera: '1.9',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 27',
  'Google Chrome': '50.68',
  'Internet Explorer': '17.25',
  Firefox: '16.89',
  Safari: '9.55',
  'Microsoft Edge': '3.73',
  Opera: '1.81',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2015 Dec 28',
  'Google Chrome': '49.89',
  'Internet Explorer': '21.09',
  Firefox: '16.22',
  Safari: '8.13',
  'Microsoft Edge': '3.21',
  Opera: '1.39',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 29',
  'Google Chrome': '50.27',
  'Internet Explorer': '20.86',
  Firefox: '16.25',
  Safari: '7.95',
  'Microsoft Edge': '3.22',
  Opera: '1.37',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 30',
  'Google Chrome': '49.85',
  'Internet Explorer': '21.28',
  Firefox: '16.26',
  Safari: '7.87',
  'Microsoft Edge': '3.29',
  Opera: '1.37',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2015 Dec 31',
  'Google Chrome': '49.4',
  'Internet Explorer': '20.41',
  Firefox: '16.43',
  Safari: '8.52',
  'Microsoft Edge': '3.57',
  Opera: '1.59',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 1',
  'Google Chrome': '50.07',
  'Internet Explorer': '16.61',
  Firefox: '17.36',
  Safari: '10.09',
  'Microsoft Edge': '4.01',
  Opera: '1.76',
  Mozilla: '0.09',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 2',
  'Google Chrome': '50.72',
  'Internet Explorer': '16.66',
  Firefox: '17.22',
  Safari: '9.67',
  'Microsoft Edge': '3.91',
  Opera: '1.74',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 3',
  'Google Chrome': '51.23',
  'Internet Explorer': '16.46',
  Firefox: '16.95',
  Safari: '9.87',
  'Microsoft Edge': '3.75',
  Opera: '1.67',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 4',
  'Google Chrome': '51.26',
  'Internet Explorer': '20.36',
  Firefox: '16.35',
  Safari: '7.84',
  'Microsoft Edge': '2.85',
  Opera: '1.29',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 5',
  'Google Chrome': '51.32',
  'Internet Explorer': '20.21',
  Firefox: '16.35',
  Safari: '7.89',
  'Microsoft Edge': '2.79',
  Opera: '1.36',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 6',
  'Google Chrome': '51.81',
  'Internet Explorer': '19.86',
  Firefox: '16.2',
  Safari: '7.93',
  'Microsoft Edge': '2.76',
  Opera: '1.38',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 7',
  'Google Chrome': '51.85',
  'Internet Explorer': '19.82',
  Firefox: '16.31',
  Safari: '7.81',
  'Microsoft Edge': '2.76',
  Opera: '1.4',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 8',
  'Google Chrome': '50.99',
  'Internet Explorer': '20.36',
  Firefox: '16.55',
  Safari: '7.64',
  'Microsoft Edge': '2.9',
  Opera: '1.49',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 9',
  'Google Chrome': '51.5',
  'Internet Explorer': '16.58',
  Firefox: '17.03',
  Safari: '9.38',
  'Microsoft Edge': '3.57',
  Opera: '1.86',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 10',
  'Google Chrome': '51.88',
  'Internet Explorer': '15.91',
  Firefox: '17',
  Safari: '9.79',
  'Microsoft Edge': '3.52',
  Opera: '1.81',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 11',
  'Google Chrome': '51.91',
  'Internet Explorer': '19.73',
  Firefox: '16.3',
  Safari: '7.93',
  'Microsoft Edge': '2.72',
  Opera: '1.37',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 12',
  'Google Chrome': '51.99',
  'Internet Explorer': '19.63',
  Firefox: '16.35',
  Safari: '7.84',
  'Microsoft Edge': '2.74',
  Opera: '1.39',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 13',
  'Google Chrome': '52.31',
  'Internet Explorer': '19.26',
  Firefox: '16.25',
  Safari: '7.95',
  'Microsoft Edge': '2.85',
  Opera: '1.33',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 14',
  'Google Chrome': '52.07',
  'Internet Explorer': '19.64',
  Firefox: '16.1',
  Safari: '7.95',
  'Microsoft Edge': '2.87',
  Opera: '1.32',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 15',
  'Google Chrome': '52.21',
  'Internet Explorer': '18.83',
  Firefox: '16.42',
  Safari: '7.98',
  'Microsoft Edge': '3.04',
  Opera: '1.46',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 16',
  'Google Chrome': '52.65',
  'Internet Explorer': '15.51',
  Firefox: '16.86',
  Safari: '9.5',
  'Microsoft Edge': '3.66',
  Opera: '1.75',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 17',
  'Google Chrome': '52.48',
  'Internet Explorer': '15.69',
  Firefox: '16.61',
  Safari: '9.84',
  'Microsoft Edge': '3.66',
  Opera: '1.66',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 18',
  'Google Chrome': '52.07',
  'Internet Explorer': '18.91',
  Firefox: '16.31',
  Safari: '8.36',
  'Microsoft Edge': '3',
  Opera: '1.3',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 19',
  'Google Chrome': '52.51',
  'Internet Explorer': '19.48',
  Firefox: '16.08',
  Safari: '7.91',
  'Microsoft Edge': '2.72',
  Opera: '1.25',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 20',
  'Google Chrome': '52.82',
  'Internet Explorer': '19.01',
  Firefox: '16.14',
  Safari: '7.97',
  'Microsoft Edge': '2.76',
  Opera: '1.25',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 21',
  'Google Chrome': '52.76',
  'Internet Explorer': '19.26',
  Firefox: '16.12',
  Safari: '7.79',
  'Microsoft Edge': '2.74',
  Opera: '1.3',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 22',
  'Google Chrome': '52.56',
  'Internet Explorer': '18.8',
  Firefox: '16.33',
  Safari: '7.9',
  'Microsoft Edge': '2.95',
  Opera: '1.4',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 23',
  'Google Chrome': '52.38',
  'Internet Explorer': '15.76',
  Firefox: '16.79',
  Safari: '9.5',
  'Microsoft Edge': '3.78',
  Opera: '1.72',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 24',
  'Google Chrome': '53.12',
  'Internet Explorer': '15.22',
  Firefox: '16.55',
  Safari: '9.83',
  'Microsoft Edge': '3.57',
  Opera: '1.65',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 25',
  'Google Chrome': '52.55',
  'Internet Explorer': '19.12',
  Firefox: '16.15',
  Safari: '7.94',
  'Microsoft Edge': '2.89',
  Opera: '1.32',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 26',
  'Google Chrome': '52.45',
  'Internet Explorer': '19.49',
  Firefox: '16.03',
  Safari: '7.83',
  'Microsoft Edge': '2.87',
  Opera: '1.28',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 27',
  'Google Chrome': '52.64',
  'Internet Explorer': '19.42',
  Firefox: '16.06',
  Safari: '7.7',
  'Microsoft Edge': '2.84',
  Opera: '1.29',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 28',
  'Google Chrome': '51.95',
  'Internet Explorer': '19.87',
  Firefox: '16.15',
  Safari: '7.77',
  'Microsoft Edge': '2.92',
  Opera: '1.32',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 29',
  'Google Chrome': '51.03',
  'Internet Explorer': '20',
  Firefox: '16.6',
  Safari: '7.85',
  'Microsoft Edge': '3.07',
  Opera: '1.4',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jan 30',
  'Google Chrome': '50.97',
  'Internet Explorer': '16.86',
  Firefox: '17.28',
  Safari: '9.36',
  'Microsoft Edge': '3.71',
  Opera: '1.76',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jan 31',
  'Google Chrome': '52.36',
  'Internet Explorer': '15.75',
  Firefox: '16.71',
  Safari: '9.85',
  'Microsoft Edge': '3.63',
  Opera: '1.63',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 1',
  'Google Chrome': '52.62',
  'Internet Explorer': '19.09',
  Firefox: '16.1',
  Safari: '7.98',
  'Microsoft Edge': '2.88',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 2',
  'Google Chrome': '52.48',
  'Internet Explorer': '19.25',
  Firefox: '16.25',
  Safari: '7.83',
  'Microsoft Edge': '2.85',
  Opera: '1.29',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 3',
  'Google Chrome': '52.47',
  'Internet Explorer': '19.16',
  Firefox: '16.16',
  Safari: '7.94',
  'Microsoft Edge': '2.91',
  Opera: '1.31',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 4',
  'Google Chrome': '51.91',
  'Internet Explorer': '19.77',
  Firefox: '16.12',
  Safari: '7.83',
  'Microsoft Edge': '3',
  Opera: '1.31',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 5',
  'Google Chrome': '51.76',
  'Internet Explorer': '19.36',
  Firefox: '16.44',
  Safari: '7.78',
  'Microsoft Edge': '3.15',
  Opera: '1.44',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 6',
  'Google Chrome': '52.11',
  'Internet Explorer': '15.66',
  Firefox: '16.99',
  Safari: '9.43',
  'Microsoft Edge': '3.96',
  Opera: '1.78',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 7',
  'Google Chrome': '52.41',
  'Internet Explorer': '15.14',
  Firefox: '17.12',
  Safari: '9.69',
  'Microsoft Edge': '3.81',
  Opera: '1.77',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 8',
  'Google Chrome': '51.83',
  'Internet Explorer': '19.4',
  Firefox: '15.93',
  Safari: '8.38',
  'Microsoft Edge': '3.13',
  Opera: '1.27',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 9',
  'Google Chrome': '52.01',
  'Internet Explorer': '19.2',
  Firefox: '16.01',
  Safari: '8.25',
  'Microsoft Edge': '3.09',
  Opera: '1.37',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 10',
  'Google Chrome': '52.92',
  'Internet Explorer': '18.52',
  Firefox: '15.94',
  Safari: '8.23',
  'Microsoft Edge': '2.93',
  Opera: '1.41',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 11',
  'Google Chrome': '52.71',
  'Internet Explorer': '18.9',
  Firefox: '16.17',
  Safari: '7.94',
  'Microsoft Edge': '2.88',
  Opera: '1.35',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 12',
  'Google Chrome': '52.37',
  'Internet Explorer': '18.63',
  Firefox: '16.65',
  Safari: '7.84',
  'Microsoft Edge': '3.01',
  Opera: '1.45',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 13',
  'Google Chrome': '52.73',
  'Internet Explorer': '14.69',
  Firefox: '17.33',
  Safari: '9.38',
  'Microsoft Edge': '3.92',
  Opera: '1.87',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 14',
  'Google Chrome': '52.73',
  'Internet Explorer': '14.91',
  Firefox: '17.06',
  Safari: '9.67',
  'Microsoft Edge': '3.85',
  Opera: '1.71',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 15',
  'Google Chrome': '52.68',
  'Internet Explorer': '17.65',
  Firefox: '16.58',
  Safari: '8.54',
  'Microsoft Edge': '3.2',
  Opera: '1.31',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 16',
  'Google Chrome': '53.18',
  'Internet Explorer': '18.24',
  Firefox: '16.32',
  Safari: '7.98',
  'Microsoft Edge': '2.93',
  Opera: '1.3',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 17',
  'Google Chrome': '52.8',
  'Internet Explorer': '18.68',
  Firefox: '16.37',
  Safari: '7.83',
  'Microsoft Edge': '2.97',
  Opera: '1.3',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 18',
  'Google Chrome': '52.85',
  'Internet Explorer': '18.74',
  Firefox: '16.32',
  Safari: '7.74',
  'Microsoft Edge': '2.93',
  Opera: '1.37',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 19',
  'Google Chrome': '52.5',
  'Internet Explorer': '18.49',
  Firefox: '16.7',
  Safari: '7.75',
  'Microsoft Edge': '3.08',
  Opera: '1.43',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 20',
  'Google Chrome': '52.15',
  'Internet Explorer': '15.14',
  Firefox: '17.4',
  Safari: '9.45',
  'Microsoft Edge': '3.89',
  Opera: '1.9',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 21',
  'Google Chrome': '52.1',
  'Internet Explorer': '14.95',
  Firefox: '17.14',
  Safari: '10.17',
  'Microsoft Edge': '3.9',
  Opera: '1.66',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 22',
  'Google Chrome': '52.35',
  'Internet Explorer': '18.91',
  Firefox: '16.41',
  Safari: '8.05',
  'Microsoft Edge': '2.97',
  Opera: '1.25',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 23',
  'Google Chrome': '52',
  'Internet Explorer': '19.19',
  Firefox: '16.48',
  Safari: '8.07',
  'Microsoft Edge': '2.97',
  Opera: '1.25',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 24',
  'Google Chrome': '52.27',
  'Internet Explorer': '18.8',
  Firefox: '16.71',
  Safari: '7.93',
  'Microsoft Edge': '2.96',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 25',
  'Google Chrome': '52.2',
  'Internet Explorer': '18.84',
  Firefox: '16.71',
  Safari: '7.91',
  'Microsoft Edge': '2.98',
  Opera: '1.31',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 26',
  'Google Chrome': '52.28',
  'Internet Explorer': '18.37',
  Firefox: '16.95',
  Safari: '7.86',
  'Microsoft Edge': '3.09',
  Opera: '1.39',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 27',
  'Google Chrome': '52.63',
  'Internet Explorer': '14.89',
  Firefox: '17.29',
  Safari: '9.44',
  'Microsoft Edge': '3.9',
  Opera: '1.77',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Feb 28',
  'Google Chrome': '52.74',
  'Internet Explorer': '14.98',
  Firefox: '16.83',
  Safari: '9.89',
  'Microsoft Edge': '3.85',
  Opera: '1.64',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Feb 29',
  'Google Chrome': '53.2',
  'Internet Explorer': '18.53',
  Firefox: '16.18',
  Safari: '7.88',
  'Microsoft Edge': '3',
  Opera: '1.17',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 1',
  'Google Chrome': '53.27',
  'Internet Explorer': '18.36',
  Firefox: '16.23',
  Safari: '7.99',
  'Microsoft Edge': '2.92',
  Opera: '1.18',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 2',
  'Google Chrome': '53.37',
  'Internet Explorer': '18.14',
  Firefox: '16.21',
  Safari: '8.14',
  'Microsoft Edge': '2.89',
  Opera: '1.19',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 3',
  'Google Chrome': '53.03',
  'Internet Explorer': '18.51',
  Firefox: '16.26',
  Safari: '7.98',
  'Microsoft Edge': '2.97',
  Opera: '1.22',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 4',
  'Google Chrome': '52.47',
  'Internet Explorer': '18.63',
  Firefox: '16.48',
  Safari: '7.92',
  'Microsoft Edge': '3.13',
  Opera: '1.32',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 5',
  'Google Chrome': '52.43',
  'Internet Explorer': '14.9',
  Firefox: '17.03',
  Safari: '9.82',
  'Microsoft Edge': '4.04',
  Opera: '1.72',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 6',
  'Google Chrome': '52.86',
  'Internet Explorer': '14.56',
  Firefox: '16.85',
  Safari: '10.1',
  'Microsoft Edge': '3.95',
  Opera: '1.63',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 7',
  'Google Chrome': '52.59',
  'Internet Explorer': '18.9',
  Firefox: '16.25',
  Safari: '7.99',
  'Microsoft Edge': '3.01',
  Opera: '1.22',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 8',
  'Google Chrome': '52.75',
  'Internet Explorer': '18.59',
  Firefox: '16.36',
  Safari: '7.99',
  'Microsoft Edge': '3.01',
  Opera: '1.24',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 9',
  'Google Chrome': '53.16',
  'Internet Explorer': '18.21',
  Firefox: '16.39',
  Safari: '7.89',
  'Microsoft Edge': '3.05',
  Opera: '1.26',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 10',
  'Google Chrome': '52.99',
  'Internet Explorer': '18.49',
  Firefox: '16.45',
  Safari: '7.7',
  'Microsoft Edge': '3.04',
  Opera: '1.28',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 11',
  'Google Chrome': '52.42',
  'Internet Explorer': '18.46',
  Firefox: '16.68',
  Safari: '7.81',
  'Microsoft Edge': '3.22',
  Opera: '1.36',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 12',
  'Google Chrome': '51.86',
  'Internet Explorer': '15.55',
  Firefox: '17.13',
  Safari: '9.46',
  'Microsoft Edge': '4.16',
  Opera: '1.78',
  Mozilla: '0.06',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 13',
  'Google Chrome': '51.95',
  'Internet Explorer': '15.09',
  Firefox: '17.03',
  Safari: '10.04',
  'Microsoft Edge': '4.17',
  Opera: '1.66',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 14',
  'Google Chrome': '51.94',
  'Internet Explorer': '19.4',
  Firefox: '16.23',
  Safari: '8.01',
  'Microsoft Edge': '3.16',
  Opera: '1.21',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 15',
  'Google Chrome': '52.49',
  'Internet Explorer': '18.73',
  Firefox: '16.42',
  Safari: '7.96',
  'Microsoft Edge': '3.11',
  Opera: '1.23',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 16',
  'Google Chrome': '52.41',
  'Internet Explorer': '18.66',
  Firefox: '16.61',
  Safari: '7.85',
  'Microsoft Edge': '3.17',
  Opera: '1.26',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 17',
  'Google Chrome': '52.26',
  'Internet Explorer': '19.15',
  Firefox: '16.53',
  Safari: '7.58',
  'Microsoft Edge': '3.15',
  Opera: '1.29',
  Mozilla: '0.04',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 18',
  'Google Chrome': '51.98',
  'Internet Explorer': '18.86',
  Firefox: '16.76',
  Safari: '7.69',
  'Microsoft Edge': '3.3',
  Opera: '1.37',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 19',
  'Google Chrome': '51.89',
  'Internet Explorer': '15.61',
  Firefox: '17',
  Safari: '9.39',
  'Microsoft Edge': '4.21',
  Opera: '1.79',
  Mozilla: '0.11',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 20',
  'Google Chrome': '51.86',
  'Internet Explorer': '15.29',
  Firefox: '16.87',
  Safari: '9.91',
  'Microsoft Edge': '4.27',
  Opera: '1.71',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 21',
  'Google Chrome': '52.74',
  'Internet Explorer': '18.37',
  Firefox: '16.28',
  Safari: '7.99',
  'Microsoft Edge': '3.22',
  Opera: '1.35',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 22',
  'Google Chrome': '52.93',
  'Internet Explorer': '18.46',
  Firefox: '16.22',
  Safari: '7.76',
  'Microsoft Edge': '3.12',
  Opera: '1.45',
  Mozilla: '0.05',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Mar 23',
  'Google Chrome': '52.65',
  'Internet Explorer': '18.47',
  Firefox: '16.28',
  Safari: '7.76',
  'Microsoft Edge': '3.22',
  Opera: '1.58',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 24',
  'Google Chrome': '52.53',
  'Internet Explorer': '18.25',
  Firefox: '16.21',
  Safari: '8.03',
  'Microsoft Edge': '3.36',
  Opera: '1.58',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 25',
  'Google Chrome': '52.15',
  'Internet Explorer': '16.95',
  Firefox: '16.75',
  Safari: '8.7',
  'Microsoft Edge': '3.76',
  Opera: '1.64',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 26',
  'Google Chrome': '52.24',
  'Internet Explorer': '15.04',
  Firefox: '17.07',
  Safari: '9.52',
  'Microsoft Edge': '4.23',
  Opera: '1.85',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 27',
  'Google Chrome': '52.56',
  'Internet Explorer': '14.27',
  Firefox: '16.98',
  Safari: '10.11',
  'Microsoft Edge': '4.26',
  Opera: '1.78',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 28',
  'Google Chrome': '53.31',
  'Internet Explorer': '17.05',
  Firefox: '16.2',
  Safari: '8.49',
  'Microsoft Edge': '3.48',
  Opera: '1.43',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 29',
  'Google Chrome': '52.98',
  'Internet Explorer': '17.82',
  Firefox: '16.37',
  Safari: '8.09',
  'Microsoft Edge': '3.23',
  Opera: '1.48',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 30',
  'Google Chrome': '53.07',
  'Internet Explorer': '17.84',
  Firefox: '16.37',
  Safari: '7.96',
  'Microsoft Edge': '3.27',
  Opera: '1.45',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Mar 31',
  'Google Chrome': '53.4',
  'Internet Explorer': '17.73',
  Firefox: '16.24',
  Safari: '7.84',
  'Microsoft Edge': '3.3',
  Opera: '1.43',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 1',
  'Google Chrome': '52.72',
  'Internet Explorer': '18.26',
  Firefox: '16.4',
  Safari: '7.72',
  'Microsoft Edge': '3.4',
  Opera: '1.47',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 2',
  'Google Chrome': '52.99',
  'Internet Explorer': '14.44',
  Firefox: '16.96',
  Safari: '9.33',
  'Microsoft Edge': '4.35',
  Opera: '1.87',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 3',
  'Google Chrome': '53.29',
  'Internet Explorer': '14.13',
  Firefox: '16.7',
  Safari: '9.8',
  'Microsoft Edge': '4.2',
  Opera: '1.82',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 4',
  'Google Chrome': '53.65',
  'Internet Explorer': '17.74',
  Firefox: '16.06',
  Safari: '7.79',
  'Microsoft Edge': '3.22',
  Opera: '1.5',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 5',
  'Google Chrome': '53.21',
  'Internet Explorer': '18.25',
  Firefox: '16.05',
  Safari: '7.71',
  'Microsoft Edge': '3.21',
  Opera: '1.54',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 6',
  'Google Chrome': '53.29',
  'Internet Explorer': '18.24',
  Firefox: '16.02',
  Safari: '7.52',
  'Microsoft Edge': '3.28',
  Opera: '1.6',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 7',
  'Google Chrome': '52.77',
  'Internet Explorer': '18.33',
  Firefox: '16.26',
  Safari: '7.56',
  'Microsoft Edge': '3.35',
  Opera: '1.69',
  Mozilla: '0.03',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 8',
  'Google Chrome': '52.41',
  'Internet Explorer': '18.15',
  Firefox: '16.82',
  Safari: '7.65',
  'Microsoft Edge': '3.5',
  Opera: '1.42',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 9',
  'Google Chrome': '52.03',
  'Internet Explorer': '15.11',
  Firefox: '17.19',
  Safari: '9.37',
  'Microsoft Edge': '4.48',
  Opera: '1.77',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 10',
  'Google Chrome': '52.62',
  'Internet Explorer': '14.85',
  Firefox: '16.78',
  Safari: '9.63',
  'Microsoft Edge': '4.42',
  Opera: '1.66',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 11',
  'Google Chrome': '52.54',
  'Internet Explorer': '18.79',
  Firefox: '16.17',
  Safari: '7.73',
  'Microsoft Edge': '3.37',
  Opera: '1.34',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 12',
  'Google Chrome': '53.2',
  'Internet Explorer': '18.04',
  Firefox: '16.1',
  Safari: '7.61',
  'Microsoft Edge': '3.34',
  Opera: '1.65',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 13',
  'Google Chrome': '53.01',
  'Internet Explorer': '17.89',
  Firefox: '16.22',
  Safari: '7.67',
  'Microsoft Edge': '3.39',
  Opera: '1.72',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 14',
  'Google Chrome': '53.2',
  'Internet Explorer': '18.06',
  Firefox: '16.08',
  Safari: '7.53',
  'Microsoft Edge': '3.3',
  Opera: '1.68',
  Mozilla: '0.15',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 15',
  'Google Chrome': '52.96',
  'Internet Explorer': '17.82',
  Firefox: '16.32',
  Safari: '7.52',
  'Microsoft Edge': '3.46',
  Opera: '1.81',
  Mozilla: '0.12',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 16',
  'Google Chrome': '52.52',
  'Internet Explorer': '14.52',
  Firefox: '17.23',
  Safari: '9.32',
  'Microsoft Edge': '4.47',
  Opera: '1.81',
  Mozilla: '0.13',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 17',
  'Google Chrome': '52.71',
  'Internet Explorer': '14.25',
  Firefox: '16.94',
  Safari: '9.9',
  'Microsoft Edge': '4.4',
  Opera: '1.7',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 18',
  'Google Chrome': '53.22',
  'Internet Explorer': '17.85',
  Firefox: '16.08',
  Safari: '7.79',
  'Microsoft Edge': '3.33',
  Opera: '1.66',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 19',
  'Google Chrome': '53.51',
  'Internet Explorer': '17.76',
  Firefox: '16.19',
  Safari: '7.77',
  'Microsoft Edge': '3.27',
  Opera: '1.43',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 20',
  'Google Chrome': '53.62',
  'Internet Explorer': '17.44',
  Firefox: '16.12',
  Safari: '7.81',
  'Microsoft Edge': '3.36',
  Opera: '1.57',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 21',
  'Google Chrome': '53.4',
  'Internet Explorer': '17.94',
  Firefox: '15.94',
  Safari: '7.59',
  'Microsoft Edge': '3.47',
  Opera: '1.6',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 22',
  'Google Chrome': '52.62',
  'Internet Explorer': '18.57',
  Firefox: '16.13',
  Safari: '7.55',
  'Microsoft Edge': '3.61',
  Opera: '1.46',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 23',
  'Google Chrome': '52.42',
  'Internet Explorer': '14.46',
  Firefox: '17.12',
  Safari: '9.44',
  'Microsoft Edge': '4.72',
  Opera: '1.75',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 24',
  'Google Chrome': '53.43',
  'Internet Explorer': '13.62',
  Firefox: '16.79',
  Safari: '9.84',
  'Microsoft Edge': '4.59',
  Opera: '1.66',
  Mozilla: '0.07',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Apr 25',
  'Google Chrome': '53.48',
  'Internet Explorer': '17.72',
  Firefox: '15.98',
  Safari: '7.79',
  'Microsoft Edge': '3.46',
  Opera: '1.5',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 26',
  'Google Chrome': '53.5',
  'Internet Explorer': '17.81',
  Firefox: '16.13',
  Safari: '7.73',
  'Microsoft Edge': '3.4',
  Opera: '1.36',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 27',
  'Google Chrome': '53.68',
  'Internet Explorer': '17.4',
  Firefox: '16.39',
  Safari: '7.76',
  'Microsoft Edge': '3.45',
  Opera: '1.24',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 28',
  'Google Chrome': '53.08',
  'Internet Explorer': '18.16',
  Firefox: '16.31',
  Safari: '7.68',
  'Microsoft Edge': '3.49',
  Opera: '1.21',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Apr 29',
  'Google Chrome': '53.09',
  'Internet Explorer': '17.74',
  Firefox: '16.65',
  Safari: '7.59',
  'Microsoft Edge': '3.56',
  Opera: '1.28',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 Apr 30',
  'Google Chrome': '53.1',
  'Internet Explorer': '14.09',
  Firefox: '16.82',
  Safari: '9.4',
  'Microsoft Edge': '4.86',
  Opera: '1.65',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2016 May 1',
  'Google Chrome': '52.76',
  'Internet Explorer': '13.89',
  Firefox: '16.72',
  Safari: '10.07',
  'Microsoft Edge': '4.88',
  Opera: '1.58',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2016 May 2',
  'Google Chrome': '53.44',
  'Internet Explorer': '17.2',
  Firefox: '16.17',
  Safari: '8.2',
  'Microsoft Edge': '3.67',
  Opera: '1.21',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2016 May 3',
  'Google Chrome': '52.97',
  'Internet Explorer': '17.96',
  Firefox: '16.21',
  Safari: '7.85',
  'Microsoft Edge': '3.52',
  Opera: '1.41',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 4',
  'Google Chrome': '53.55',
  'Internet Explorer': '17.62',
  Firefox: '16.01',
  Safari: '7.62',
  'Microsoft Edge': '3.57',
  Opera: '1.54',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 May 5',
  'Google Chrome': '53.76',
  'Internet Explorer': '17.45',
  Firefox: '15.92',
  Safari: '7.6',
  'Microsoft Edge': '3.63',
  Opera: '1.57',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 May 6',
  'Google Chrome': '52.97',
  'Internet Explorer': '17.61',
  Firefox: '16.28',
  Safari: '7.72',
  'Microsoft Edge': '3.78',
  Opera: '1.55',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 May 7',
  'Google Chrome': '51.82',
  'Internet Explorer': '14.56',
  Firefox: '17.28',
  Safari: '9.66',
  'Microsoft Edge': '4.86',
  Opera: '1.72',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2016 May 8',
  'Google Chrome': '52.46',
  'Internet Explorer': '14.09',
  Firefox: '17.17',
  Safari: '9.79',
  'Microsoft Edge': '4.69',
  Opera: '1.71',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 May 9',
  'Google Chrome': '53.05',
  'Internet Explorer': '18.2',
  Firefox: '16.1',
  Safari: '7.92',
  'Microsoft Edge': '3.58',
  Opera: '1.08',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 10',
  'Google Chrome': '52.83',
  'Internet Explorer': '18.34',
  Firefox: '16.14',
  Safari: '7.77',
  'Microsoft Edge': '3.62',
  Opera: '1.24',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 11',
  'Google Chrome': '53.18',
  'Internet Explorer': '17.93',
  Firefox: '16.28',
  Safari: '7.67',
  'Microsoft Edge': '3.6',
  Opera: '1.26',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 12',
  'Google Chrome': '52.5',
  'Internet Explorer': '18.46',
  Firefox: '16.41',
  Safari: '7.53',
  'Microsoft Edge': '3.63',
  Opera: '1.4',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 13',
  'Google Chrome': '51.81',
  'Internet Explorer': '18.58',
  Firefox: '16.66',
  Safari: '7.6',
  'Microsoft Edge': '3.77',
  Opera: '1.48',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 May 14',
  'Google Chrome': '50.29',
  'Internet Explorer': '15.33',
  Firefox: '17.99',
  Safari: '9.42',
  'Microsoft Edge': '4.96',
  Opera: '1.91',
  Mozilla: '0.1',
  'Other/Unknown': '0'
}, {
  date: '2016 May 15',
  'Google Chrome': '51.36',
  'Internet Explorer': '14.55',
  Firefox: '17.56',
  Safari: '9.66',
  'Microsoft Edge': '4.91',
  Opera: '1.87',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 May 16',
  'Google Chrome': '52.3',
  'Internet Explorer': '18.24',
  Firefox: '16.41',
  Safari: '7.76',
  'Microsoft Edge': '3.73',
  Opera: '1.49',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 17',
  'Google Chrome': '52.05',
  'Internet Explorer': '18.88',
  Firefox: '16.42',
  Safari: '7.64',
  'Microsoft Edge': '3.57',
  Opera: '1.37',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 18',
  'Google Chrome': '51.99',
  'Internet Explorer': '18.87',
  Firefox: '16.43',
  Safari: '7.76',
  'Microsoft Edge': '3.64',
  Opera: '1.24',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 19',
  'Google Chrome': '51.67',
  'Internet Explorer': '19.25',
  Firefox: '16.18',
  Safari: '7.96',
  'Microsoft Edge': '3.77',
  Opera: '1.1',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 20',
  'Google Chrome': '51.75',
  'Internet Explorer': '18.51',
  Firefox: '16.52',
  Safari: '7.88',
  'Microsoft Edge': '4.09',
  Opera: '1.19',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 21',
  'Google Chrome': '51.83',
  'Internet Explorer': '14.13',
  Firefox: '17.6',
  Safari: '9.54',
  'Microsoft Edge': '5.19',
  Opera: '1.62',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 22',
  'Google Chrome': '52.46',
  'Internet Explorer': '13.53',
  Firefox: '17.44',
  Safari: '9.82',
  'Microsoft Edge': '5.07',
  Opera: '1.61',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 23',
  'Google Chrome': '52.6',
  'Internet Explorer': '18.04',
  Firefox: '16.37',
  Safari: '7.69',
  'Microsoft Edge': '3.95',
  Opera: '1.3',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 May 24',
  'Google Chrome': '52.83',
  'Internet Explorer': '17.85',
  Firefox: '16.46',
  Safari: '7.58',
  'Microsoft Edge': '3.91',
  Opera: '1.32',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 25',
  'Google Chrome': '53.16',
  'Internet Explorer': '17.45',
  Firefox: '16.35',
  Safari: '7.6',
  'Microsoft Edge': '3.99',
  Opera: '1.39',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 26',
  'Google Chrome': '52.81',
  'Internet Explorer': '17.8',
  Firefox: '16.38',
  Safari: '7.67',
  'Microsoft Edge': '3.95',
  Opera: '1.33',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 May 27',
  'Google Chrome': '52.54',
  'Internet Explorer': '17.27',
  Firefox: '16.86',
  Safari: '7.73',
  'Microsoft Edge': '4.17',
  Opera: '1.35',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 28',
  'Google Chrome': '52.58',
  'Internet Explorer': '13.24',
  Firefox: '17.76',
  Safari: '9.27',
  'Microsoft Edge': '5.33',
  Opera: '1.74',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 May 29',
  'Google Chrome': '52.85',
  'Internet Explorer': '12.95',
  Firefox: '17.78',
  Safari: '9.34',
  'Microsoft Edge': '5.29',
  Opera: '1.72',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 30',
  'Google Chrome': '52.89',
  'Internet Explorer': '14.39',
  Firefox: '17.67',
  Safari: '8.53',
  'Microsoft Edge': '4.86',
  Opera: '1.59',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 May 31',
  'Google Chrome': '53.61',
  'Internet Explorer': '17.15',
  Firefox: '16.08',
  Safari: '7.6',
  'Microsoft Edge': '4.13',
  Opera: '1.37',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 1',
  'Google Chrome': '53.58',
  'Internet Explorer': '16.65',
  Firefox: '16.01',
  Safari: '7.99',
  'Microsoft Edge': '4.29',
  Opera: '1.42',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 2',
  'Google Chrome': '52.76',
  'Internet Explorer': '17.4',
  Firefox: '16.35',
  Safari: '7.81',
  'Microsoft Edge': '4.29',
  Opera: '1.33',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 3',
  'Google Chrome': '52.44',
  'Internet Explorer': '16.96',
  Firefox: '16.52',
  Safari: '7.71',
  'Microsoft Edge': '4.6',
  Opera: '1.69',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 4',
  'Google Chrome': '52.33',
  'Internet Explorer': '12.93',
  Firefox: '17.3',
  Safari: '9.52',
  'Microsoft Edge': '5.88',
  Opera: '1.96',
  Mozilla: '0.08',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 5',
  'Google Chrome': '52.38',
  'Internet Explorer': '12.56',
  Firefox: '17.42',
  Safari: '9.66',
  'Microsoft Edge': '5.76',
  Opera: '2.14',
  Mozilla: '0.08',
  'Other/Unknown': '0.01'
}, {
  date: '2016 Jun 6',
  'Google Chrome': '52.69',
  'Internet Explorer': '17.32',
  Firefox: '16.31',
  Safari: '7.43',
  'Microsoft Edge': '4.18',
  Opera: '2.01',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 7',
  'Google Chrome': '52.95',
  'Internet Explorer': '17.47',
  Firefox: '16.28',
  Safari: '7.65',
  'Microsoft Edge': '4.05',
  Opera: '1.55',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 8',
  'Google Chrome': '52.68',
  'Internet Explorer': '17.66',
  Firefox: '16.3',
  Safari: '7.6',
  'Microsoft Edge': '4.14',
  Opera: '1.56',
  Mozilla: '0.06',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 9',
  'Google Chrome': '52.3',
  'Internet Explorer': '18.02',
  Firefox: '16.25',
  Safari: '7.85',
  'Microsoft Edge': '4.14',
  Opera: '1.38',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 10',
  'Google Chrome': '52.22',
  'Internet Explorer': '17.36',
  Firefox: '16.46',
  Safari: '7.96',
  'Microsoft Edge': '4.44',
  Opera: '1.49',
  Mozilla: '0.07',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 11',
  'Google Chrome': '52.06',
  'Internet Explorer': '13.19',
  Firefox: '17.21',
  Safari: '9.98',
  'Microsoft Edge': '5.78',
  Opera: '1.69',
  Mozilla: '0.09',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 12',
  'Google Chrome': '52.09',
  'Internet Explorer': '12.75',
  Firefox: '16.89',
  Safari: '10.65',
  'Microsoft Edge': '5.96',
  Opera: '1.6',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 13',
  'Google Chrome': '53.18',
  'Internet Explorer': '16.87',
  Firefox: '16.21',
  Safari: '8.15',
  'Microsoft Edge': '4.39',
  Opera: '1.15',
  Mozilla: '0.05',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 14',
  'Google Chrome': '53.45',
  'Internet Explorer': '17.03',
  Firefox: '16.15',
  Safari: '7.8',
  'Microsoft Edge': '4.31',
  Opera: '1.21',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}, {
  date: '2016 Jun 15',
  'Google Chrome': '53.4',
  'Internet Explorer': '18.12',
  Firefox: '16.51',
  Safari: '6.69',
  'Microsoft Edge': '3.84',
  Opera: '1.4',
  Mozilla: '0.04',
  'Other/Unknown': '0'
}];

var groupDateValue = [{ key: 'Group1', value: '37', date: '04/23/12' }, { key: 'Group2', value: '12', date: '04/23/12' }, { key: 'Group3', value: '46', date: '04/23/12' }, { key: 'Group1', value: '32', date: '04/24/12' }, { key: 'Group2', value: '19', date: '04/24/12' }, { key: 'Group3', value: '42', date: '04/24/12' }, { key: 'Group1', value: '45', date: '04/25/12' }, { key: 'Group2', value: '16', date: '04/25/12' }, { key: 'Group3', value: '44', date: '04/25/12' }, { key: 'Group1', value: '24', date: '04/26/12' }, { key: 'Group2', value: '52', date: '04/26/12' }, { key: 'Group3', value: '64', date: '04/26/12' }];

var cityTemperature = [{
  date: '20111001',
  'New York': '63.4',
  'San Francisco': '62.7',
  Austin: '72.2'
}, {
  date: '20111002',
  'New York': '58.0',
  'San Francisco': '59.9',
  Austin: '67.7'
}, {
  date: '20111003',
  'New York': '53.3',
  'San Francisco': '59.1',
  Austin: '69.4'
}, {
  date: '20111004',
  'New York': '55.7',
  'San Francisco': '58.8',
  Austin: '68.0'
}, {
  date: '20111005',
  'New York': '64.2',
  'San Francisco': '58.7',
  Austin: '72.4'
}, {
  date: '20111006',
  'New York': '58.8',
  'San Francisco': '57.0',
  Austin: '77.0'
}, {
  date: '20111007',
  'New York': '57.9',
  'San Francisco': '56.7',
  Austin: '82.3'
}, {
  date: '20111008',
  'New York': '61.8',
  'San Francisco': '56.8',
  Austin: '78.9'
}, {
  date: '20111009',
  'New York': '69.3',
  'San Francisco': '56.7',
  Austin: '68.8'
}, {
  date: '20111010',
  'New York': '71.2',
  'San Francisco': '60.1',
  Austin: '68.7'
}, {
  date: '20111011',
  'New York': '68.7',
  'San Francisco': '61.1',
  Austin: '70.3'
}, {
  date: '20111012',
  'New York': '61.8',
  'San Francisco': '61.5',
  Austin: '75.3'
}, {
  date: '20111013',
  'New York': '63.0',
  'San Francisco': '64.3',
  Austin: '76.6'
}, {
  date: '20111014',
  'New York': '66.9',
  'San Francisco': '67.1',
  Austin: '66.6'
}, {
  date: '20111015',
  'New York': '61.7',
  'San Francisco': '64.6',
  Austin: '68.0'
}, {
  date: '20111016',
  'New York': '61.8',
  'San Francisco': '61.6',
  Austin: '70.6'
}, {
  date: '20111017',
  'New York': '62.8',
  'San Francisco': '61.1',
  Austin: '71.1'
}, {
  date: '20111018',
  'New York': '60.8',
  'San Francisco': '59.2',
  Austin: '70.0'
}, {
  date: '20111019',
  'New York': '62.1',
  'San Francisco': '58.9',
  Austin: '61.6'
}, {
  date: '20111020',
  'New York': '65.1',
  'San Francisco': '57.2',
  Austin: '57.4'
}, {
  date: '20111021',
  'New York': '55.6',
  'San Francisco': '56.4',
  Austin: '64.3'
}, {
  date: '20111022',
  'New York': '54.4',
  'San Francisco': '60.7',
  Austin: '72.4'
}, {
  date: '20111023',
  'New York': '54.4',
  'San Francisco': '65.1',
  Austin: '72.4'
}, {
  date: '20111024',
  'New York': '54.8',
  'San Francisco': '60.9',
  Austin: '72.5'
}, {
  date: '20111025',
  'New York': '57.9',
  'San Francisco': '56.1',
  Austin: '72.7'
}, {
  date: '20111026',
  'New York': '54.6',
  'San Francisco': '54.6',
  Austin: '73.4'
}, {
  date: '20111027',
  'New York': '54.4',
  'San Francisco': '56.1',
  Austin: '70.7'
}, {
  date: '20111028',
  'New York': '42.5',
  'San Francisco': '58.1',
  Austin: '56.8'
}, {
  date: '20111029',
  'New York': '40.9',
  'San Francisco': '57.5',
  Austin: '51.0'
}, {
  date: '20111030',
  'New York': '38.6',
  'San Francisco': '57.7',
  Austin: '54.9'
}, {
  date: '20111031',
  'New York': '44.2',
  'San Francisco': '55.1',
  Austin: '58.8'
}, {
  date: '20111101',
  'New York': '49.6',
  'San Francisco': '57.9',
  Austin: '62.6'
}, {
  date: '20111102',
  'New York': '47.2',
  'San Francisco': '64.6',
  Austin: '71.0'
}, {
  date: '20111103',
  'New York': '50.1',
  'San Francisco': '56.2',
  Austin: '58.4'
}, {
  date: '20111104',
  'New York': '50.1',
  'San Francisco': '50.5',
  Austin: '45.1'
}, {
  date: '20111105',
  'New York': '43.5',
  'San Francisco': '51.3',
  Austin: '52.2'
}, {
  date: '20111106',
  'New York': '43.8',
  'San Francisco': '52.6',
  Austin: '73.0'
}, {
  date: '20111107',
  'New York': '48.9',
  'San Francisco': '51.4',
  Austin: '75.4'
}, {
  date: '20111108',
  'New York': '55.5',
  'San Francisco': '50.6',
  Austin: '72.1'
}, {
  date: '20111109',
  'New York': '53.7',
  'San Francisco': '54.6',
  Austin: '56.6'
}, {
  date: '20111110',
  'New York': '57.7',
  'San Francisco': '55.6',
  Austin: '55.4'
}, {
  date: '20111111',
  'New York': '48.5',
  'San Francisco': '53.9',
  Austin: '46.7'
}, {
  date: '20111112',
  'New York': '46.8',
  'San Francisco': '54.0',
  Austin: '62.0'
}, {
  date: '20111113',
  'New York': '51.1',
  'San Francisco': '53.8',
  Austin: '71.6'
}, {
  date: '20111114',
  'New York': '56.8',
  'San Francisco': '53.5',
  Austin: '75.5'
}, {
  date: '20111115',
  'New York': '59.7',
  'San Francisco': '53.4',
  Austin: '72.1'
}, {
  date: '20111116',
  'New York': '56.5',
  'San Francisco': '52.2',
  Austin: '65.7'
}, {
  date: '20111117',
  'New York': '49.6',
  'San Francisco': '52.7',
  Austin: '56.8'
}, {
  date: '20111118',
  'New York': '41.5',
  'San Francisco': '53.1',
  Austin: '49.9'
}, {
  date: '20111119',
  'New York': '44.3',
  'San Francisco': '49.0',
  Austin: '71.7'
}, {
  date: '20111120',
  'New York': '54.0',
  'San Francisco': '50.4',
  Austin: '77.7'
}, {
  date: '20111121',
  'New York': '54.1',
  'San Francisco': '51.1',
  Austin: '76.4'
}, {
  date: '20111122',
  'New York': '49.4',
  'San Francisco': '52.3',
  Austin: '68.8'
}, {
  date: '20111123',
  'New York': '50.0',
  'San Francisco': '54.6',
  Austin: '57.0'
}, {
  date: '20111124',
  'New York': '44.0',
  'San Francisco': '55.1',
  Austin: '55.5'
}, {
  date: '20111125',
  'New York': '50.3',
  'San Francisco': '51.5',
  Austin: '61.6'
}, {
  date: '20111126',
  'New York': '52.1',
  'San Francisco': '53.6',
  Austin: '64.1'
}, {
  date: '20111127',
  'New York': '49.6',
  'San Francisco': '52.3',
  Austin: '51.1'
}, {
  date: '20111128',
  'New York': '57.2',
  'San Francisco': '51.0',
  Austin: '43.0'
}, {
  date: '20111129',
  'New York': '59.1',
  'San Francisco': '49.5',
  Austin: '46.4'
}, {
  date: '20111130',
  'New York': '50.6',
  'San Francisco': '49.8',
  Austin: '48.0'
}, {
  date: '20111201',
  'New York': '44.3',
  'San Francisco': '60.4',
  Austin: '48.1'
}, {
  date: '20111202',
  'New York': '43.9',
  'San Francisco': '62.2',
  Austin: '60.6'
}, {
  date: '20111203',
  'New York': '42.1',
  'San Francisco': '58.3',
  Austin: '62.6'
}, {
  date: '20111204',
  'New York': '43.9',
  'San Francisco': '52.7',
  Austin: '57.1'
}, {
  date: '20111205',
  'New York': '50.2',
  'San Francisco': '51.5',
  Austin: '44.2'
}, {
  date: '20111206',
  'New York': '54.2',
  'San Francisco': '49.9',
  Austin: '37.4'
}, {
  date: '20111207',
  'New York': '54.6',
  'San Francisco': '48.6',
  Austin: '35.0'
}, {
  date: '20111208',
  'New York': '43.4',
  'San Francisco': '46.4',
  Austin: '37.0'
}, {
  date: '20111209',
  'New York': '42.2',
  'San Francisco': '49.8',
  Austin: '45.4'
}, {
  date: '20111210',
  'New York': '45.0',
  'San Francisco': '52.1',
  Austin: '50.7'
}, {
  date: '20111211',
  'New York': '33.8',
  'San Francisco': '48.8',
  Austin: '48.6'
}, {
  date: '20111212',
  'New York': '36.8',
  'San Francisco': '47.4',
  Austin: '52.2'
}, {
  date: '20111213',
  'New York': '38.6',
  'San Francisco': '47.2',
  Austin: '60.8'
}, {
  date: '20111214',
  'New York': '41.9',
  'San Francisco': '46.1',
  Austin: '70.0'
}, {
  date: '20111215',
  'New York': '49.6',
  'San Francisco': '48.8',
  Austin: '64.2'
}, {
  date: '20111216',
  'New York': '50.2',
  'San Francisco': '47.9',
  Austin: '50.9'
}, {
  date: '20111217',
  'New York': '40.6',
  'San Francisco': '49.8',
  Austin: '51.6'
}, {
  date: '20111218',
  'New York': '29.1',
  'San Francisco': '49.1',
  Austin: '55.2'
}, {
  date: '20111219',
  'New York': '33.7',
  'San Francisco': '48.3',
  Austin: '62.1'
}, {
  date: '20111220',
  'New York': '45.8',
  'San Francisco': '49.3',
  Austin: '56.3'
}, {
  date: '20111221',
  'New York': '47.4',
  'San Francisco': '48.4',
  Austin: '47.2'
}, {
  date: '20111222',
  'New York': '54.4',
  'San Francisco': '53.3',
  Austin: '52.3'
}, {
  date: '20111223',
  'New York': '47.8',
  'San Francisco': '47.5',
  Austin: '45.2'
}, {
  date: '20111224',
  'New York': '34.9',
  'San Francisco': '47.9',
  Austin: '43.6'
}, {
  date: '20111225',
  'New York': '35.9',
  'San Francisco': '48.9',
  Austin: '42.9'
}, {
  date: '20111226',
  'New York': '43.6',
  'San Francisco': '45.9',
  Austin: '48.2'
}, {
  date: '20111227',
  'New York': '42.9',
  'San Francisco': '47.2',
  Austin: '45.4'
}, {
  date: '20111228',
  'New York': '46.2',
  'San Francisco': '48.9',
  Austin: '44.2'
}, {
  date: '20111229',
  'New York': '30.8',
  'San Francisco': '50.9',
  Austin: '50.4'
}, {
  date: '20111230',
  'New York': '40.8',
  'San Francisco': '52.9',
  Austin: '52.4'
}, {
  date: '20111231',
  'New York': '49.8',
  'San Francisco': '50.1',
  Austin: '53.5'
}, {
  date: '20120101',
  'New York': '46.3',
  'San Francisco': '53.9',
  Austin: '55.9'
}, {
  date: '20120102',
  'New York': '43.2',
  'San Francisco': '53.1',
  Austin: '48.2'
}, {
  date: '20120103',
  'New York': '30.3',
  'San Francisco': '49.7',
  Austin: '41.0'
}, {
  date: '20120104',
  'New York': '19.2',
  'San Francisco': '52.7',
  Austin: '48.9'
}, {
  date: '20120105',
  'New York': '32.1',
  'San Francisco': '52.6',
  Austin: '54.8'
}, {
  date: '20120106',
  'New York': '41.2',
  'San Francisco': '49.0',
  Austin: '61.2'
}, {
  date: '20120107',
  'New York': '47.0',
  'San Francisco': '51.0',
  Austin: '59.7'
}, {
  date: '20120108',
  'New York': '46.0',
  'San Francisco': '56.8',
  Austin: '52.5'
}, {
  date: '20120109',
  'New York': '34.7',
  'San Francisco': '52.3',
  Austin: '54.0'
}, {
  date: '20120110',
  'New York': '39.4',
  'San Francisco': '51.6',
  Austin: '47.7'
}, {
  date: '20120111',
  'New York': '40.4',
  'San Francisco': '49.8',
  Austin: '49.2'
}, {
  date: '20120112',
  'New York': '45.4',
  'San Francisco': '51.9',
  Austin: '48.4'
}, {
  date: '20120113',
  'New York': '40.7',
  'San Francisco': '53.7',
  Austin: '40.2'
}, {
  date: '20120114',
  'New York': '30.4',
  'San Francisco': '52.9',
  Austin: '43.9'
}, {
  date: '20120115',
  'New York': '23.9',
  'San Francisco': '49.7',
  Austin: '45.2'
}, {
  date: '20120116',
  'New York': '22.6',
  'San Francisco': '45.3',
  Austin: '65.0'
}, {
  date: '20120117',
  'New York': '39.8',
  'San Francisco': '43.6',
  Austin: '68.2'
}, {
  date: '20120118',
  'New York': '43.2',
  'San Francisco': '45.0',
  Austin: '47.5'
}, {
  date: '20120119',
  'New York': '26.3',
  'San Francisco': '47.3',
  Austin: '57.1'
}, {
  date: '20120120',
  'New York': '32.8',
  'San Francisco': '51.4',
  Austin: '61.9'
}, {
  date: '20120121',
  'New York': '27.4',
  'San Francisco': '53.7',
  Austin: '54.6'
}, {
  date: '20120122',
  'New York': '25.0',
  'San Francisco': '48.3',
  Austin: '56.7'
}, {
  date: '20120123',
  'New York': '39.4',
  'San Francisco': '52.9',
  Austin: '54.4'
}, {
  date: '20120124',
  'New York': '48.7',
  'San Francisco': '49.1',
  Austin: '52.7'
}, {
  date: '20120125',
  'New York': '43.0',
  'San Francisco': '52.1',
  Austin: '61.8'
}, {
  date: '20120126',
  'New York': '37.1',
  'San Francisco': '53.6',
  Austin: '55.0'
}, {
  date: '20120127',
  'New York': '48.2',
  'San Francisco': '50.4',
  Austin: '50.7'
}, {
  date: '20120128',
  'New York': '43.7',
  'San Francisco': '50.3',
  Austin: '52.9'
}, {
  date: '20120129',
  'New York': '40.1',
  'San Francisco': '53.8',
  Austin: '44.4'
}, {
  date: '20120130',
  'New York': '38.0',
  'San Francisco': '51.9',
  Austin: '49.1'
}, {
  date: '20120131',
  'New York': '43.5',
  'San Francisco': '50.0',
  Austin: '62.8'
}, {
  date: '20120201',
  'New York': '50.4',
  'San Francisco': '50.0',
  Austin: '64.6'
}, {
  date: '20120202',
  'New York': '45.8',
  'San Francisco': '51.3',
  Austin: '61.1'
}, {
  date: '20120203',
  'New York': '37.5',
  'San Francisco': '51.5',
  Austin: '70.0'
}, {
  date: '20120204',
  'New York': '40.8',
  'San Francisco': '52.0',
  Austin: '61.3'
}, {
  date: '20120205',
  'New York': '36.5',
  'San Francisco': '53.8',
  Austin: '48.2'
}, {
  date: '20120206',
  'New York': '39.1',
  'San Francisco': '54.6',
  Austin: '44.2'
}, {
  date: '20120207',
  'New York': '43.2',
  'San Francisco': '54.3',
  Austin: '51.3'
}, {
  date: '20120208',
  'New York': '36.5',
  'San Francisco': '51.9',
  Austin: '49.2'
}, {
  date: '20120209',
  'New York': '36.5',
  'San Francisco': '53.8',
  Austin: '45.7'
}, {
  date: '20120210',
  'New York': '38.3',
  'San Francisco': '53.9',
  Austin: '54.1'
}, {
  date: '20120211',
  'New York': '36.9',
  'San Francisco': '52.3',
  Austin: '44.9'
}, {
  date: '20120212',
  'New York': '29.7',
  'San Francisco': '50.1',
  Austin: '36.5'
}, {
  date: '20120213',
  'New York': '33.1',
  'San Francisco': '49.5',
  Austin: '44.8'
}, {
  date: '20120214',
  'New York': '39.6',
  'San Francisco': '48.6',
  Austin: '52.3'
}, {
  date: '20120215',
  'New York': '42.3',
  'San Francisco': '49.9',
  Austin: '68.0'
}, {
  date: '20120216',
  'New York': '39.7',
  'San Francisco': '52.4',
  Austin: '54.6'
}, {
  date: '20120217',
  'New York': '46.0',
  'San Francisco': '49.9',
  Austin: '53.8'
}, {
  date: '20120218',
  'New York': '41.2',
  'San Francisco': '51.6',
  Austin: '56.2'
}, {
  date: '20120219',
  'New York': '39.8',
  'San Francisco': '47.8',
  Austin: '50.8'
}, {
  date: '20120220',
  'New York': '38.1',
  'San Francisco': '48.7',
  Austin: '53.0'
}, {
  date: '20120221',
  'New York': '37.1',
  'San Francisco': '49.7',
  Austin: '61.0'
}, {
  date: '20120222',
  'New York': '45.5',
  'San Francisco': '53.4',
  Austin: '68.8'
}, {
  date: '20120223',
  'New York': '50.6',
  'San Francisco': '54.1',
  Austin: '69.4'
}, {
  date: '20120224',
  'New York': '42.7',
  'San Francisco': '55.9',
  Austin: '59.3'
}, {
  date: '20120225',
  'New York': '42.6',
  'San Francisco': '51.7',
  Austin: '47.2'
}, {
  date: '20120226',
  'New York': '36.9',
  'San Francisco': '47.7',
  Austin: '47.7'
}, {
  date: '20120227',
  'New York': '40.9',
  'San Francisco': '45.4',
  Austin: '61.9'
}, {
  date: '20120228',
  'New York': '45.9',
  'San Francisco': '47.0',
  Austin: '67.2'
}, {
  date: '20120229',
  'New York': '40.7',
  'San Francisco': '49.8',
  Austin: '70.1'
}, {
  date: '20120301',
  'New York': '41.3',
  'San Francisco': '48.9',
  Austin: '62.1'
}, {
  date: '20120302',
  'New York': '36.8',
  'San Francisco': '48.1',
  Austin: '72.7'
}, {
  date: '20120303',
  'New York': '47.6',
  'San Francisco': '50.7',
  Austin: '59.0'
}, {
  date: '20120304',
  'New York': '44.2',
  'San Francisco': '55.0',
  Austin: '51.8'
}, {
  date: '20120305',
  'New York': '38.5',
  'San Francisco': '48.8',
  Austin: '55.0'
}, {
  date: '20120306',
  'New York': '32.9',
  'San Francisco': '48.4',
  Austin: '61.8'
}, {
  date: '20120307',
  'New York': '43.3',
  'San Francisco': '49.9',
  Austin: '67.1'
}, {
  date: '20120308',
  'New York': '51.2',
  'San Francisco': '49.2',
  Austin: '72.0'
}, {
  date: '20120309',
  'New York': '47.8',
  'San Francisco': '51.7',
  Austin: '46.4'
}, {
  date: '20120310',
  'New York': '37.2',
  'San Francisco': '49.3',
  Austin: '46.7'
}, {
  date: '20120311',
  'New York': '42.9',
  'San Francisco': '50.0',
  Austin: '56.9'
}, {
  date: '20120312',
  'New York': '48.8',
  'San Francisco': '48.6',
  Austin: '61.9'
}, {
  date: '20120313',
  'New York': '52.6',
  'San Francisco': '53.9',
  Austin: '68.8'
}, {
  date: '20120314',
  'New York': '60.5',
  'San Francisco': '55.2',
  Austin: '71.9'
}, {
  date: '20120315',
  'New York': '47.2',
  'San Francisco': '55.9',
  Austin: '72.0'
}, {
  date: '20120316',
  'New York': '44.7',
  'San Francisco': '54.6',
  Austin: '72.5'
}, {
  date: '20120317',
  'New York': '48.2',
  'San Francisco': '48.2',
  Austin: '71.7'
}, {
  date: '20120318',
  'New York': '48.2',
  'San Francisco': '47.1',
  Austin: '71.1'
}, {
  date: '20120319',
  'New York': '53.1',
  'San Francisco': '45.8',
  Austin: '73.0'
}, {
  date: '20120320',
  'New York': '57.8',
  'San Francisco': '49.7',
  Austin: '63.8'
}, {
  date: '20120321',
  'New York': '57.5',
  'San Francisco': '51.4',
  Austin: '60.0'
}, {
  date: '20120322',
  'New York': '57.3',
  'San Francisco': '51.4',
  Austin: '62.3'
}, {
  date: '20120323',
  'New York': '61.7',
  'San Francisco': '48.4',
  Austin: '61.1'
}, {
  date: '20120324',
  'New York': '55.8',
  'San Francisco': '49.0',
  Austin: '62.0'
}, {
  date: '20120325',
  'New York': '48.4',
  'San Francisco': '46.4',
  Austin: '64.6'
}, {
  date: '20120326',
  'New York': '49.8',
  'San Francisco': '49.7',
  Austin: '66.0'
}, {
  date: '20120327',
  'New York': '39.6',
  'San Francisco': '54.1',
  Austin: '65.8'
}, {
  date: '20120328',
  'New York': '49.7',
  'San Francisco': '54.6',
  Austin: '69.2'
}, {
  date: '20120329',
  'New York': '56.8',
  'San Francisco': '52.3',
  Austin: '69.5'
}, {
  date: '20120330',
  'New York': '46.5',
  'San Francisco': '54.5',
  Austin: '73.5'
}, {
  date: '20120331',
  'New York': '42.2',
  'San Francisco': '56.2',
  Austin: '73.9'
}, {
  date: '20120401',
  'New York': '45.3',
  'San Francisco': '51.1',
  Austin: '75.3'
}, {
  date: '20120402',
  'New York': '48.1',
  'San Francisco': '50.5',
  Austin: '75.4'
}, {
  date: '20120403',
  'New York': '51.2',
  'San Francisco': '52.2',
  Austin: '77.3'
}, {
  date: '20120404',
  'New York': '61.0',
  'San Francisco': '50.6',
  Austin: '67.0'
}, {
  date: '20120405',
  'New York': '50.7',
  'San Francisco': '47.9',
  Austin: '71.1'
}, {
  date: '20120406',
  'New York': '48.0',
  'San Francisco': '47.4',
  Austin: '70.4'
}, {
  date: '20120407',
  'New York': '51.1',
  'San Francisco': '49.4',
  Austin: '73.6'
}, {
  date: '20120408',
  'New York': '55.7',
  'San Francisco': '50.0',
  Austin: '71.1'
}, {
  date: '20120409',
  'New York': '58.3',
  'San Francisco': '51.3',
  Austin: '70.0'
}, {
  date: '20120410',
  'New York': '55.0',
  'San Francisco': '53.8',
  Austin: '69.0'
}, {
  date: '20120411',
  'New York': '49.0',
  'San Francisco': '52.9',
  Austin: '69.2'
}, {
  date: '20120412',
  'New York': '51.7',
  'San Francisco': '53.9',
  Austin: '74.5'
}, {
  date: '20120413',
  'New York': '53.1',
  'San Francisco': '50.2',
  Austin: '73.4'
}, {
  date: '20120414',
  'New York': '55.2',
  'San Francisco': '50.9',
  Austin: '76.0'
}, {
  date: '20120415',
  'New York': '62.3',
  'San Francisco': '51.5',
  Austin: '74.5'
}, {
  date: '20120416',
  'New York': '62.9',
  'San Francisco': '51.9',
  Austin: '63.6'
}, {
  date: '20120417',
  'New York': '69.3',
  'San Francisco': '53.2',
  Austin: '67.3'
}, {
  date: '20120418',
  'New York': '59.0',
  'San Francisco': '53.0',
  Austin: '65.1'
}, {
  date: '20120419',
  'New York': '54.1',
  'San Francisco': '55.1',
  Austin: '67.9'
}, {
  date: '20120420',
  'New York': '56.5',
  'San Francisco': '55.8',
  Austin: '68.9'
}, {
  date: '20120421',
  'New York': '58.2',
  'San Francisco': '58.0',
  Austin: '65.1'
}, {
  date: '20120422',
  'New York': '52.4',
  'San Francisco': '52.8',
  Austin: '65.4'
}, {
  date: '20120423',
  'New York': '51.6',
  'San Francisco': '55.1',
  Austin: '70.1'
}, {
  date: '20120424',
  'New York': '49.3',
  'San Francisco': '57.9',
  Austin: '67.0'
}, {
  date: '20120425',
  'New York': '52.5',
  'San Francisco': '57.5',
  Austin: '75.4'
}, {
  date: '20120426',
  'New York': '50.5',
  'San Francisco': '55.3',
  Austin: '77.5'
}, {
  date: '20120427',
  'New York': '51.9',
  'San Francisco': '53.5',
  Austin: '77.0'
}, {
  date: '20120428',
  'New York': '47.4',
  'San Francisco': '54.7',
  Austin: '77.7'
}, {
  date: '20120429',
  'New York': '54.1',
  'San Francisco': '54.0',
  Austin: '77.7'
}, {
  date: '20120430',
  'New York': '51.9',
  'San Francisco': '53.4',
  Austin: '77.7'
}, {
  date: '20120501',
  'New York': '57.4',
  'San Francisco': '52.7',
  Austin: '77.0'
}, {
  date: '20120502',
  'New York': '53.7',
  'San Francisco': '50.7',
  Austin: '77.9'
}, {
  date: '20120503',
  'New York': '53.1',
  'San Francisco': '52.6',
  Austin: '79.1'
}, {
  date: '20120504',
  'New York': '57.2',
  'San Francisco': '53.4',
  Austin: '80.1'
}, {
  date: '20120505',
  'New York': '57.0',
  'San Francisco': '53.1',
  Austin: '82.1'
}, {
  date: '20120506',
  'New York': '56.6',
  'San Francisco': '56.5',
  Austin: '79.0'
}, {
  date: '20120507',
  'New York': '54.6',
  'San Francisco': '55.3',
  Austin: '79.8'
}, {
  date: '20120508',
  'New York': '57.9',
  'San Francisco': '52.0',
  Austin: '70.0'
}, {
  date: '20120509',
  'New York': '59.2',
  'San Francisco': '52.4',
  Austin: '69.8'
}, {
  date: '20120510',
  'New York': '61.1',
  'San Francisco': '53.4',
  Austin: '71.3'
}, {
  date: '20120511',
  'New York': '59.7',
  'San Francisco': '53.1',
  Austin: '69.4'
}, {
  date: '20120512',
  'New York': '64.1',
  'San Francisco': '49.9',
  Austin: '72.0'
}, {
  date: '20120513',
  'New York': '65.3',
  'San Francisco': '52.0',
  Austin: '72.4'
}, {
  date: '20120514',
  'New York': '64.2',
  'San Francisco': '56.0',
  Austin: '72.5'
}, {
  date: '20120515',
  'New York': '62.0',
  'San Francisco': '53.0',
  Austin: '67.6'
}, {
  date: '20120516',
  'New York': '63.8',
  'San Francisco': '51.0',
  Austin: '69.0'
}, {
  date: '20120517',
  'New York': '64.5',
  'San Francisco': '51.4',
  Austin: '72.7'
}, {
  date: '20120518',
  'New York': '61.0',
  'San Francisco': '52.2',
  Austin: '73.7'
}, {
  date: '20120519',
  'New York': '62.6',
  'San Francisco': '52.4',
  Austin: '77.5'
}, {
  date: '20120520',
  'New York': '66.2',
  'San Francisco': '54.5',
  Austin: '75.8'
}, {
  date: '20120521',
  'New York': '62.7',
  'San Francisco': '52.8',
  Austin: '76.9'
}, {
  date: '20120522',
  'New York': '63.7',
  'San Francisco': '53.9',
  Austin: '78.8'
}, {
  date: '20120523',
  'New York': '66.4',
  'San Francisco': '56.5',
  Austin: '77.7'
}, {
  date: '20120524',
  'New York': '64.5',
  'San Francisco': '54.7',
  Austin: '80.6'
}, {
  date: '20120525',
  'New York': '65.4',
  'San Francisco': '52.5',
  Austin: '81.4'
}, {
  date: '20120526',
  'New York': '69.4',
  'San Francisco': '52.1',
  Austin: '82.3'
}, {
  date: '20120527',
  'New York': '71.9',
  'San Francisco': '52.2',
  Austin: '80.3'
}, {
  date: '20120528',
  'New York': '74.4',
  'San Francisco': '52.9',
  Austin: '80.3'
}, {
  date: '20120529',
  'New York': '75.9',
  'San Francisco': '52.1',
  Austin: '82.2'
}, {
  date: '20120530',
  'New York': '72.9',
  'San Francisco': '52.1',
  Austin: '81.9'
}, {
  date: '20120531',
  'New York': '72.5',
  'San Francisco': '53.3',
  Austin: '82.4'
}, {
  date: '20120601',
  'New York': '67.2',
  'San Francisco': '54.8',
  Austin: '77.9'
}, {
  date: '20120602',
  'New York': '68.3',
  'San Francisco': '54.0',
  Austin: '81.1'
}, {
  date: '20120603',
  'New York': '67.7',
  'San Francisco': '52.3',
  Austin: '82.2'
}, {
  date: '20120604',
  'New York': '61.9',
  'San Francisco': '55.3',
  Austin: '81.2'
}, {
  date: '20120605',
  'New York': '58.3',
  'San Francisco': '53.5',
  Austin: '83.0'
}, {
  date: '20120606',
  'New York': '61.7',
  'San Francisco': '54.1',
  Austin: '83.2'
}, {
  date: '20120607',
  'New York': '66.7',
  'San Francisco': '53.9',
  Austin: '82.1'
}, {
  date: '20120608',
  'New York': '68.7',
  'San Francisco': '54.4',
  Austin: '77.5'
}, {
  date: '20120609',
  'New York': '72.2',
  'San Francisco': '55.0',
  Austin: '77.9'
}, {
  date: '20120610',
  'New York': '72.6',
  'San Francisco': '60.0',
  Austin: '82.9'
}, {
  date: '20120611',
  'New York': '69.2',
  'San Francisco': '57.2',
  Austin: '86.8'
}, {
  date: '20120612',
  'New York': '66.9',
  'San Francisco': '55.1',
  Austin: '85.3'
}, {
  date: '20120613',
  'New York': '66.7',
  'San Francisco': '53.3',
  Austin: '76.9'
}, {
  date: '20120614',
  'New York': '67.7',
  'San Francisco': '53.4',
  Austin: '84.5'
}, {
  date: '20120615',
  'New York': '68.5',
  'San Francisco': '54.6',
  Austin: '84.4'
}, {
  date: '20120616',
  'New York': '67.5',
  'San Francisco': '57.0',
  Austin: '83.8'
}, {
  date: '20120617',
  'New York': '64.2',
  'San Francisco': '55.6',
  Austin: '82.5'
}, {
  date: '20120618',
  'New York': '61.7',
  'San Francisco': '52.5',
  Austin: '82.9'
}, {
  date: '20120619',
  'New York': '66.4',
  'San Francisco': '53.9',
  Austin: '82.5'
}, {
  date: '20120620',
  'New York': '77.9',
  'San Francisco': '55.3',
  Austin: '81.3'
}, {
  date: '20120621',
  'New York': '88.3',
  'San Francisco': '53.3',
  Austin: '80.8'
}, {
  date: '20120622',
  'New York': '82.2',
  'San Francisco': '54.1',
  Austin: '81.7'
}, {
  date: '20120623',
  'New York': '77.0',
  'San Francisco': '55.2',
  Austin: '83.9'
}, {
  date: '20120624',
  'New York': '75.4',
  'San Francisco': '55.8',
  Austin: '85.5'
}, {
  date: '20120625',
  'New York': '70.9',
  'San Francisco': '56.8',
  Austin: '87.2'
}, {
  date: '20120626',
  'New York': '65.9',
  'San Francisco': '57.5',
  Austin: '88.0'
}, {
  date: '20120627',
  'New York': '73.5',
  'San Francisco': '57.7',
  Austin: '89.6'
}, {
  date: '20120628',
  'New York': '77.4',
  'San Francisco': '56.6',
  Austin: '86.7'
}, {
  date: '20120629',
  'New York': '79.6',
  'San Francisco': '56.4',
  Austin: '85.3'
}, {
  date: '20120630',
  'New York': '84.2',
  'San Francisco': '58.4',
  Austin: '81.7'
}, {
  date: '20120701',
  'New York': '81.8',
  'San Francisco': '58.8',
  Austin: '78.5'
}, {
  date: '20120702',
  'New York': '82.5',
  'San Francisco': '56.4',
  Austin: '83.1'
}, {
  date: '20120703',
  'New York': '80.2',
  'San Francisco': '56.5',
  Austin: '83.1'
}, {
  date: '20120704',
  'New York': '77.8',
  'San Francisco': '55.8',
  Austin: '84.5'
}, {
  date: '20120705',
  'New York': '86.1',
  'San Francisco': '54.8',
  Austin: '84.6'
}, {
  date: '20120706',
  'New York': '79.9',
  'San Francisco': '54.9',
  Austin: '84.2'
}, {
  date: '20120707',
  'New York': '83.5',
  'San Francisco': '54.7',
  Austin: '86.7'
}, {
  date: '20120708',
  'New York': '81.5',
  'San Francisco': '52.8',
  Austin: '84.3'
}, {
  date: '20120709',
  'New York': '77.8',
  'San Francisco': '53.7',
  Austin: '83.7'
}, {
  date: '20120710',
  'New York': '76.1',
  'San Francisco': '53.1',
  Austin: '77.1'
}, {
  date: '20120711',
  'New York': '76.3',
  'San Francisco': '52.7',
  Austin: '77.4'
}, {
  date: '20120712',
  'New York': '75.8',
  'San Francisco': '52.0',
  Austin: '80.6'
}, {
  date: '20120713',
  'New York': '77.2',
  'San Francisco': '53.4',
  Austin: '81.4'
}, {
  date: '20120714',
  'New York': '79.3',
  'San Francisco': '54.0',
  Austin: '80.2'
}, {
  date: '20120715',
  'New York': '78.9',
  'San Francisco': '54.0',
  Austin: '81.8'
}, {
  date: '20120716',
  'New York': '79.6',
  'San Francisco': '54.5',
  Austin: '77.3'
}, {
  date: '20120717',
  'New York': '83.3',
  'San Francisco': '56.7',
  Austin: '80.8'
}, {
  date: '20120718',
  'New York': '84.3',
  'San Francisco': '57.5',
  Austin: '81.6'
}, {
  date: '20120719',
  'New York': '75.1',
  'San Francisco': '57.1',
  Austin: '80.9'
}, {
  date: '20120720',
  'New York': '68.4',
  'San Francisco': '58.1',
  Austin: '83.9'
}, {
  date: '20120721',
  'New York': '68.4',
  'San Francisco': '57.6',
  Austin: '85.6'
}, {
  date: '20120722',
  'New York': '72.2',
  'San Francisco': '56.0',
  Austin: '83.6'
}, {
  date: '20120723',
  'New York': '75.6',
  'San Francisco': '56.6',
  Austin: '84.0'
}, {
  date: '20120724',
  'New York': '82.6',
  'San Francisco': '57.8',
  Austin: '83.0'
}, {
  date: '20120725',
  'New York': '78.4',
  'San Francisco': '57.5',
  Austin: '84.8'
}, {
  date: '20120726',
  'New York': '77.0',
  'San Francisco': '56.4',
  Austin: '84.4'
}, {
  date: '20120727',
  'New York': '79.4',
  'San Francisco': '55.3',
  Austin: '84.3'
}, {
  date: '20120728',
  'New York': '77.4',
  'San Francisco': '55.0',
  Austin: '83.9'
}, {
  date: '20120729',
  'New York': '72.5',
  'San Francisco': '55.6',
  Austin: '85.0'
}, {
  date: '20120730',
  'New York': '72.9',
  'San Francisco': '55.6',
  Austin: '84.9'
}, {
  date: '20120731',
  'New York': '73.6',
  'San Francisco': '55.9',
  Austin: '86.3'
}, {
  date: '20120801',
  'New York': '75.0',
  'San Francisco': '55.4',
  Austin: '86.5'
}, {
  date: '20120802',
  'New York': '77.7',
  'San Francisco': '54.4',
  Austin: '85.8'
}, {
  date: '20120803',
  'New York': '79.7',
  'San Francisco': '53.7',
  Austin: '85.3'
}, {
  date: '20120804',
  'New York': '79.6',
  'San Francisco': '54.1',
  Austin: '86.0'
}, {
  date: '20120805',
  'New York': '81.5',
  'San Francisco': '57.8',
  Austin: '84.2'
}, {
  date: '20120806',
  'New York': '80.0',
  'San Francisco': '58.2',
  Austin: '81.9'
}, {
  date: '20120807',
  'New York': '75.7',
  'San Francisco': '58.0',
  Austin: '86.5'
}, {
  date: '20120808',
  'New York': '77.8',
  'San Francisco': '57.0',
  Austin: '86.1'
}, {
  date: '20120809',
  'New York': '78.6',
  'San Francisco': '55.0',
  Austin: '86.8'
}, {
  date: '20120810',
  'New York': '77.8',
  'San Francisco': '54.8',
  Austin: '88.0'
}, {
  date: '20120811',
  'New York': '78.5',
  'San Francisco': '53.0',
  Austin: '85.1'
}, {
  date: '20120812',
  'New York': '78.8',
  'San Francisco': '52.5',
  Austin: '87.4'
}, {
  date: '20120813',
  'New York': '78.6',
  'San Francisco': '53.3',
  Austin: '88.0'
}, {
  date: '20120814',
  'New York': '76.8',
  'San Francisco': '53.9',
  Austin: '88.0'
}, {
  date: '20120815',
  'New York': '76.7',
  'San Francisco': '56.2',
  Austin: '87.2'
}, {
  date: '20120816',
  'New York': '75.9',
  'San Francisco': '57.1',
  Austin: '86.1'
}, {
  date: '20120817',
  'New York': '77.6',
  'San Francisco': '55.3',
  Austin: '86.8'
}, {
  date: '20120818',
  'New York': '72.6',
  'San Francisco': '56.2',
  Austin: '84.9'
}, {
  date: '20120819',
  'New York': '70.4',
  'San Francisco': '54.3',
  Austin: '76.8'
}, {
  date: '20120820',
  'New York': '71.8',
  'San Francisco': '53.1',
  Austin: '80.6'
}, {
  date: '20120821',
  'New York': '73.6',
  'San Francisco': '53.4',
  Austin: '80.0'
}, {
  date: '20120822',
  'New York': '74.7',
  'San Francisco': '54.5',
  Austin: '78.2'
}, {
  date: '20120823',
  'New York': '74.6',
  'San Francisco': '55.7',
  Austin: '79.1'
}, {
  date: '20120824',
  'New York': '76.0',
  'San Francisco': '54.8',
  Austin: '81.9'
}, {
  date: '20120825',
  'New York': '76.2',
  'San Francisco': '53.8',
  Austin: '84.7'
}, {
  date: '20120826',
  'New York': '73.4',
  'San Francisco': '56.5',
  Austin: '83.5'
}, {
  date: '20120827',
  'New York': '74.6',
  'San Francisco': '58.3',
  Austin: '82.1'
}, {
  date: '20120828',
  'New York': '79.4',
  'San Francisco': '58.7',
  Austin: '84.0'
}, {
  date: '20120829',
  'New York': '74.7',
  'San Francisco': '57.5',
  Austin: '85.7'
}, {
  date: '20120830',
  'New York': '73.5',
  'San Francisco': '55.9',
  Austin: '87.2'
}, {
  date: '20120831',
  'New York': '77.9',
  'San Francisco': '55.4',
  Austin: '82.9'
}, {
  date: '20120901',
  'New York': '80.7',
  'San Francisco': '55.7',
  Austin: '84.8'
}, {
  date: '20120902',
  'New York': '75.1',
  'San Francisco': '53.1',
  Austin: '83.9'
}, {
  date: '20120903',
  'New York': '73.5',
  'San Francisco': '53.5',
  Austin: '85.5'
}, {
  date: '20120904',
  'New York': '73.5',
  'San Francisco': '52.5',
  Austin: '86.4'
}, {
  date: '20120905',
  'New York': '77.7',
  'San Francisco': '54.5',
  Austin: '85.8'
}, {
  date: '20120906',
  'New York': '74.2',
  'San Francisco': '56.3',
  Austin: '85.4'
}, {
  date: '20120907',
  'New York': '76.0',
  'San Francisco': '56.4',
  Austin: '85.3'
}, {
  date: '20120908',
  'New York': '77.1',
  'San Francisco': '56.5',
  Austin: '81.9'
}, {
  date: '20120909',
  'New York': '69.7',
  'San Francisco': '56.4',
  Austin: '74.8'
}, {
  date: '20120910',
  'New York': '67.8',
  'San Francisco': '55.4',
  Austin: '71.6'
}, {
  date: '20120911',
  'New York': '64.0',
  'San Francisco': '56.2',
  Austin: '75.9'
}, {
  date: '20120912',
  'New York': '68.1',
  'San Francisco': '55.7',
  Austin: '82.1'
}, {
  date: '20120913',
  'New York': '69.3',
  'San Francisco': '54.3',
  Austin: '80.5'
}, {
  date: '20120914',
  'New York': '70.0',
  'San Francisco': '55.2',
  Austin: '70.0'
}, {
  date: '20120915',
  'New York': '69.3',
  'San Francisco': '54.3',
  Austin: '71.2'
}, {
  date: '20120916',
  'New York': '66.3',
  'San Francisco': '52.9',
  Austin: '70.3'
}, {
  date: '20120917',
  'New York': '67.0',
  'San Francisco': '54.8',
  Austin: '72.1'
}, {
  date: '20120918',
  'New York': '72.8',
  'San Francisco': '54.8',
  Austin: '73.7'
}, {
  date: '20120919',
  'New York': '67.2',
  'San Francisco': '56.8',
  Austin: '72.7'
}, {
  date: '20120920',
  'New York': '62.1',
  'San Francisco': '55.4',
  Austin: '71.7'
}, {
  date: '20120921',
  'New York': '64.0',
  'San Francisco': '55.8',
  Austin: '72.9'
}, {
  date: '20120922',
  'New York': '65.5',
  'San Francisco': '55.9',
  Austin: '73.1'
}, {
  date: '20120923',
  'New York': '65.7',
  'San Francisco': '52.8',
  Austin: '75.6'
}, {
  date: '20120924',
  'New York': '60.4',
  'San Francisco': '54.5',
  Austin: '78.3'
}, {
  date: '20120925',
  'New York': '63.2',
  'San Francisco': '53.3',
  Austin: '78.3'
}, {
  date: '20120926',
  'New York': '68.5',
  'San Francisco': '53.6',
  Austin: '79.6'
}, {
  date: '20120927',
  'New York': '69.2',
  'San Francisco': '52.1',
  Austin: '76.4'
}, {
  date: '20120928',
  'New York': '68.7',
  'San Francisco': '52.6',
  Austin: '77.2'
}, {
  date: '20120929',
  'New York': '62.5',
  'San Francisco': '53.9',
  Austin: '75.2'
}, {
  date: '20120930',
  'New York': '62.3',
  'San Francisco': '55.1',
  Austin: '71.9'
}];

var lesMiserables = {
  nodes: [{ id: 'Myriel', group: 1 }, { id: 'Napoleon', group: 1 }, { id: 'Mlle.Baptistine', group: 1 }, { id: 'Mme.Magloire', group: 1 }, { id: 'CountessdeLo', group: 1 }, { id: 'Geborand', group: 1 }, { id: 'Champtercier', group: 1 }, { id: 'Cravatte', group: 1 }, { id: 'Count', group: 1 }, { id: 'OldMan', group: 1 }, { id: 'Labarre', group: 2 }, { id: 'Valjean', group: 2 }, { id: 'Marguerite', group: 3 }, { id: 'Mme.deR', group: 2 }, { id: 'Isabeau', group: 2 }, { id: 'Gervais', group: 2 }, { id: 'Tholomyes', group: 3 }, { id: 'Listolier', group: 3 }, { id: 'Fameuil', group: 3 }, { id: 'Blacheville', group: 3 }, { id: 'Favourite', group: 3 }, { id: 'Dahlia', group: 3 }, { id: 'Zephine', group: 3 }, { id: 'Fantine', group: 3 }, { id: 'Mme.Thenardier', group: 4 }, { id: 'Thenardier', group: 4 }, { id: 'Cosette', group: 5 }, { id: 'Javert', group: 4 }, { id: 'Fauchelevent', group: 0 }, { id: 'Bamatabois', group: 2 }, { id: 'Perpetue', group: 3 }, { id: 'Simplice', group: 2 }, { id: 'Scaufflaire', group: 2 }, { id: 'Woman1', group: 2 }, { id: 'Judge', group: 2 }, { id: 'Champmathieu', group: 2 }, { id: 'Brevet', group: 2 }, { id: 'Chenildieu', group: 2 }, { id: 'Cochepaille', group: 2 }, { id: 'Pontmercy', group: 4 }, { id: 'Boulatruelle', group: 6 }, { id: 'Eponine', group: 4 }, { id: 'Anzelma', group: 4 }, { id: 'Woman2', group: 5 }, { id: 'MotherInnocent', group: 0 }, { id: 'Gribier', group: 0 }, { id: 'Jondrette', group: 7 }, { id: 'Mme.Burgon', group: 7 }, { id: 'Gavroche', group: 8 }, { id: 'Gillenormand', group: 5 }, { id: 'Magnon', group: 5 }, { id: 'Mlle.Gillenormand', group: 5 }, { id: 'Mme.Pontmercy', group: 5 }, { id: 'Mlle.Vaubois', group: 5 }, { id: 'Lt.Gillenormand', group: 5 }, { id: 'Marius', group: 8 }, { id: 'BaronessT', group: 5 }, { id: 'Mabeuf', group: 8 }, { id: 'Enjolras', group: 8 }, { id: 'Combeferre', group: 8 }, { id: 'Prouvaire', group: 8 }, { id: 'Feuilly', group: 8 }, { id: 'Courfeyrac', group: 8 }, { id: 'Bahorel', group: 8 }, { id: 'Bossuet', group: 8 }, { id: 'Joly', group: 8 }, { id: 'Grantaire', group: 8 }, { id: 'MotherPlutarch', group: 9 }, { id: 'Gueulemer', group: 4 }, { id: 'Babet', group: 4 }, { id: 'Claquesous', group: 4 }, { id: 'Montparnasse', group: 4 }, { id: 'Toussaint', group: 5 }, { id: 'Child1', group: 10 }, { id: 'Child2', group: 10 }, { id: 'Brujon', group: 4 }, { id: 'Mme.Hucheloup', group: 8 }],
  links: [{ source: 'Napoleon', target: 'Myriel', value: 1 }, { source: 'Mlle.Baptistine', target: 'Myriel', value: 8 }, { source: 'Mme.Magloire', target: 'Myriel', value: 10 }, { source: 'Mme.Magloire', target: 'Mlle.Baptistine', value: 6 }, { source: 'CountessdeLo', target: 'Myriel', value: 1 }, { source: 'Geborand', target: 'Myriel', value: 1 }, { source: 'Champtercier', target: 'Myriel', value: 1 }, { source: 'Cravatte', target: 'Myriel', value: 1 }, { source: 'Count', target: 'Myriel', value: 2 }, { source: 'OldMan', target: 'Myriel', value: 1 }, { source: 'Valjean', target: 'Labarre', value: 1 }, { source: 'Valjean', target: 'Mme.Magloire', value: 3 }, { source: 'Valjean', target: 'Mlle.Baptistine', value: 3 }, { source: 'Valjean', target: 'Myriel', value: 5 }, { source: 'Marguerite', target: 'Valjean', value: 1 }, { source: 'Mme.deR', target: 'Valjean', value: 1 }, { source: 'Isabeau', target: 'Valjean', value: 1 }, { source: 'Gervais', target: 'Valjean', value: 1 }, { source: 'Listolier', target: 'Tholomyes', value: 4 }, { source: 'Fameuil', target: 'Tholomyes', value: 4 }, { source: 'Fameuil', target: 'Listolier', value: 4 }, { source: 'Blacheville', target: 'Tholomyes', value: 4 }, { source: 'Blacheville', target: 'Listolier', value: 4 }, { source: 'Blacheville', target: 'Fameuil', value: 4 }, { source: 'Favourite', target: 'Tholomyes', value: 3 }, { source: 'Favourite', target: 'Listolier', value: 3 }, { source: 'Favourite', target: 'Fameuil', value: 3 }, { source: 'Favourite', target: 'Blacheville', value: 4 }, { source: 'Dahlia', target: 'Tholomyes', value: 3 }, { source: 'Dahlia', target: 'Listolier', value: 3 }, { source: 'Dahlia', target: 'Fameuil', value: 3 }, { source: 'Dahlia', target: 'Blacheville', value: 3 }, { source: 'Dahlia', target: 'Favourite', value: 5 }, { source: 'Zephine', target: 'Tholomyes', value: 3 }, { source: 'Zephine', target: 'Listolier', value: 3 }, { source: 'Zephine', target: 'Fameuil', value: 3 }, { source: 'Zephine', target: 'Blacheville', value: 3 }, { source: 'Zephine', target: 'Favourite', value: 4 }, { source: 'Zephine', target: 'Dahlia', value: 4 }, { source: 'Fantine', target: 'Tholomyes', value: 3 }, { source: 'Fantine', target: 'Listolier', value: 3 }, { source: 'Fantine', target: 'Fameuil', value: 3 }, { source: 'Fantine', target: 'Blacheville', value: 3 }, { source: 'Fantine', target: 'Favourite', value: 4 }, { source: 'Fantine', target: 'Dahlia', value: 4 }, { source: 'Fantine', target: 'Zephine', value: 4 }, { source: 'Fantine', target: 'Marguerite', value: 2 }, { source: 'Fantine', target: 'Valjean', value: 9 }, { source: 'Mme.Thenardier', target: 'Fantine', value: 2 }, { source: 'Mme.Thenardier', target: 'Valjean', value: 7 }, { source: 'Thenardier', target: 'Mme.Thenardier', value: 13 }, { source: 'Thenardier', target: 'Fantine', value: 1 }, { source: 'Thenardier', target: 'Valjean', value: 12 }, { source: 'Cosette', target: 'Mme.Thenardier', value: 4 }, { source: 'Cosette', target: 'Valjean', value: 31 }, { source: 'Cosette', target: 'Tholomyes', value: 1 }, { source: 'Cosette', target: 'Thenardier', value: 1 }, { source: 'Javert', target: 'Valjean', value: 17 }, { source: 'Javert', target: 'Fantine', value: 5 }, { source: 'Javert', target: 'Thenardier', value: 5 }, { source: 'Javert', target: 'Mme.Thenardier', value: 1 }, { source: 'Javert', target: 'Cosette', value: 1 }, { source: 'Fauchelevent', target: 'Valjean', value: 8 }, { source: 'Fauchelevent', target: 'Javert', value: 1 }, { source: 'Bamatabois', target: 'Fantine', value: 1 }, { source: 'Bamatabois', target: 'Javert', value: 1 }, { source: 'Bamatabois', target: 'Valjean', value: 2 }, { source: 'Perpetue', target: 'Fantine', value: 1 }, { source: 'Simplice', target: 'Perpetue', value: 2 }, { source: 'Simplice', target: 'Valjean', value: 3 }, { source: 'Simplice', target: 'Fantine', value: 2 }, { source: 'Simplice', target: 'Javert', value: 1 }, { source: 'Scaufflaire', target: 'Valjean', value: 1 }, { source: 'Woman1', target: 'Valjean', value: 2 }, { source: 'Woman1', target: 'Javert', value: 1 }, { source: 'Judge', target: 'Valjean', value: 3 }, { source: 'Judge', target: 'Bamatabois', value: 2 }, { source: 'Champmathieu', target: 'Valjean', value: 3 }, { source: 'Champmathieu', target: 'Judge', value: 3 }, { source: 'Champmathieu', target: 'Bamatabois', value: 2 }, { source: 'Brevet', target: 'Judge', value: 2 }, { source: 'Brevet', target: 'Champmathieu', value: 2 }, { source: 'Brevet', target: 'Valjean', value: 2 }, { source: 'Brevet', target: 'Bamatabois', value: 1 }, { source: 'Chenildieu', target: 'Judge', value: 2 }, { source: 'Chenildieu', target: 'Champmathieu', value: 2 }, { source: 'Chenildieu', target: 'Brevet', value: 2 }, { source: 'Chenildieu', target: 'Valjean', value: 2 }, { source: 'Chenildieu', target: 'Bamatabois', value: 1 }, { source: 'Cochepaille', target: 'Judge', value: 2 }, { source: 'Cochepaille', target: 'Champmathieu', value: 2 }, { source: 'Cochepaille', target: 'Brevet', value: 2 }, { source: 'Cochepaille', target: 'Chenildieu', value: 2 }, { source: 'Cochepaille', target: 'Valjean', value: 2 }, { source: 'Cochepaille', target: 'Bamatabois', value: 1 }, { source: 'Pontmercy', target: 'Thenardier', value: 1 }, { source: 'Boulatruelle', target: 'Thenardier', value: 1 }, { source: 'Eponine', target: 'Mme.Thenardier', value: 2 }, { source: 'Eponine', target: 'Thenardier', value: 3 }, { source: 'Anzelma', target: 'Eponine', value: 2 }, { source: 'Anzelma', target: 'Thenardier', value: 2 }, { source: 'Anzelma', target: 'Mme.Thenardier', value: 1 }, { source: 'Woman2', target: 'Valjean', value: 3 }, { source: 'Woman2', target: 'Cosette', value: 1 }, { source: 'Woman2', target: 'Javert', value: 1 }, { source: 'MotherInnocent', target: 'Fauchelevent', value: 3 }, { source: 'MotherInnocent', target: 'Valjean', value: 1 }, { source: 'Gribier', target: 'Fauchelevent', value: 2 }, { source: 'Mme.Burgon', target: 'Jondrette', value: 1 }, { source: 'Gavroche', target: 'Mme.Burgon', value: 2 }, { source: 'Gavroche', target: 'Thenardier', value: 1 }, { source: 'Gavroche', target: 'Javert', value: 1 }, { source: 'Gavroche', target: 'Valjean', value: 1 }, { source: 'Gillenormand', target: 'Cosette', value: 3 }, { source: 'Gillenormand', target: 'Valjean', value: 2 }, { source: 'Magnon', target: 'Gillenormand', value: 1 }, { source: 'Magnon', target: 'Mme.Thenardier', value: 1 }, { source: 'Mlle.Gillenormand', target: 'Gillenormand', value: 9 }, { source: 'Mlle.Gillenormand', target: 'Cosette', value: 2 }, { source: 'Mlle.Gillenormand', target: 'Valjean', value: 2 }, { source: 'Mme.Pontmercy', target: 'Mlle.Gillenormand', value: 1 }, { source: 'Mme.Pontmercy', target: 'Pontmercy', value: 1 }, { source: 'Mlle.Vaubois', target: 'Mlle.Gillenormand', value: 1 }, { source: 'Lt.Gillenormand', target: 'Mlle.Gillenormand', value: 2 }, { source: 'Lt.Gillenormand', target: 'Gillenormand', value: 1 }, { source: 'Lt.Gillenormand', target: 'Cosette', value: 1 }, { source: 'Marius', target: 'Mlle.Gillenormand', value: 6 }, { source: 'Marius', target: 'Gillenormand', value: 12 }, { source: 'Marius', target: 'Pontmercy', value: 1 }, { source: 'Marius', target: 'Lt.Gillenormand', value: 1 }, { source: 'Marius', target: 'Cosette', value: 21 }, { source: 'Marius', target: 'Valjean', value: 19 }, { source: 'Marius', target: 'Tholomyes', value: 1 }, { source: 'Marius', target: 'Thenardier', value: 2 }, { source: 'Marius', target: 'Eponine', value: 5 }, { source: 'Marius', target: 'Gavroche', value: 4 }, { source: 'BaronessT', target: 'Gillenormand', value: 1 }, { source: 'BaronessT', target: 'Marius', value: 1 }, { source: 'Mabeuf', target: 'Marius', value: 1 }, { source: 'Mabeuf', target: 'Eponine', value: 1 }, { source: 'Mabeuf', target: 'Gavroche', value: 1 }, { source: 'Enjolras', target: 'Marius', value: 7 }, { source: 'Enjolras', target: 'Gavroche', value: 7 }, { source: 'Enjolras', target: 'Javert', value: 6 }, { source: 'Enjolras', target: 'Mabeuf', value: 1 }, { source: 'Enjolras', target: 'Valjean', value: 4 }, { source: 'Combeferre', target: 'Enjolras', value: 15 }, { source: 'Combeferre', target: 'Marius', value: 5 }, { source: 'Combeferre', target: 'Gavroche', value: 6 }, { source: 'Combeferre', target: 'Mabeuf', value: 2 }, { source: 'Prouvaire', target: 'Gavroche', value: 1 }, { source: 'Prouvaire', target: 'Enjolras', value: 4 }, { source: 'Prouvaire', target: 'Combeferre', value: 2 }, { source: 'Feuilly', target: 'Gavroche', value: 2 }, { source: 'Feuilly', target: 'Enjolras', value: 6 }, { source: 'Feuilly', target: 'Prouvaire', value: 2 }, { source: 'Feuilly', target: 'Combeferre', value: 5 }, { source: 'Feuilly', target: 'Mabeuf', value: 1 }, { source: 'Feuilly', target: 'Marius', value: 1 }, { source: 'Courfeyrac', target: 'Marius', value: 9 }, { source: 'Courfeyrac', target: 'Enjolras', value: 17 }, { source: 'Courfeyrac', target: 'Combeferre', value: 13 }, { source: 'Courfeyrac', target: 'Gavroche', value: 7 }, { source: 'Courfeyrac', target: 'Mabeuf', value: 2 }, { source: 'Courfeyrac', target: 'Eponine', value: 1 }, { source: 'Courfeyrac', target: 'Feuilly', value: 6 }, { source: 'Courfeyrac', target: 'Prouvaire', value: 3 }, { source: 'Bahorel', target: 'Combeferre', value: 5 }, { source: 'Bahorel', target: 'Gavroche', value: 5 }, { source: 'Bahorel', target: 'Courfeyrac', value: 6 }, { source: 'Bahorel', target: 'Mabeuf', value: 2 }, { source: 'Bahorel', target: 'Enjolras', value: 4 }, { source: 'Bahorel', target: 'Feuilly', value: 3 }, { source: 'Bahorel', target: 'Prouvaire', value: 2 }, { source: 'Bahorel', target: 'Marius', value: 1 }, { source: 'Bossuet', target: 'Marius', value: 5 }, { source: 'Bossuet', target: 'Courfeyrac', value: 12 }, { source: 'Bossuet', target: 'Gavroche', value: 5 }, { source: 'Bossuet', target: 'Bahorel', value: 4 }, { source: 'Bossuet', target: 'Enjolras', value: 10 }, { source: 'Bossuet', target: 'Feuilly', value: 6 }, { source: 'Bossuet', target: 'Prouvaire', value: 2 }, { source: 'Bossuet', target: 'Combeferre', value: 9 }, { source: 'Bossuet', target: 'Mabeuf', value: 1 }, { source: 'Bossuet', target: 'Valjean', value: 1 }, { source: 'Joly', target: 'Bahorel', value: 5 }, { source: 'Joly', target: 'Bossuet', value: 7 }, { source: 'Joly', target: 'Gavroche', value: 3 }, { source: 'Joly', target: 'Courfeyrac', value: 5 }, { source: 'Joly', target: 'Enjolras', value: 5 }, { source: 'Joly', target: 'Feuilly', value: 5 }, { source: 'Joly', target: 'Prouvaire', value: 2 }, { source: 'Joly', target: 'Combeferre', value: 5 }, { source: 'Joly', target: 'Mabeuf', value: 1 }, { source: 'Joly', target: 'Marius', value: 2 }, { source: 'Grantaire', target: 'Bossuet', value: 3 }, { source: 'Grantaire', target: 'Enjolras', value: 3 }, { source: 'Grantaire', target: 'Combeferre', value: 1 }, { source: 'Grantaire', target: 'Courfeyrac', value: 2 }, { source: 'Grantaire', target: 'Joly', value: 2 }, { source: 'Grantaire', target: 'Gavroche', value: 1 }, { source: 'Grantaire', target: 'Bahorel', value: 1 }, { source: 'Grantaire', target: 'Feuilly', value: 1 }, { source: 'Grantaire', target: 'Prouvaire', value: 1 }, { source: 'MotherPlutarch', target: 'Mabeuf', value: 3 }, { source: 'Gueulemer', target: 'Thenardier', value: 5 }, { source: 'Gueulemer', target: 'Valjean', value: 1 }, { source: 'Gueulemer', target: 'Mme.Thenardier', value: 1 }, { source: 'Gueulemer', target: 'Javert', value: 1 }, { source: 'Gueulemer', target: 'Gavroche', value: 1 }, { source: 'Gueulemer', target: 'Eponine', value: 1 }, { source: 'Babet', target: 'Thenardier', value: 6 }, { source: 'Babet', target: 'Gueulemer', value: 6 }, { source: 'Babet', target: 'Valjean', value: 1 }, { source: 'Babet', target: 'Mme.Thenardier', value: 1 }, { source: 'Babet', target: 'Javert', value: 2 }, { source: 'Babet', target: 'Gavroche', value: 1 }, { source: 'Babet', target: 'Eponine', value: 1 }, { source: 'Claquesous', target: 'Thenardier', value: 4 }, { source: 'Claquesous', target: 'Babet', value: 4 }, { source: 'Claquesous', target: 'Gueulemer', value: 4 }, { source: 'Claquesous', target: 'Valjean', value: 1 }, { source: 'Claquesous', target: 'Mme.Thenardier', value: 1 }, { source: 'Claquesous', target: 'Javert', value: 1 }, { source: 'Claquesous', target: 'Eponine', value: 1 }, { source: 'Claquesous', target: 'Enjolras', value: 1 }, { source: 'Montparnasse', target: 'Javert', value: 1 }, { source: 'Montparnasse', target: 'Babet', value: 2 }, { source: 'Montparnasse', target: 'Gueulemer', value: 2 }, { source: 'Montparnasse', target: 'Claquesous', value: 2 }, { source: 'Montparnasse', target: 'Valjean', value: 1 }, { source: 'Montparnasse', target: 'Gavroche', value: 1 }, { source: 'Montparnasse', target: 'Eponine', value: 1 }, { source: 'Montparnasse', target: 'Thenardier', value: 1 }, { source: 'Toussaint', target: 'Cosette', value: 2 }, { source: 'Toussaint', target: 'Javert', value: 1 }, { source: 'Toussaint', target: 'Valjean', value: 1 }, { source: 'Child1', target: 'Gavroche', value: 2 }, { source: 'Child2', target: 'Gavroche', value: 2 }, { source: 'Child2', target: 'Child1', value: 3 }, { source: 'Brujon', target: 'Babet', value: 3 }, { source: 'Brujon', target: 'Gueulemer', value: 3 }, { source: 'Brujon', target: 'Thenardier', value: 3 }, { source: 'Brujon', target: 'Gavroche', value: 1 }, { source: 'Brujon', target: 'Eponine', value: 1 }, { source: 'Brujon', target: 'Claquesous', value: 1 }, { source: 'Brujon', target: 'Montparnasse', value: 1 }, { source: 'Mme.Hucheloup', target: 'Bossuet', value: 1 }, { source: 'Mme.Hucheloup', target: 'Joly', value: 1 }, { source: 'Mme.Hucheloup', target: 'Grantaire', value: 1 }, { source: 'Mme.Hucheloup', target: 'Bahorel', value: 1 }, { source: 'Mme.Hucheloup', target: 'Courfeyrac', value: 1 }, { source: 'Mme.Hucheloup', target: 'Gavroche', value: 1 }, { source: 'Mme.Hucheloup', target: 'Enjolras', value: 1 }]
};

var exoplanets = [{
  name: 'Jupiter',
  radius: '10.97',
  distance: '0'
}, {
  name: 'Saturn',
  radius: '9.14',
  distance: '0'
}, {
  name: 'Uranus',
  radius: '3.98',
  distance: '0'
}, {
  name: 'Neptune',
  radius: '3.86',
  distance: '0'
}, {
  name: 'Earth',
  radius: '1',
  distance: '0'
}, {
  name: 'Venus',
  radius: '0.950',
  distance: '0'
}, {
  name: 'Mars',
  radius: '0.532',
  distance: '0'
}, {
  name: 'Mercury',
  radius: '0.383',
  distance: '0'
}, {
  name: 'Pluto',
  radius: '0.181',
  distance: '0'
}, {
  name: '11 Com b',
  radius: '12.64',
  distance: '110.60'
}, {
  name: '11 UMi b',
  radius: '12.89',
  distance: '119.50'
}, {
  name: '14 And b',
  radius: '13.18',
  distance: '76.40'
}, {
  name: '14 Her b',
  radius: '13.24',
  distance: '18.10'
}, {
  name: '16 Cyg B b',
  radius: '13.69',
  distance: '21.41'
}, {
  name: '18 Del b',
  radius: '12.90',
  distance: '73.10'
}, {
  name: '1RXS1609 b',
  radius: '19.04',
  distance: '145.00'
}, {
  name: '24 Sex b',
  radius: '13.62',
  distance: '74.80'
}, {
  name: '24 Sex c',
  radius: '13.99',
  distance: '74.80'
}, {
  name: '2M 0103(AB) b',
  radius: '12.74',
  distance: '47.20'
}, {
  name: '2M 0122-2439 b',
  radius: '12.74',
  distance: '36.00'
}, {
  name: '2M 044144 b',
  radius: '13.04',
  distance: '140.00'
}, {
  name: '2M 0746+20 b',
  radius: '10.86',
  distance: '12.21'
}, {
  name: '2M 2140+16 b',
  radius: '10.30',
  distance: '25.00'
}, {
  name: '2M 2206-20 b',
  radius: '14.56',
  distance: '26.67'
}, {
  name: '2M1207 b',
  radius: '13.31',
  distance: '52.40'
}, {
  name: '30 Ari B b',
  radius: '12.92',
  distance: '39.40'
}, {
  name: '4 Uma b',
  radius: '13.06',
  distance: '78.50'
}, {
  name: '42 Dra b',
  radius: '13.32',
  distance: '97.30'
}, {
  name: '47 Uma b',
  radius: '13.51',
  distance: '13.97'
}, {
  name: '47 Uma c',
  radius: '14.21',
  distance: '13.97'
}, {
  name: '47 Uma d',
  radius: '13.70',
  distance: '13.97'
}, {
  name: '51 Peg b',
  radius: '14.28',
  distance: '14.70'
}, {
  name: '55 Cnc b',
  radius: '14.03',
  distance: '12.34'
}, {
  name: '55 Cnc c',
  radius: '8.48',
  distance: '12.34'
}, {
  name: '55 Cnc d',
  radius: '13.33',
  distance: '12.34'
}, {
  name: '55 Cnc e',
  radius: '1.99',
  distance: '12.34'
}, {
  name: '55 Cnc f',
  radius: '7.75',
  distance: '12.34'
}, {
  name: '6 Lyn b',
  radius: '13.53',
  distance: '56.90'
}, {
  name: '61 Vir b',
  radius: '1.89',
  distance: '8.52'
}, {
  name: '61 Vir c',
  radius: '4.63',
  distance: '8.52'
}, {
  name: '61 Vir d',
  radius: '5.26',
  distance: '8.52'
}, {
  name: '7 CMa b',
  radius: '13.50',
  distance: '19.75'
}, {
  name: '70 Vir b',
  radius: '13.09',
  distance: '22.00'
}, {
  name: '75 Cet b',
  radius: '13.37',
  distance: '81.50'
}, {
  name: '81 Cet b',
  radius: '13.19',
  distance: '97.20'
}, {
  name: '91 Aqr b',
  radius: '13.41',
  distance: '45.90'
}, {
  name: 'AB Pic b',
  radius: '12.79',
  distance: '47.30'
}, {
  name: 'alf Ari b',
  radius: '13.66',
  distance: '20.20'
}, {
  name: 'alf Cen B b',
  radius: '1.10',
  distance: '1.30'
}, {
  name: 'BD +48 738 b',
  radius: '13.90',
  distance: ''
}, {
  name: 'BD+15 2940 b',
  radius: '13.81',
  distance: '585.00'
}, {
  name: 'BD+20 274 c',
  radius: '13.22',
  distance: ''
}, {
  name: 'BD-061339 b',
  radius: '3.29',
  distance: '20.00'
}, {
  name: 'BD-061339 c',
  radius: '9.22',
  distance: '20.00'
}, {
  name: 'BD-082823 b',
  radius: '4.04',
  distance: '42.20'
}, {
  name: 'BD-082823 c',
  radius: '14.44',
  distance: '42.20'
}, {
  name: 'BD-10 3166 b',
  radius: '14.26',
  distance: '66.00'
}, {
  name: 'BD-17 63 b',
  radius: '13.20',
  distance: '34.60'
}, {
  name: 'BD14 4559 b',
  radius: '13.75',
  distance: '50.00'
}, {
  name: 'BD20 2457 b',
  radius: '12.60',
  distance: '200.00'
}, {
  name: 'BD20 2457 c',
  radius: '12.82',
  distance: '200.00'
}, {
  name: 'beta Pic b',
  radius: '13.07',
  distance: '19.30'
}, {
  name: 'CD-35 2722 b',
  radius: '12.44',
  distance: '21.30'
}, {
  name: 'CFBDS 1458 b',
  radius: '13.10',
  distance: '23.10'
}, {
  name: 'CHXR 73 b',
  radius: '12.78',
  distance: ''
}, {
  name: 'CoRoT-1 b',
  radius: '16.69',
  distance: '460.00'
}, {
  name: 'CoRoT-10 b',
  radius: '10.86',
  distance: '345.00'
}, {
  name: 'CoRoT-11 b',
  radius: '16.02',
  distance: '560.00'
}, {
  name: 'CoRoT-12 b',
  radius: '16.13',
  distance: '1150.00'
}, {
  name: 'CoRoT-13 b',
  radius: '9.91',
  distance: '1310.00'
}, {
  name: 'CoRoT-14 b',
  radius: '12.21',
  distance: '1340.00'
}, {
  name: 'CoRoT-16 b',
  radius: '13.10',
  distance: '840.00'
}, {
  name: 'CoRoT-17 b',
  radius: '11.42',
  distance: '920.00'
}, {
  name: 'CoRoT-18 b',
  radius: '14.67',
  distance: '870.00'
}, {
  name: 'CoRoT-19 b',
  radius: '14.45',
  distance: '800.00'
}, {
  name: 'CoRoT-2 b',
  radius: '16.41',
  distance: '300.00'
}, {
  name: 'CoRoT-20 b',
  radius: '9.41',
  distance: '1230.00'
}, {
  name: 'CoRoT-21 b',
  radius: '14.56',
  distance: ''
}, {
  name: 'CoRoT-23 b',
  radius: '12.10',
  distance: '600.00'
}, {
  name: 'CoRoT-25 b',
  radius: '12.10',
  distance: '1000.00'
}, {
  name: 'CoRoT-26 b',
  radius: '14.11',
  distance: '1670.00'
}, {
  name: 'CoRoT-3 b',
  radius: '11.31',
  distance: '680.00'
}, {
  name: 'CoRoT-4 b',
  radius: '13.33',
  distance: ''
}, {
  name: 'CoRoT-5 b',
  radius: '14.90',
  distance: '400.00'
}, {
  name: 'CoRoT-6 b',
  radius: '13.06',
  distance: ''
}, {
  name: 'CoRoT-7 b',
  radius: '1.67',
  distance: '150.00'
}, {
  name: 'CoRoT-7 c',
  radius: '2.43',
  distance: '150.00'
}, {
  name: 'CoRoT-8 b',
  radius: '6.37',
  distance: '380.00'
}, {
  name: 'CoRoT-9 b',
  radius: '10.53',
  distance: '460.00'
}, {
  name: 'CT Cha b',
  radius: '24.64',
  distance: '165.00'
}, {
  name: 'DH Tau b',
  radius: '12.81',
  distance: ''
}, {
  name: 'DP Leo b',
  radius: '13.07',
  distance: ''
}, {
  name: 'eps CrB b',
  radius: '13.02',
  distance: '67.90'
}, {
  name: 'eps Eridani b',
  radius: '13.73',
  distance: '3.20'
}, {
  name: 'eps Tau b',
  radius: '13.03',
  distance: '45.00'
}, {
  name: 'Fomalhaut b',
  radius: '13.61',
  distance: '7.70'
}, {
  name: 'FU Tau b',
  radius: '12.74',
  distance: '140.00'
}, {
  name: 'gamma 1 Leo b',
  radius: '12.97',
  distance: '38.50'
}, {
  name: 'gamma Cephei b',
  radius: '13.65',
  distance: '13.79'
}, {
  name: 'GJ 1214 b',
  radius: '2.67',
  distance: '13.00'
}, {
  name: 'GJ 163 b',
  radius: '3.71',
  distance: '15.00'
}, {
  name: 'GJ 163 c',
  radius: '2.43',
  distance: '15.00'
}, {
  name: 'Gj 163 d',
  radius: '5.58',
  distance: '15.00'
}, {
  name: 'GJ 176 b',
  radius: '2.43',
  distance: '9.42'
}, {
  name: 'GJ 3021 b',
  radius: '13.38',
  distance: '17.62'
}, {
  name: 'GJ 317 b',
  radius: '13.66',
  distance: '15.10'
}, {
  name: 'GJ 317 c',
  radius: '13.61',
  distance: '15.10'
}, {
  name: 'GJ 328 b',
  radius: '13.49',
  distance: '19.80'
}, {
  name: 'GJ 3470 b',
  radius: '4.19',
  distance: '30.70'
}, {
  name: 'GJ 3634 b',
  radius: '2.20',
  distance: '19.80'
}, {
  name: 'GJ 433 b',
  radius: '2.01',
  distance: '9.04'
}, {
  name: 'GJ 433 c',
  radius: '7.63',
  distance: '9.04'
}, {
  name: 'GJ 436 b',
  radius: '4.09',
  distance: '10.20'
}, {
  name: 'GJ 504 b',
  radius: '13.24',
  distance: '17.56'
}, {
  name: 'GJ 667C b',
  radius: '1.95',
  distance: '7.23'
}, {
  name: 'GJ 667C c',
  radius: '1.74',
  distance: '7.23'
}, {
  name: 'GJ 667C d',
  radius: '2.19',
  distance: '7.23'
}, {
  name: 'GJ 667C e',
  radius: '1.52',
  distance: '7.23'
}, {
  name: 'GJ 667C f',
  radius: '1.52',
  distance: '7.23'
}, {
  name: 'GJ 667C g',
  radius: '1.93',
  distance: '7.23'
}, {
  name: 'GJ 674 b',
  radius: '3.62',
  distance: '4.54'
}, {
  name: 'GJ 676A b',
  radius: '13.21',
  distance: '16.45'
}, {
  name: 'GJ 676A c',
  radius: '13.37',
  distance: '16.45'
}, {
  name: 'GJ 676A d',
  radius: '1.90',
  distance: '16.45'
}, {
  name: 'GJ 676A e',
  radius: '3.87',
  distance: '16.45'
}, {
  name: 'GJ 832 b',
  radius: '14.13',
  distance: '4.94'
}, {
  name: 'GJ 849 b',
  radius: '13.97',
  distance: '9.10'
}, {
  name: 'GJ 849 c',
  radius: '13.98',
  distance: '9.10'
}, {
  name: 'Gl 179 b',
  radius: '14.02',
  distance: '12.30'
}, {
  name: 'Gl 581 b',
  radius: '4.29',
  distance: '6.21'
}, {
  name: 'Gl 581 c',
  radius: '1.94',
  distance: '6.21'
}, {
  name: 'Gl 581 d',
  radius: '2.05',
  distance: '6.21'
}, {
  name: 'Gl 581 e',
  radius: '1.27',
  distance: '6.21'
}, {
  name: 'Gl 649 b',
  radius: '14.44',
  distance: '10.34'
}, {
  name: 'Gl 649 c',
  radius: '3.49',
  distance: '10.34'
}, {
  name: 'Gl 86 b',
  radius: '13.31',
  distance: '10.90'
}, {
  name: 'Gliese 876 b',
  radius: '13.56',
  distance: '4.70'
}, {
  name: 'Gliese 876 c',
  radius: '14.08',
  distance: '4.70'
}, {
  name: 'Gliese 876 d',
  radius: '2.15',
  distance: '4.70'
}, {
  name: 'Gliese 876 e',
  radius: '4.09',
  distance: '4.70'
}, {
  name: 'GQ Lup b',
  radius: '20.16',
  distance: '140.00'
}, {
  name: 'GSC 06214-00210 b',
  radius: '12.69',
  distance: '145.00'
}, {
  name: 'HAT-P-1 b',
  radius: '14.77',
  distance: '139.00'
}, {
  name: 'HAT-P-11 b',
  radius: '4.73',
  distance: '38.00'
}, {
  name: 'HAT-P-12 b',
  radius: '10.69',
  distance: '142.50'
}, {
  name: 'HAT-P-13 b',
  radius: '14.34',
  distance: '214.00'
}, {
  name: 'HAT-P-13 c',
  radius: '12.76',
  distance: '214.00'
}, {
  name: 'HAT-P-14 b',
  radius: '13.44',
  distance: '205.00'
}, {
  name: 'HAT-P-15 b',
  radius: '12.01',
  distance: '190.00'
}, {
  name: 'HAT-P-16 b',
  radius: '14.44',
  distance: '235.00'
}, {
  name: 'HAT-P-17 b',
  radius: '11.31',
  distance: '90.00'
}, {
  name: 'HAT-P-17 c',
  radius: '13.77',
  distance: '90.00'
}, {
  name: 'HAT-P-18 b',
  radius: '11.09',
  distance: '166.00'
}, {
  name: 'HAT-P-19 b',
  radius: '12.68',
  distance: '215.00'
}, {
  name: 'HAT-P-2 b',
  radius: '10.65',
  distance: '118.00'
}, {
  name: 'HAT-P-20 b',
  radius: '9.71',
  distance: '70.00'
}, {
  name: 'HAT-P-21 b',
  radius: '11.47',
  distance: '254.00'
}, {
  name: 'HAT-P-22 b',
  radius: '12.10',
  distance: '82.00'
}, {
  name: 'HAT-P-23 b',
  radius: '15.32',
  distance: '393.00'
}, {
  name: 'HAT-P-24 b',
  radius: '13.91',
  distance: '306.00'
}, {
  name: 'HAT-P-25 b',
  radius: '13.33',
  distance: '297.00'
}, {
  name: 'HAT-P-26 b',
  radius: '6.32',
  distance: '134.00'
}, {
  name: 'HAT-P-27-WASP-40 b',
  radius: '11.82',
  distance: '204.00'
}, {
  name: 'HAT-P-28 b',
  radius: '13.57',
  distance: '395.00'
}, {
  name: 'HAT-P-29 b',
  radius: '12.40',
  distance: '322.00'
}, {
  name: 'HAT-P-3 b',
  radius: '9.26',
  distance: '130.00'
}, {
  name: 'HAT-P-30-WASP-51 b',
  radius: '15.01',
  distance: '193.00'
}, {
  name: 'HAT-P-31 b',
  radius: '11.98',
  distance: '354.00'
}, {
  name: 'HAT-P-32 b',
  radius: '22.81',
  distance: '320.00'
}, {
  name: 'HAT-P-33 b',
  radius: '20.46',
  distance: '419.00'
}, {
  name: 'HAT-P-34 b',
  radius: '12.40',
  distance: '257.00'
}, {
  name: 'HAT-P-35 b',
  radius: '14.92',
  distance: '535.00'
}, {
  name: 'HAT-P-36 b',
  radius: '14.16',
  distance: '317.00'
}, {
  name: 'HAT-P-37 b',
  radius: '13.19',
  distance: '411.00'
}, {
  name: 'HAT-P-38 b',
  radius: '9.24',
  distance: '249.00'
}, {
  name: 'HAT-P-39 b',
  radius: '17.60',
  distance: '642.00'
}, {
  name: 'HAT-P-4 b',
  radius: '14.22',
  distance: '310.00'
}, {
  name: 'HAT-P-40 b',
  radius: '19.38',
  distance: '501.00'
}, {
  name: 'HAT-P-41 b',
  radius: '17.12',
  distance: '311.00'
}, {
  name: 'HAT-P-42 b',
  radius: '14.30',
  distance: '447.00'
}, {
  name: 'HAT-P-43 b',
  radius: '14.37',
  distance: '543.00'
}, {
  name: 'HAT-P-44 b',
  radius: '14.34',
  distance: '374.00'
}, {
  name: 'HAT-P-44 c',
  radius: '13.65',
  distance: '374.00'
}, {
  name: 'HAT-P-45 b',
  radius: '15.97',
  distance: '305.00'
}, {
  name: 'HAT-P-46 b',
  radius: '14.38',
  distance: '296.00'
}, {
  name: 'HAT-P-46 c',
  radius: '13.55',
  distance: '296.00'
}, {
  name: 'HAT-P-5 b',
  radius: '14.02',
  distance: '340.00'
}, {
  name: 'HAT-P-6 b',
  radius: '14.90',
  distance: '200.00'
}, {
  name: 'HAT-P-7 b',
  radius: '15.92',
  distance: '320.00'
}, {
  name: 'HAT-P-8 b',
  radius: '16.80',
  distance: '230.00'
}, {
  name: 'HAT-P-9 b',
  radius: '15.68',
  distance: '480.00'
}, {
  name: 'HATS-1 b',
  radius: '14.58',
  distance: '303.00'
}, {
  name: 'HATS-2 b',
  radius: '13.08',
  distance: '360.00'
}, {
  name: 'HATS-3 b',
  radius: '15.47',
  distance: '453.00'
}, {
  name: 'HD 100655 b',
  radius: '13.69',
  distance: '122.00'
}, {
  name: 'HD 100777 b',
  radius: '13.86',
  distance: '52.80'
}, {
  name: 'HD 10180 c',
  radius: '3.85',
  distance: '39.40'
}, {
  name: 'HD 10180 d',
  radius: '3.62',
  distance: '39.40'
}, {
  name: 'HD 10180 e',
  radius: '5.54',
  distance: '39.40'
}, {
  name: 'HD 10180 f',
  radius: '5.39',
  distance: '39.40'
}, {
  name: 'HD 10180 g',
  radius: '5.06',
  distance: '39.40'
}, {
  name: 'HD 10180 h',
  radius: '9.38',
  distance: '39.40'
}, {
  name: 'HD 101930 b',
  radius: '11.69',
  distance: '30.49'
}, {
  name: 'HD 102117 b',
  radius: '8.56',
  distance: '42.00'
}, {
  name: 'HD 102195 b',
  radius: '14.30',
  distance: '28.98'
}, {
  name: 'HD 102272 b',
  radius: '13.14',
  distance: '360.00'
}, {
  name: 'HD 102272 c',
  radius: '13.50',
  distance: '360.00'
}, {
  name: 'HD 102329 b',
  radius: '13.14',
  distance: '158.00'
}, {
  name: 'HD 102365 b',
  radius: '4.29',
  distance: '9.24'
}, {
  name: 'HD 102956 b',
  radius: '13.94',
  distance: '126.00'
}, {
  name: 'HD 103197 b',
  radius: '6.25',
  distance: '49.30'
}, {
  name: 'HD 103774 b',
  radius: '14.32',
  distance: '55.00'
}, {
  name: 'HD 104067 b',
  radius: '8.95',
  distance: '20.80'
}, {
  name: 'HD 104985 b',
  radius: '13.11',
  distance: '102.00'
}, {
  name: 'HD 106252 b',
  radius: '13.03',
  distance: '37.44'
}, {
  name: 'HD 106270 b',
  radius: '12.87',
  distance: '84.90'
}, {
  name: 'HD 10647 b',
  radius: '13.96',
  distance: '17.30'
}, {
  name: 'HD 106515A b',
  radius: '12.87',
  distance: '35.20'
}, {
  name: 'HD 10697 b',
  radius: '13.11',
  distance: '32.56'
}, {
  name: 'HD 107148 b',
  radius: '9.57',
  distance: '51.30'
}, {
  name: 'HD 108147 b',
  radius: '10.81',
  distance: '38.57'
}, {
  name: 'HD 108863 b',
  radius: '13.50',
  distance: '139.00'
}, {
  name: 'HD 108874 b',
  radius: '13.79',
  distance: '68.50'
}, {
  name: 'HD 108874 c',
  radius: '13.92',
  distance: '68.50'
}, {
  name: 'HD 109246 b',
  radius: '14.05',
  distance: '65.60'
}, {
  name: 'HD 109271 b',
  radius: '4.85',
  distance: '62.00'
}, {
  name: 'HD 109271 c',
  radius: '5.87',
  distance: '62.00'
}, {
  name: 'HD 109749 b',
  radius: '11.25',
  distance: '59.00'
}, {
  name: 'HD 110014 b',
  radius: '12.87',
  distance: '90.00'
}, {
  name: 'HD 111232 b',
  radius: '13.08',
  distance: '29.00'
}, {
  name: 'HD 113337 b',
  radius: '13.40',
  distance: '36.90'
}, {
  name: 'HD 113538 b',
  radius: '11.02',
  distance: '15.80'
}, {
  name: 'HD 113538 c',
  radius: '14.08',
  distance: '15.80'
}, {
  name: 'HD 114386 b',
  radius: '13.83',
  distance: '28.00'
}, {
  name: 'HD 114386 c',
  radius: '13.78',
  distance: '28.00'
}, {
  name: 'HD 114729 b',
  radius: '14.01',
  distance: '35.00'
}, {
  name: 'HD 114762 b',
  radius: '12.87',
  distance: '39.46'
}, {
  name: 'HD 114783 b',
  radius: '13.93',
  distance: '20.40'
}, {
  name: 'HD 11506 b',
  radius: '13.37',
  distance: '53.82'
}, {
  name: 'HD 11506 c',
  radius: '14.02',
  distance: '53.82'
}, {
  name: 'HD 116029 b',
  radius: '13.59',
  distance: '123.20'
}, {
  name: 'HD 117207 b',
  radius: '13.60',
  distance: '33.00'
}, {
  name: 'HD 117618 b',
  radius: '8.73',
  distance: '38.00'
}, {
  name: 'HD 117618 c',
  radius: '10.10',
  distance: '38.00'
}, {
  name: 'HD 118203 b',
  radius: '13.59',
  distance: '88.60'
}, {
  name: 'HD 11964 b',
  radius: '14.14',
  distance: '33.98'
}, {
  name: 'HD 11964 c',
  radius: '5.54',
  distance: '33.98'
}, {
  name: 'HD 11977 b',
  radius: '13.09',
  distance: '66.50'
}, {
  name: 'HD 120084 b',
  radius: '13.19',
  distance: '97.70'
}, {
  name: 'HD 121504 b',
  radius: '13.84',
  distance: '44.37'
}, {
  name: 'HD 122430 b',
  radius: '13.34',
  distance: '135.00'
}, {
  name: 'HD 125595 b',
  radius: '3.89',
  distance: '27.40'
}, {
  name: 'HD 125612 b',
  radius: '13.43',
  distance: '52.82'
}, {
  name: 'HD 125612 c',
  radius: '4.66',
  distance: '52.82'
}, {
  name: 'HD 125612 d',
  radius: '13.05',
  distance: '52.82'
}, {
  name: 'HD 126525 b',
  radius: '9.93',
  distance: '38.10'
}, {
  name: 'HD 12661 b',
  radius: '13.55',
  distance: '37.16'
}, {
  name: 'HD 12661 c',
  radius: '13.72',
  distance: '37.16'
}, {
  name: 'HD 126614 b',
  radius: '14.37',
  distance: '72.40'
}, {
  name: 'HD 128311 b',
  radius: '13.57',
  distance: '16.60'
}, {
  name: 'HD 128311 c',
  radius: '13.40',
  distance: '16.60'
}, {
  name: 'HD 129445 b',
  radius: '13.71',
  distance: '67.61'
}, {
  name: 'HD 130322 b',
  radius: '13.92',
  distance: '30.00'
}, {
  name: 'HD 131496 b',
  radius: '13.57',
  distance: '110.00'
}, {
  name: 'HD 13189 b',
  radius: '12.77',
  distance: '185.00'
}, {
  name: 'HD 132406 b',
  radius: '13.16',
  distance: '71.00'
}, {
  name: 'HD 132563B b',
  radius: '13.75',
  distance: '96.00'
}, {
  name: 'HD 134060 b',
  radius: '3.52',
  distance: '24.20'
}, {
  name: 'HD 134060 c',
  radius: '7.95',
  distance: '24.20'
}, {
  name: 'HD 134606 b',
  radius: '2.57',
  distance: '26.50'
}, {
  name: 'HD 134606 c',
  radius: '3.69',
  distance: '26.50'
}, {
  name: 'HD 134606 d',
  radius: '7.03',
  distance: '26.50'
}, {
  name: 'HD 134987 b',
  radius: '13.72',
  distance: '22.20'
}, {
  name: 'HD 134987 c',
  radius: '14.02',
  distance: '22.20'
}, {
  name: 'HD 136352 b',
  radius: '1.92',
  distance: '14.80'
}, {
  name: 'HD 136352 c',
  radius: '3.56',
  distance: '14.80'
}, {
  name: 'HD 136352 d',
  radius: '3.22',
  distance: '14.80'
}, {
  name: 'HD 136418 b',
  radius: '13.61',
  distance: '98.20'
}, {
  name: 'HD 137388 b',
  radius: '9.90',
  distance: '38.00'
}, {
  name: 'HD 13808 b',
  radius: '3.37',
  distance: '28.60'
}, {
  name: 'HD 13808 c',
  radius: '3.57',
  distance: '28.60'
}, {
  name: 'HD 13908 b',
  radius: '13.93',
  distance: '71.20'
}, {
  name: 'HD 13908 c',
  radius: '13.14',
  distance: '71.20'
}, {
  name: 'HD 13931 b',
  radius: '13.64',
  distance: '44.20'
}, {
  name: 'HD 139357 b',
  radius: '12.92',
  distance: '121.40'
}, {
  name: 'HD 141937 b',
  radius: '12.93',
  distance: '33.46'
}, {
  name: 'HD 142 b',
  radius: '13.82',
  distance: '20.60'
}, {
  name: 'HD 142 c',
  radius: '13.19',
  distance: '20.60'
}, {
  name: 'HD 142022 A b',
  radius: '13.20',
  distance: '35.87'
}, {
  name: 'HD 142245 b',
  radius: '13.64',
  distance: '109.50'
}, {
  name: 'HD 142415 b',
  radius: '13.71',
  distance: '34.20'
}, {
  name: 'HD 143361 b',
  radius: '13.42',
  distance: '59.35'
}, {
  name: 'HD 145377 b',
  radius: '13.15',
  distance: '57.70'
}, {
  name: 'HD 145457 b',
  radius: '13.45',
  distance: '126.00'
}, {
  name: 'HD 1461 b',
  radius: '2.30',
  distance: '23.40'
}, {
  name: 'HD 1461 c',
  radius: '2.03',
  distance: '23.40'
}, {
  name: 'HD 147018 b',
  radius: '13.59',
  distance: '42.96'
}, {
  name: 'HD 147018 c',
  radius: '13.09',
  distance: '42.96'
}, {
  name: 'HD 147513 b',
  radius: '13.84',
  distance: '12.90'
}, {
  name: 'HD 148156 b',
  radius: '14.00',
  distance: '53.05'
}, {
  name: 'HD 148427 b',
  radius: '13.94',
  distance: '59.30'
}, {
  name: 'HD 149026 b',
  radius: '8.04',
  distance: '78.90'
}, {
  name: 'HD 149143 b',
  radius: '13.79',
  distance: '63.00'
}, {
  name: 'HD 1502 b',
  radius: '13.42',
  distance: '159.00'
}, {
  name: 'HD 150433 b',
  radius: '8.45',
  distance: '29.60'
}, {
  name: 'HD 150706 b',
  radius: '13.48',
  distance: '27.20'
}, {
  name: 'HD 152079 b',
  radius: '13.43',
  distance: '85.17'
}, {
  name: 'HD 152581 b',
  radius: '13.74',
  distance: '186.00'
}, {
  name: 'HD 153950 b',
  radius: '13.48',
  distance: '49.60'
}, {
  name: 'HD 154088 b',
  radius: '2.06',
  distance: '17.80'
}, {
  name: 'HD 154345 b',
  radius: '13.93',
  distance: '18.06'
}, {
  name: 'HD 154672 b',
  radius: '13.21',
  distance: '65.80'
}, {
  name: 'HD 154857 b',
  radius: '13.66',
  distance: '68.50'
}, {
  name: 'HD 155358 b',
  radius: '14.00',
  distance: '43.00'
}, {
  name: 'HD 155358 c',
  radius: '14.02',
  distance: '43.00'
}, {
  name: 'HD 156279 b',
  radius: '12.93',
  distance: '36.60'
}, {
  name: 'HD 156411 b',
  radius: '14.06',
  distance: '55.10'
}, {
  name: 'HD 156668 b',
  radius: '1.72',
  distance: '24.50'
}, {
  name: 'HD 157172 b',
  radius: '7.00',
  distance: '31.90'
}, {
  name: 'HD 158038 b',
  radius: '13.66',
  distance: '103.60'
}, {
  name: 'HD 159243 b',
  radius: '13.81',
  distance: '69.20'
}, {
  name: 'HD 159243 c',
  radius: '13.57',
  distance: '69.20'
}, {
  name: 'HD 159868 b',
  radius: '13.59',
  distance: '52.70'
}, {
  name: 'HD 159868 c',
  radius: '14.07',
  distance: '52.70'
}, {
  name: 'HD 16141 b',
  radius: '9.70',
  distance: '35.90'
}, {
  name: 'HD 16175 b',
  radius: '13.27',
  distance: '59.80'
}, {
  name: 'HD 162020 b',
  radius: '12.76',
  distance: '31.26'
}, {
  name: 'HD 163607 b',
  radius: '14.05',
  distance: '69.00'
}, {
  name: 'HD 163607 c',
  radius: '13.55',
  distance: '69.00'
}, {
  name: 'HD 16417 b',
  radius: '5.13',
  distance: '25.50'
}, {
  name: 'HD 164509 b',
  radius: '14.26',
  distance: '52.00'
}, {
  name: 'HD 164604 b',
  radius: '13.48',
  distance: '38.00'
}, {
  name: 'HD 164922 b',
  radius: '14.40',
  distance: '21.93'
}, {
  name: 'HD 166724 b',
  radius: '13.30',
  distance: '42.30'
}, {
  name: 'HD 167042 b',
  radius: '13.71',
  distance: '50.00'
}, {
  name: 'HD 168443 b',
  radius: '13.03',
  distance: '37.38'
}, {
  name: 'HD 168443 c',
  radius: '12.69',
  distance: '37.38'
}, {
  name: 'HD 168746 b',
  radius: '10.07',
  distance: '43.12'
}, {
  name: 'HD 1690 b',
  radius: '13.12',
  distance: '319.00'
}, {
  name: 'HD 169830 b',
  radius: '13.45',
  distance: '36.32'
}, {
  name: 'HD 169830 c',
  radius: '13.30',
  distance: '36.32'
}, {
  name: 'HD 170469 b',
  radius: '14.11',
  distance: '64.97'
}, {
  name: 'HD 17092 b',
  radius: '13.25',
  distance: '109.00'
}, {
  name: 'HD 171028 b',
  radius: '13.62',
  distance: '90.00'
}, {
  name: 'HD 171238 b',
  radius: '13.50',
  distance: '50.28'
}, {
  name: 'HD 17156 b',
  radius: '12.26',
  distance: '78.24'
}, {
  name: 'HD 173416 b',
  radius: '13.48',
  distance: '135.00'
}, {
  name: 'HD 175167 b',
  radius: '13.02',
  distance: '67.02'
}, {
  name: 'HD 175541 b',
  radius: '14.15',
  distance: '128.00'
}, {
  name: 'HD 176051 b',
  radius: '13.74',
  distance: '14.99'
}, {
  name: 'HD 177830 b',
  radius: '13.75',
  distance: '59.00'
}, {
  name: 'HD 177830 c',
  radius: '7.93',
  distance: '59.00'
}, {
  name: 'HD 178911 B b',
  radius: '13.11',
  distance: '46.73'
}, {
  name: 'HD 179079 b',
  radius: '5.58',
  distance: '63.69'
}, {
  name: 'HD 179949 b',
  radius: '13.95',
  distance: '27.00'
}, {
  name: 'HD 180314 b',
  radius: '12.58',
  distance: '132.00'
}, {
  name: 'HD 180902 b',
  radius: '13.71',
  distance: '110.00'
}, {
  name: 'HD 181342 b',
  radius: '13.39',
  distance: '110.60'
}, {
  name: 'HD 181433 b',
  radius: '2.30',
  distance: '26.15'
}, {
  name: 'HD 181433 c',
  radius: '14.13',
  distance: '26.15'
}, {
  name: 'HD 181433 d',
  radius: '14.21',
  distance: '26.15'
}, {
  name: 'HD 181720 b',
  radius: '14.39',
  distance: '56.00'
}, {
  name: 'HD 183263 b',
  radius: '13.35',
  distance: '53.00'
}, {
  name: 'HD 183263 c',
  radius: '13.33',
  distance: '53.00'
}, {
  name: 'HD 185269 b',
  radius: '13.95',
  distance: '47.00'
}, {
  name: 'HD 187085 b',
  radius: '14.06',
  distance: '44.98'
}, {
  name: 'HD 187123 b',
  radius: '14.23',
  distance: '50.00'
}, {
  name: 'HD 187123 c',
  radius: '13.62',
  distance: '50.00'
}, {
  name: 'HD 18742 b',
  radius: '13.48',
  distance: '135.00'
}, {
  name: 'HD 188015 b',
  radius: '13.82',
  distance: '52.60'
}, {
  name: 'HD 189567 b',
  radius: '3.32',
  distance: '17.70'
}, {
  name: 'HD 189733 b',
  radius: '12.75',
  distance: '19.30'
}, {
  name: 'HD 190360 b',
  radius: '13.74',
  distance: '15.89'
}, {
  name: 'HD 190360 c',
  radius: '4.61',
  distance: '15.89'
}, {
  name: 'HD 190647 b',
  radius: '13.64',
  distance: '54.20'
}, {
  name: 'HD 190984 b',
  radius: '13.42',
  distance: '103.00'
}, {
  name: 'HD 192263 b',
  radius: '14.07',
  distance: '19.90'
}, {
  name: 'HD 192310 b',
  radius: '4.43',
  distance: '8.82'
}, {
  name: 'HD 192310 c',
  radius: '5.38',
  distance: '8.82'
}, {
  name: 'HD 192699 b',
  radius: '13.51',
  distance: '67.00'
}, {
  name: 'HD 195019 b',
  radius: '13.34',
  distance: '37.36'
}, {
  name: 'HD 196050 b',
  radius: '13.46',
  distance: '46.90'
}, {
  name: 'HD 196067 b',
  radius: '13.01',
  distance: '44.30'
}, {
  name: 'HD 196885 A b',
  radius: '13.44',
  distance: '33.00'
}, {
  name: 'HD 197037 b',
  radius: '14.03',
  distance: '33.00'
}, {
  name: 'HD 19994 b',
  radius: '13.69',
  distance: '22.38'
}, {
  name: 'HD 20003 b',
  radius: '3.67',
  distance: '43.80'
}, {
  name: 'HD 20003 c',
  radius: '3.90',
  distance: '43.80'
}, {
  name: 'HD 200964 b',
  radius: '13.65',
  distance: '68.40'
}, {
  name: 'HD 200964 c',
  radius: '13.97',
  distance: '68.40'
}, {
  name: 'HD 202206 b',
  radius: '12.68',
  distance: '46.34'
}, {
  name: 'HD 202206 c',
  radius: '13.52',
  distance: '46.34'
}, {
  name: 'HD 20367 b',
  radius: '13.90',
  distance: '27.00'
}, {
  name: 'HD 2039 b',
  radius: '13.22',
  distance: '89.80'
}, {
  name: 'HD 204313 b',
  radius: '13.36',
  distance: '47.37'
}, {
  name: 'HD 204313 c',
  radius: '4.48',
  distance: '47.37'
}, {
  name: 'HD 204313 d',
  radius: '13.69',
  distance: '47.37'
}, {
  name: 'HD 204941 b',
  radius: '10.93',
  distance: '27.00'
}, {
  name: 'HD 205739 b',
  radius: '13.78',
  distance: '90.30'
}, {
  name: 'HD 206610 b',
  radius: '13.57',
  distance: '194.00'
}, {
  name: 'HD 20781 b',
  radius: '3.67',
  distance: '35.40'
}, {
  name: 'HD 20781 c',
  radius: '4.27',
  distance: '35.40'
}, {
  name: 'HD 20782 b',
  radius: '13.64',
  distance: '36.02'
}, {
  name: 'HD 207832 b',
  radius: '14.13',
  distance: '54.40'
}, {
  name: 'HD 207832 c',
  radius: '14.00',
  distance: '54.40'
}, {
  name: 'HD 20794 b',
  radius: '1.44',
  distance: '6.06'
}, {
  name: 'HD 20794 c',
  radius: '1.38',
  distance: '6.06'
}, {
  name: 'HD 20794 d',
  radius: '1.83',
  distance: '6.06'
}, {
  name: 'HD 208487 b',
  radius: '14.34',
  distance: '45.00'
}, {
  name: 'HD 208527 b',
  radius: '12.86',
  distance: '320.20'
}, {
  name: 'HD 20868 b',
  radius: '13.62',
  distance: '48.90'
}, {
  name: 'HD 209458 b',
  radius: '15.46',
  distance: '47.00'
}, {
  name: 'HD 210277 b',
  radius: '13.83',
  distance: '21.29'
}, {
  name: 'HD 210702 b',
  radius: '13.64',
  distance: '56.00'
}, {
  name: 'HD 212301 b',
  radius: '14.30',
  distance: '52.70'
}, {
  name: 'HD 212771 b',
  radius: '13.55',
  distance: '131.00'
}, {
  name: 'HD 213240 b',
  radius: '13.26',
  distance: '40.75'
}, {
  name: 'HD 215152 b',
  radius: '1.45',
  distance: '21.50'
}, {
  name: 'HD 215152 c',
  radius: '1.52',
  distance: '21.50'
}, {
  name: 'HD 215456 b',
  radius: '6.35',
  distance: '38.00'
}, {
  name: 'HD 215456 c',
  radius: '10.46',
  distance: '38.00'
}, {
  name: 'HD 215497 b',
  radius: '2.10',
  distance: '44.00'
}, {
  name: 'HD 215497 c',
  radius: '14.44',
  distance: '44.00'
}, {
  name: 'HD 216435 b',
  radius: '13.82',
  distance: '33.30'
}, {
  name: 'HD 216437 b',
  radius: '13.66',
  distance: '26.50'
}, {
  name: 'HD 216770 b',
  radius: '14.12',
  distance: '38.00'
}, {
  name: 'HD 21693 b',
  radius: '3.35',
  distance: '32.40'
}, {
  name: 'HD 21693 c',
  radius: '4.95',
  distance: '32.40'
}, {
  name: 'HD 217107 b',
  radius: '13.80',
  distance: '19.72'
}, {
  name: 'HD 217107 c',
  radius: '13.52',
  distance: '19.72'
}, {
  name: 'HD 217786 b',
  radius: '12.80',
  distance: '54.80'
}, {
  name: 'HD 218566 b',
  radius: '9.57',
  distance: '29.94'
}, {
  name: 'HD 219077 b',
  radius: '12.84',
  distance: '29.35'
}, {
  name: 'HD 219415 b',
  radius: '13.86',
  distance: ''
}, {
  name: 'HD 219828 b',
  radius: '5.01',
  distance: '81.10'
}, {
  name: 'HD 220074 b',
  radius: '12.81',
  distance: '290.20'
}, {
  name: 'HD 220689 b',
  radius: '13.83',
  distance: '44.60'
}, {
  name: 'HD 220773 b',
  radius: '13.76',
  distance: '49.00'
}, {
  name: 'HD 221287 b',
  radius: '13.42',
  distance: '52.90'
}, {
  name: 'HD 222155 b',
  radius: '13.64',
  distance: '49.10'
}, {
  name: 'HD 222582 b',
  radius: '13.02',
  distance: '42.00'
}, {
  name: 'HD 224693 b',
  radius: '14.08',
  distance: '94.00'
}, {
  name: 'HD 22781 b',
  radius: '12.78',
  distance: '31.79'
}, {
  name: 'HD 23079 b',
  radius: '13.51',
  distance: '34.80'
}, {
  name: 'HD 23127 b',
  radius: '13.74',
  distance: '89.10'
}, {
  name: 'HD 231701 b',
  radius: '13.89',
  distance: '108.40'
}, {
  name: 'HD 233604 b',
  radius: '13.03',
  distance: ''
}, {
  name: 'HD 23596 b',
  radius: '13.00',
  distance: '52.00'
}, {
  name: 'HD 240210 b',
  radius: '13.07',
  distance: '143.00'
}, {
  name: 'HD 240237 b',
  radius: '13.19',
  distance: '1500.00'
}, {
  name: 'HD 24040 b',
  radius: '13.31',
  distance: '46.51'
}, {
  name: 'HD 25171 b',
  radius: '13.95',
  distance: '55.00'
}, {
  name: 'HD 2638 b',
  radius: '14.26',
  distance: '53.71'
}, {
  name: 'HD 27442 b',
  radius: '13.79',
  distance: '18.10'
}, {
  name: 'HD 27631 b',
  radius: '13.69',
  distance: '45.50'
}, {
  name: 'HD 27894 b',
  radius: '14.15',
  distance: '42.37'
}, {
  name: 'HD 28185 b',
  radius: '13.15',
  distance: '39.40'
}, {
  name: 'HD 28254 b',
  radius: '13.86',
  distance: '56.20'
}, {
  name: 'HD 285507 b',
  radius: '13.90',
  distance: '41.30'
}, {
  name: 'HD 28678 b',
  radius: '13.69',
  distance: '227.00'
}, {
  name: 'HD 290327 b',
  radius: '13.51',
  distance: '54.90'
}, {
  name: 'HD 2952 b',
  radius: '13.65',
  distance: '115.20'
}, {
  name: 'HD 30177 b',
  radius: '13.02',
  distance: '55.00'
}, {
  name: 'HD 30562 b',
  radius: '13.81',
  distance: '26.50'
}, {
  name: 'HD 30856 b',
  radius: '13.66',
  distance: '118.10'
}, {
  name: 'HD 31253 b',
  radius: '14.25',
  distance: '53.82'
}, {
  name: 'HD 31527 b',
  radius: '3.58',
  distance: '38.60'
}, {
  name: 'HD 31527 c',
  radius: '4.28',
  distance: '38.60'
}, {
  name: 'HD 31527 d',
  radius: '4.38',
  distance: '38.60'
}, {
  name: 'HD 32518 b',
  radius: '13.43',
  distance: '117.40'
}, {
  name: 'HD 330075 b',
  radius: '14.15',
  distance: '50.20'
}, {
  name: 'HD 33142 b',
  radius: '13.81',
  distance: '126.00'
}, {
  name: 'HD 33283 b',
  radius: '14.44',
  distance: '86.00'
}, {
  name: 'HD 33564 b',
  radius: '12.95',
  distance: '20.98'
}, {
  name: 'HD 34445 b',
  radius: '14.03',
  distance: '46.50'
}, {
  name: 'HD 3651 b',
  radius: '9.32',
  distance: '11.00'
}, {
  name: 'HD 3651 c',
  radius: '6.46',
  distance: '11.00'
}, {
  name: 'HD 37124 b',
  radius: '14.11',
  distance: '33.00'
}, {
  name: 'HD 37124 c',
  radius: '14.12',
  distance: '33.00'
}, {
  name: 'HD 37124 d',
  radius: '14.09',
  distance: '33.00'
}, {
  name: 'HD 37605 b',
  radius: '13.46',
  distance: '44.00'
}, {
  name: 'HD 37605 c',
  radius: '13.32',
  distance: '44.00'
}, {
  name: 'HD 38283 b',
  radius: '14.43',
  distance: '37.70'
}, {
  name: 'HD 38529 b',
  radius: '14.04',
  distance: '39.28'
}, {
  name: 'HD 38529 c',
  radius: '12.67',
  distance: '39.28'
}, {
  name: 'HD 38801 b',
  radius: '12.89',
  distance: '99.40'
}, {
  name: 'HD 38858 b',
  radius: '6.18',
  distance: '15.20'
}, {
  name: 'HD 39091 b',
  radius: '12.90',
  distance: '18.32'
}, {
  name: 'HD 39194 b',
  radius: '1.64',
  distance: '25.90'
}, {
  name: 'HD 39194 c',
  radius: '2.03',
  distance: '25.90'
}, {
  name: 'HD 39194 d',
  radius: '1.90',
  distance: '25.90'
}, {
  name: 'HD 40307 b',
  radius: '1.69',
  distance: '12.80'
}, {
  name: 'HD 40307 c',
  radius: '2.14',
  distance: '12.80'
}, {
  name: 'HD 40307 d',
  radius: '3.21',
  distance: '12.80'
}, {
  name: 'HD 40307 e',
  radius: '1.70',
  distance: '12.80'
}, {
  name: 'HD 40307 f',
  radius: '2.04',
  distance: '12.80'
}, {
  name: 'HD 40307 g',
  radius: '2.39',
  distance: '12.80'
}, {
  name: 'HD 40979 b',
  radius: '13.39',
  distance: '33.30'
}, {
  name: 'HD 41004 A b',
  radius: '13.51',
  distance: '42.50'
}, {
  name: 'HD 41004 B b',
  radius: '12.66',
  distance: '43.03'
}, {
  name: 'HD 4113 b',
  radius: '13.72',
  distance: '44.00'
}, {
  name: 'HD 41248 b',
  radius: '4.03',
  distance: '52.38'
}, {
  name: 'HD 41248 c',
  radius: '3.30',
  distance: '52.38'
}, {
  name: 'HD 4203 b',
  radius: '13.60',
  distance: '77.50'
}, {
  name: 'HD 4208 b',
  radius: '14.03',
  distance: '33.90'
}, {
  name: 'HD 4308 b',
  radius: '3.81',
  distance: '21.90'
}, {
  name: 'HD 4313 b',
  radius: '13.55',
  distance: '137.00'
}, {
  name: 'HD 43197 b',
  radius: '14.16',
  distance: '54.90'
}, {
  name: 'HD 43691 b',
  radius: '13.52',
  distance: '93.20'
}, {
  name: 'HD 44219 b',
  radius: '14.18',
  distance: '50.43'
}, {
  name: 'HD 45184 b',
  radius: '3.78',
  distance: '21.90'
}, {
  name: 'HD 45350 b',
  radius: '13.66',
  distance: '49.00'
}, {
  name: 'HD 45364 b',
  radius: '8.98',
  distance: '32.60'
}, {
  name: 'HD 45364 c',
  radius: '14.12',
  distance: '32.60'
}, {
  name: 'HD 45652 b',
  radius: '14.27',
  distance: '36.00'
}, {
  name: 'HD 46375 b',
  radius: '10.53',
  distance: '33.40'
}, {
  name: 'HD 47186 b',
  radius: '5.24',
  distance: '37.84'
}, {
  name: 'HD 47186 c',
  radius: '14.41',
  distance: '37.84'
}, {
  name: 'HD 47536 b',
  radius: '13.21',
  distance: '121.36'
}, {
  name: 'HD 47536 c',
  radius: '13.00',
  distance: '121.36'
}, {
  name: 'HD 48265 b',
  radius: '13.86',
  distance: '87.40'
}, {
  name: 'HD 49674 b',
  radius: '6.83',
  distance: '40.70'
}, {
  name: 'HD 50499 b',
  radius: '13.68',
  distance: '47.26'
}, {
  name: 'HD 50554 b',
  radius: '13.20',
  distance: '31.03'
}, {
  name: 'HD 51608 b',
  radius: '3.85',
  distance: '34.80'
}, {
  name: 'HD 51608 c',
  radius: '4.59',
  distance: '34.80'
}, {
  name: 'HD 52265 b',
  radius: '13.90',
  distance: '28.00'
}, {
  name: 'HD 52265 c',
  radius: '14.35',
  distance: '28.00'
}, {
  name: 'HD 5319 b',
  radius: '13.63',
  distance: '100.00'
}, {
  name: 'HD 5608 b',
  radius: '13.71',
  distance: '58.20'
}, {
  name: 'HD 5891 b',
  radius: '13.03',
  distance: '251.00'
}, {
  name: 'HD 59686 b',
  radius: '13.19',
  distance: '92.00'
}, {
  name: 'HD 60532 b',
  radius: '13.41',
  distance: '25.70'
}, {
  name: 'HD 60532 c',
  radius: '13.04',
  distance: '25.70'
}, {
  name: 'HD 62509 b',
  radius: '13.45',
  distance: '10.34'
}, {
  name: 'HD 63454 b',
  radius: '14.37',
  distance: '35.80'
}, {
  name: 'HD 63765 b',
  radius: '14.13',
  distance: '32.60'
}, {
  name: 'HD 6434 b',
  radius: '14.36',
  distance: '40.32'
}, {
  name: 'HD 65216 b',
  radius: '13.84',
  distance: '34.30'
}, {
  name: 'HD 65216 c',
  radius: '9.22',
  distance: '34.30'
}, {
  name: 'HD 66141 b',
  radius: '13.07',
  distance: '80.90'
}, {
  name: 'HD 66428 b',
  radius: '13.46',
  distance: '55.00'
}, {
  name: 'HD 6718 b',
  radius: '13.72',
  distance: '55.90'
}, {
  name: 'HD 68988 b',
  radius: '13.64',
  distance: '58.00'
}, {
  name: 'HD 69830 b',
  radius: '3.40',
  distance: '12.60'
}, {
  name: 'HD 69830 c',
  radius: '3.68',
  distance: '12.60'
}, {
  name: 'HD 69830 d',
  radius: '4.66',
  distance: '12.60'
}, {
  name: 'HD 70573 b',
  radius: '13.12',
  distance: '45.70'
}, {
  name: 'HD 70642 b',
  radius: '13.61',
  distance: '28.80'
}, {
  name: 'HD 7199 b',
  radius: '11.47',
  distance: '36.00'
}, {
  name: 'HD 72659 b',
  radius: '13.41',
  distance: '49.80'
}, {
  name: 'HD 73256 b',
  radius: '13.64',
  distance: '36.50'
}, {
  name: 'HD 73267 b',
  radius: '13.42',
  distance: '54.91'
}, {
  name: 'HD 73526 b',
  radius: '13.45',
  distance: '99.00'
}, {
  name: 'HD 73526 c',
  radius: '13.51',
  distance: '99.00'
}, {
  name: 'HD 73534 b',
  radius: '13.86',
  distance: '96.99'
}, {
  name: 'HD 74156 b',
  radius: '13.64',
  distance: '64.56'
}, {
  name: 'HD 74156 c',
  radius: '13.01',
  distance: '64.56'
}, {
  name: 'HD 7449 b',
  radius: '13.88',
  distance: '39.00'
}, {
  name: 'HD 7449 c',
  radius: '13.61',
  distance: '39.00'
}, {
  name: 'HD 75289 b',
  radius: '14.33',
  distance: '28.94'
}, {
  name: 'HD 75898 b',
  radius: '13.51',
  distance: '80.58'
}, {
  name: 'HD 76700 b',
  radius: '9.24',
  distance: '59.70'
}, {
  name: 'HD 77338 b',
  radius: '14.18',
  distance: '40.75'
}, {
  name: 'HD 7924 b',
  radius: '2.56',
  distance: '16.80'
}, {
  name: 'HD 79498 b',
  radius: '13.79',
  distance: '49.00'
}, {
  name: 'HD 80606 b',
  radius: '10.32',
  distance: '58.40'
}, {
  name: 'HD 81040 b',
  radius: '13.07',
  distance: '32.56'
}, {
  name: 'HD 81688 b',
  radius: '13.48',
  distance: '88.26'
}, {
  name: 'HD 82886 b',
  radius: '13.81',
  distance: '125.00'
}, {
  name: 'HD 82943 b',
  radius: '13.23',
  distance: '27.46'
}, {
  name: 'HD 82943 c',
  radius: '13.23',
  distance: '27.46'
}, {
  name: 'HD 82943 d',
  radius: '14.43',
  distance: '27.46'
}, {
  name: 'HD 83443 b',
  radius: '14.35',
  distance: '43.54'
}, {
  name: 'HD 8535 b',
  radius: '14.10',
  distance: '52.50'
}, {
  name: 'HD 85390 b',
  radius: '7.38',
  distance: '33.96'
}, {
  name: 'HD 85390 c',
  radius: '10.10',
  distance: '33.96'
}, {
  name: 'HD 85512 b',
  radius: '1.60',
  distance: '11.15'
}, {
  name: 'HD 8574 b',
  radius: '13.59',
  distance: '44.20'
}, {
  name: 'HD 86081 b',
  radius: '13.74',
  distance: '91.00'
}, {
  name: 'HD 86226 b',
  radius: '13.74',
  distance: '42.48'
}, {
  name: 'HD 86264 b',
  radius: '13.07',
  distance: '72.60'
}, {
  name: 'HD 8673 b',
  radius: '12.77',
  distance: '38.25'
}, {
  name: 'HD 87883 b',
  radius: '12.83',
  distance: '18.10'
}, {
  name: 'HD 88133 b',
  radius: '9.83',
  distance: '74.50'
}, {
  name: 'HD 89307 b',
  radius: '13.61',
  distance: '30.90'
}, {
  name: 'HD 89744 b',
  radius: '13.05',
  distance: '40.00'
}, {
  name: 'HD 89744 c',
  radius: '13.34',
  distance: '40.00'
}, {
  name: 'HD 90156 b',
  radius: '4.61',
  distance: '39.60'
}, {
  name: 'HD 92788 b',
  radius: '13.32',
  distance: '32.82'
}, {
  name: 'HD 92788 c',
  radius: '13.91',
  distance: '32.82'
}, {
  name: 'HD 93083 b',
  radius: '14.39',
  distance: '28.90'
}, {
  name: 'HD 93385 b',
  radius: '2.42',
  distance: '42.20'
}, {
  name: 'HD 93385 c',
  radius: '3.33',
  distance: '42.20'
}, {
  name: 'HD 9446 b',
  radius: '14.09',
  distance: '53.00'
}, {
  name: 'HD 9446 c',
  radius: '13.66',
  distance: '53.00'
}, {
  name: 'HD 95086 b',
  radius: '13.19',
  distance: '90.40'
}, {
  name: 'HD 95089 b',
  radius: '13.84',
  distance: '139.00'
}, {
  name: 'HD 9578 b',
  radius: '14.08',
  distance: '57.24'
}, {
  name: 'HD 96063 b',
  radius: '13.97',
  distance: '158.00'
}, {
  name: 'HD 96127 b',
  radius: '13.31',
  distance: '540.00'
}, {
  name: 'HD 96167 b',
  radius: '14.10',
  distance: '84.00'
}, {
  name: 'HD 96700 b',
  radius: '2.53',
  distance: '25.60'
}, {
  name: 'HD 96700 c',
  radius: '3.78',
  distance: '25.60'
}, {
  name: 'HD 97658 b',
  radius: '2.34',
  distance: '21.10'
}, {
  name: 'HD 98219 b',
  radius: '13.66',
  distance: '134.00'
}, {
  name: 'HD 98649 b',
  radius: '13.02',
  distance: '40.30'
}, {
  name: 'HD 99109 b',
  radius: '14.24',
  distance: '60.50'
}, {
  name: 'HD 99492 b',
  radius: '6.63',
  distance: '18.00'
}, {
  name: 'HD 99492 c',
  radius: '14.40',
  distance: '18.00'
}, {
  name: 'HD 99706 b',
  radius: '13.77',
  distance: '129.00'
}, {
  name: 'HIP 12961 b',
  radius: '14.41',
  distance: '23.00'
}, {
  name: 'HIP 13044 b',
  radius: '13.82',
  distance: '701.00'
}, {
  name: 'HIP 14810 b',
  radius: '13.32',
  distance: '52.90'
}, {
  name: 'HIP 14810 c',
  radius: '13.81',
  distance: '52.90'
}, {
  name: 'HIP 14810 d',
  radius: '14.18',
  distance: '52.90'
}, {
  name: 'HIP 5158 b',
  radius: '13.76',
  distance: '45.00'
}, {
  name: 'HIP 5158 c',
  radius: '12.74',
  distance: '45.00'
}, {
  name: 'HIP 57050 b',
  radius: '11.65',
  distance: '11.00'
}, {
  name: 'HIP 57274 b',
  radius: '3.57',
  distance: '25.92'
}, {
  name: 'HIP 57274 c',
  radius: '14.34',
  distance: '25.92'
}, {
  name: 'HIP 57274 d',
  radius: '14.22',
  distance: '25.92'
}, {
  name: 'HIP 63242 b',
  radius: '12.89',
  distance: '135.00'
}, {
  name: 'HIP 70849 b',
  radius: '12.96',
  distance: '24.00'
}, {
  name: 'HIP 75458 b',
  radius: '12.97',
  distance: '31.50'
}, {
  name: 'HIP 77900 b',
  radius: '12.56',
  distance: ''
}, {
  name: 'HIP 78530 b',
  radius: '12.57',
  distance: '156.70'
}, {
  name: 'HIP 79431 b',
  radius: '13.59',
  distance: '14.40'
}, {
  name: 'HIP 91258 b',
  radius: '13.83',
  distance: '44.90'
}, {
  name: 'HN Peg b',
  radius: '12.32',
  distance: '18.40'
}, {
  name: 'HR 228 b',
  radius: '13.47',
  distance: ''
}, {
  name: 'HR 228 c',
  radius: '13.47',
  distance: ''
}, {
  name: 'HR 810 b',
  radius: '13.56',
  distance: '17.17'
}, {
  name: 'HR 8799 b',
  radius: '12.32',
  distance: '39.40'
}, {
  name: 'HR 8799 c',
  radius: '14.56',
  distance: '39.40'
}, {
  name: 'HR 8799 d',
  radius: '13.44',
  distance: '39.40'
}, {
  name: 'HR 8799 e',
  radius: '12.96',
  distance: '39.40'
}, {
  name: 'HU Aqr(AB) c',
  radius: '13.08',
  distance: ''
}, {
  name: 'HW Vir(AB) b',
  radius: '12.76',
  distance: '181.00'
}, {
  name: 'kappa And b',
  radius: '12.74',
  distance: '51.60'
}, {
  name: 'kappa CrB b',
  radius: '13.71',
  distance: '31.10'
}, {
  name: 'KELT-1 b',
  radius: '12.50',
  distance: '263.00'
}, {
  name: 'KELT-2A b',
  radius: '14.63',
  distance: '128.90'
}, {
  name: 'KELT-3 b',
  radius: '14.93',
  distance: '178.00'
}, {
  name: 'KELT-6 b',
  radius: '13.33',
  distance: ''
}, {
  name: 'Kepler-10 b',
  radius: '1.41',
  distance: '173.00'
}, {
  name: 'Kepler-10 c',
  radius: '2.23',
  distance: '173.00'
}, {
  name: 'Kepler-11 b',
  radius: '1.80',
  distance: ''
}, {
  name: 'Kepler-11 c',
  radius: '2.87',
  distance: ''
}, {
  name: 'Kepler-11 d',
  radius: '3.12',
  distance: ''
}, {
  name: 'Kepler-11 e',
  radius: '4.53',
  distance: ''
}, {
  name: 'Kepler-11 f',
  radius: '2.49',
  distance: ''
}, {
  name: 'Kepler-11 g',
  radius: '3.67',
  distance: ''
}, {
  name: 'Kepler-12 b',
  radius: '18.98',
  distance: ''
}, {
  name: 'Kepler-13 b',
  radius: '20.50',
  distance: ''
}, {
  name: 'Kepler-14 b',
  radius: '12.72',
  distance: '980.00'
}, {
  name: 'Kepler-15 b',
  radius: '10.75',
  distance: ''
}, {
  name: 'Kepler-16(AB) b',
  radius: '8.44',
  distance: ''
}, {
  name: 'Kepler-17 b',
  radius: '14.69',
  distance: '800.00'
}, {
  name: 'Kepler-18 b',
  radius: '2.00',
  distance: ''
}, {
  name: 'Kepler-18 c',
  radius: '5.48',
  distance: ''
}, {
  name: 'Kepler-18 d',
  radius: '6.96',
  distance: ''
}, {
  name: 'Kepler-19 b',
  radius: '2.22',
  distance: ''
}, {
  name: 'Kepler-20 b',
  radius: '1.90',
  distance: '290.00'
}, {
  name: 'Kepler-20 c',
  radius: '3.06',
  distance: '290.00'
}, {
  name: 'Kepler-20 d',
  radius: '2.80',
  distance: '290.00'
}, {
  name: 'Kepler-20 e',
  radius: '0.87',
  distance: '290.00'
}, {
  name: 'Kepler-20 f',
  radius: '1.01',
  distance: '290.00'
}, {
  name: 'Kepler-21 b',
  radius: '1.63',
  distance: '108.00'
}, {
  name: 'Kepler-22 b',
  radius: '2.35',
  distance: '190.00'
}, {
  name: 'Kepler-23 b',
  radius: '1.90',
  distance: ''
}, {
  name: 'Kepler-23 c',
  radius: '3.25',
  distance: ''
}, {
  name: 'Kepler-24 b',
  radius: '2.35',
  distance: ''
}, {
  name: 'Kepler-24 c',
  radius: '2.80',
  distance: ''
}, {
  name: 'Kepler-25 b',
  radius: '2.58',
  distance: ''
}, {
  name: 'Kepler-25 c',
  radius: '4.48',
  distance: ''
}, {
  name: 'Kepler-26 b',
  radius: '3.58',
  distance: ''
}, {
  name: 'Kepler-26 c',
  radius: '3.58',
  distance: ''
}, {
  name: 'Kepler-27 b',
  radius: '4.03',
  distance: ''
}, {
  name: 'Kepler-27 c',
  radius: '4.93',
  distance: ''
}, {
  name: 'Kepler-28 b',
  radius: '3.58',
  distance: ''
}, {
  name: 'Kepler-28 c',
  radius: '3.36',
  distance: ''
}, {
  name: 'Kepler-29 b',
  radius: '3.58',
  distance: ''
}, {
  name: 'Kepler-29 c',
  radius: '2.91',
  distance: ''
}, {
  name: 'Kepler-30 b',
  radius: '3.92',
  distance: ''
}, {
  name: 'Kepler-30 c',
  radius: '12.32',
  distance: ''
}, {
  name: 'Kepler-30 d',
  radius: '8.85',
  distance: ''
}, {
  name: 'Kepler-31 b',
  radius: '4.26',
  distance: ''
}, {
  name: 'Kepler-31 c',
  radius: '4.26',
  distance: ''
}, {
  name: 'Kepler-32 b',
  radius: '4.14',
  distance: ''
}, {
  name: 'Kepler-32 c',
  radius: '3.70',
  distance: ''
}, {
  name: 'Kepler-33 b',
  radius: '1.79',
  distance: ''
}, {
  name: 'Kepler-33 c',
  radius: '3.25',
  distance: ''
}, {
  name: 'Kepler-33 d',
  radius: '5.38',
  distance: ''
}, {
  name: 'Kepler-33 e',
  radius: '4.03',
  distance: ''
}, {
  name: 'Kepler-33 f',
  radius: '4.48',
  distance: ''
}, {
  name: 'Kepler-34(AB)  b',
  radius: '8.55',
  distance: '1499.00'
}, {
  name: 'Kepler-35(AB) b',
  radius: '8.15',
  distance: '1645.00'
}, {
  name: 'Kepler-36 b',
  radius: '1.48',
  distance: ''
}, {
  name: 'Kepler-36 c',
  radius: '3.68',
  distance: ''
}, {
  name: 'Kepler-37 b',
  radius: '0.30',
  distance: '66.00'
}, {
  name: 'Kepler-37 c',
  radius: '0.74',
  distance: '66.00'
}, {
  name: 'Kepler-37 d',
  radius: '1.98',
  distance: '66.00'
}, {
  name: 'Kepler-38(AB) b',
  radius: '4.37',
  distance: ''
}, {
  name: 'Kepler-39 b',
  radius: '13.66',
  distance: '1200.00'
}, {
  name: 'Kepler-4 b',
  radius: '4.00',
  distance: '550.00'
}, {
  name: 'Kepler-40 b',
  radius: '13.10',
  distance: '2700.00'
}, {
  name: 'Kepler-41  b',
  radius: '9.42',
  distance: '730.00'
}, {
  name: 'Kepler-42 b',
  radius: '0.78',
  distance: '38.70'
}, {
  name: 'Kepler-42 c',
  radius: '0.73',
  distance: '38.70'
}, {
  name: 'Kepler-42 d',
  radius: '0.57',
  distance: '38.70'
}, {
  name: 'Kepler-43 b',
  radius: '13.44',
  distance: '1950.00'
}, {
  name: 'Kepler-44 b',
  radius: '13.89',
  distance: '2250.00'
}, {
  name: 'Kepler-45 b',
  radius: '10.75',
  distance: '333.00'
}, {
  name: 'Kepler-46 b',
  radius: '9.09',
  distance: '857.00'
}, {
  name: 'Kepler-46 c',
  radius: '14.38',
  distance: '857.00'
}, {
  name: 'Kepler-47(AB) b',
  radius: '3.02',
  distance: ''
}, {
  name: 'Kepler-47(AB) c',
  radius: '4.59',
  distance: ''
}, {
  name: 'Kepler-48 b',
  radius: '2.02',
  distance: ''
}, {
  name: 'Kepler-48 c',
  radius: '3.36',
  distance: ''
}, {
  name: 'Kepler-49 b',
  radius: '2.69',
  distance: ''
}, {
  name: 'Kepler-49 c',
  radius: '2.58',
  distance: ''
}, {
  name: 'Kepler-5 b',
  radius: '16.03',
  distance: ''
}, {
  name: 'Kepler-50 b',
  radius: '2.24',
  distance: ''
}, {
  name: 'Kepler-50 c',
  radius: '2.80',
  distance: ''
}, {
  name: 'Kepler-51 b',
  radius: '7.06',
  distance: ''
}, {
  name: 'Kepler-51 c',
  radius: '5.71',
  distance: ''
}, {
  name: 'Kepler-52 b',
  radius: '2.13',
  distance: ''
}, {
  name: 'Kepler-52 c',
  radius: '1.79',
  distance: ''
}, {
  name: 'Kepler-53 b',
  radius: '2.91',
  distance: ''
}, {
  name: 'Kepler-53 c',
  radius: '3.14',
  distance: ''
}, {
  name: 'Kepler-54 b',
  radius: '2.13',
  distance: ''
}, {
  name: 'Kepler-54 c',
  radius: '1.23',
  distance: ''
}, {
  name: 'Kepler-55 b',
  radius: '2.46',
  distance: ''
}, {
  name: 'Kepler-55 c',
  radius: '2.24',
  distance: ''
}, {
  name: 'Kepler-56 b',
  radius: '6.50',
  distance: ''
}, {
  name: 'Kepler-56 c',
  radius: '9.86',
  distance: ''
}, {
  name: 'Kepler-56 d',
  radius: '13.33',
  distance: ''
}, {
  name: 'Kepler-57 b',
  radius: '2.24',
  distance: ''
}, {
  name: 'Kepler-57 c',
  radius: '1.57',
  distance: ''
}, {
  name: 'Kepler-58 b',
  radius: '2.80',
  distance: ''
}, {
  name: 'Kepler-58 c',
  radius: '2.91',
  distance: ''
}, {
  name: 'Kepler-59 b',
  radius: '1.10',
  distance: ''
}, {
  name: 'Kepler-59 c',
  radius: '2.02',
  distance: ''
}, {
  name: 'Kepler-6 b',
  radius: '14.82',
  distance: ''
}, {
  name: 'Kepler-60 b',
  radius: '2.24',
  distance: ''
}, {
  name: 'Kepler-60 c',
  radius: '2.46',
  distance: ''
}, {
  name: 'Kepler-60 d',
  radius: '2.58',
  distance: ''
}, {
  name: 'Kepler-61 b',
  radius: '2.15',
  distance: '326.00'
}, {
  name: 'Kepler-62 b',
  radius: '1.31',
  distance: '368.00'
}, {
  name: 'Kepler-62 c',
  radius: '0.54',
  distance: '368.00'
}, {
  name: 'Kepler-62 d',
  radius: '1.95',
  distance: '368.00'
}, {
  name: 'Kepler-62 e',
  radius: '1.61',
  distance: '368.00'
}, {
  name: 'Kepler-62 f',
  radius: '1.41',
  distance: '368.00'
}, {
  name: 'Kepler-63 b',
  radius: '6.10',
  distance: '200.00'
}, {
  name: 'Kepler-65 b',
  radius: '1.42',
  distance: ''
}, {
  name: 'Kepler-65 c',
  radius: '2.58',
  distance: ''
}, {
  name: 'Kepler-65 d',
  radius: '1.51',
  distance: ''
}, {
  name: 'Kepler-66 b',
  radius: '2.80',
  distance: '1107.00'
}, {
  name: 'Kepler-67 b',
  radius: '2.91',
  distance: '1107.00'
}, {
  name: 'Kepler-68 b',
  radius: '2.30',
  distance: '135.00'
}, {
  name: 'Kepler-68 c',
  radius: '0.91',
  distance: '135.00'
}, {
  name: 'Kepler-68 d',
  radius: '13.89',
  distance: '135.00'
}, {
  name: 'Kepler-69 b',
  radius: '2.24',
  distance: ''
}, {
  name: 'Kepler-69 c',
  radius: '1.71',
  distance: ''
}, {
  name: 'Kepler-7 b',
  radius: '18.08',
  distance: ''
}, {
  name: 'Kepler-70  b',
  radius: '0.76',
  distance: '1180.00'
}, {
  name: 'Kepler-70 c',
  radius: '0.87',
  distance: '1180.00'
}, {
  name: 'Kepler-71 b',
  radius: '11.71',
  distance: ''
}, {
  name: 'Kepler-74 b',
  radius: '14.78',
  distance: '1330.00'
}, {
  name: 'Kepler-75 b',
  radius: '11.54',
  distance: '1140.00'
}, {
  name: 'Kepler-76 b',
  radius: '14.00',
  distance: ''
}, {
  name: 'Kepler-77 b',
  radius: '10.75',
  distance: '570.00'
}, {
  name: 'Kepler-78 b',
  radius: '1.20',
  distance: ''
}, {
  name: 'Kepler-79 b',
  radius: '3.30',
  distance: ''
}, {
  name: 'Kepler-79 c',
  radius: '3.73',
  distance: ''
}, {
  name: 'Kepler-79 d',
  radius: '7.17',
  distance: ''
}, {
  name: 'Kepler-79 e',
  radius: '3.49',
  distance: ''
}, {
  name: 'Kepler-8 b',
  radius: '15.89',
  distance: '1330.00'
}, {
  name: 'Kepler-80 b',
  radius: '2.35',
  distance: ''
}, {
  name: 'Kepler-80 c',
  radius: '2.58',
  distance: ''
}, {
  name: 'Kepler-80 d',
  radius: '1.40',
  distance: ''
}, {
  name: 'Kepler-80 e',
  radius: '1.50',
  distance: ''
}, {
  name: 'Kepler-80 f',
  radius: '1.30',
  distance: ''
}, {
  name: 'Kepler-81 b',
  radius: '2.54',
  distance: ''
}, {
  name: 'Kepler-81 c',
  radius: '2.45',
  distance: ''
}, {
  name: 'Kepler-82 b',
  radius: '4.00',
  distance: ''
}, {
  name: 'Kepler-82 c',
  radius: '5.30',
  distance: ''
}, {
  name: 'Kepler-83 b',
  radius: '2.34',
  distance: ''
}, {
  name: 'Kepler-83 c',
  radius: '1.94',
  distance: ''
}, {
  name: 'Kepler-84 b',
  radius: '2.20',
  distance: ''
}, {
  name: 'Kepler-84 c',
  radius: '2.40',
  distance: ''
}, {
  name: 'Kepler-85 b',
  radius: '1.99',
  distance: ''
}, {
  name: 'Kepler-85 c',
  radius: '2.21',
  distance: ''
}, {
  name: 'Kepler-86 b',
  radius: '10.14',
  distance: ''
}, {
  name: 'Kepler-87 b',
  radius: '13.55',
  distance: ''
}, {
  name: 'Kepler-87 c',
  radius: '6.15',
  distance: ''
}, {
  name: 'Kepler-88 b',
  radius: '4.22',
  distance: '385.00'
}, {
  name: 'Kepler-88 c',
  radius: '14.04',
  distance: '385.00'
}, {
  name: 'Kepler-89 b',
  radius: '1.71',
  distance: ''
}, {
  name: 'Kepler-89 c',
  radius: '4.32',
  distance: ''
}, {
  name: 'Kepler-89 d',
  radius: '11.20',
  distance: ''
}, {
  name: 'Kepler-89 e',
  radius: '6.16',
  distance: ''
}, {
  name: 'Kepler-9 b',
  radius: '9.42',
  distance: ''
}, {
  name: 'Kepler-9 c',
  radius: '9.21',
  distance: ''
}, {
  name: 'Kepler-9 d',
  radius: '1.65',
  distance: ''
}, {
  name: 'Kepler-90 b',
  radius: '1.31',
  distance: ''
}, {
  name: 'Kepler-90 c',
  radius: '1.19',
  distance: ''
}, {
  name: 'Kepler-90 d',
  radius: '2.88',
  distance: ''
}, {
  name: 'Kepler-90 e',
  radius: '2.67',
  distance: ''
}, {
  name: 'Kepler-90 f',
  radius: '2.89',
  distance: ''
}, {
  name: 'Kepler-90 g',
  radius: '8.12',
  distance: ''
}, {
  name: 'Kepler-90 h',
  radius: '11.31',
  distance: ''
}, {
  name: 'KIC-10255705 b',
  radius: '7.28',
  distance: ''
}, {
  name: 'KIC-10905746 b',
  radius: '2.65',
  distance: ''
}, {
  name: 'KIC-11152511 b',
  radius: '4.03',
  distance: ''
}, {
  name: 'KIC-12351927(AB) b',
  radius: '4.37',
  distance: ''
}, {
  name: 'KIC-12454613 b',
  radius: '2.69',
  distance: ''
}, {
  name: 'KIC-12557548 b',
  radius: '0.85',
  distance: '470.00'
}, {
  name: 'KIC-5010054 b',
  radius: '6.94',
  distance: ''
}, {
  name: 'KIC-5094412 b',
  radius: '5.71',
  distance: ''
}, {
  name: 'KIC-5522786 b',
  radius: '1.23',
  distance: ''
}, {
  name: 'KIC-5732155 b',
  radius: '12.77',
  distance: ''
}, {
  name: 'KIC-6185331 b',
  radius: '8.06',
  distance: ''
}, {
  name: 'KIC-6372194 b',
  radius: '8.29',
  distance: ''
}, {
  name: 'KIC-6436029 c',
  radius: '3.07',
  distance: ''
}, {
  name: 'KIC-8852719 b',
  radius: '3.53',
  distance: ''
}, {
  name: 'KIC-9662267 b',
  radius: '3.81',
  distance: ''
}, {
  name: 'KIC-9704149 b',
  radius: '4.48',
  distance: ''
}, {
  name: 'KOI-111 b',
  radius: '2.14',
  distance: ''
}, {
  name: 'KOI-111 c',
  radius: '2.05',
  distance: ''
}, {
  name: 'KOI-115 b',
  radius: '4.82',
  distance: ''
}, {
  name: 'KOI-115 c',
  radius: '1.91',
  distance: ''
}, {
  name: 'KOI-117 b',
  radius: '1.58',
  distance: ''
}, {
  name: 'KOI-117 c',
  radius: '1.71',
  distance: ''
}, {
  name: 'KOI-1203 b',
  radius: '2.90',
  distance: ''
}, {
  name: 'KOI-1203 c',
  radius: '2.80',
  distance: ''
}, {
  name: 'KOI-1215 b',
  radius: '2.92',
  distance: ''
}, {
  name: 'KOI-1215 c',
  radius: '3.36',
  distance: ''
}, {
  name: 'KOI-1236 b',
  radius: '4.31',
  distance: ''
}, {
  name: 'KOI-1236 c',
  radius: '3.10',
  distance: ''
}, {
  name: 'KOI-1278 b',
  radius: '2.46',
  distance: ''
}, {
  name: 'KOI-1278 c',
  radius: '3.10',
  distance: ''
}, {
  name: 'KOI-156 b',
  radius: '1.18',
  distance: ''
}, {
  name: 'KOI-156 c',
  radius: '1.60',
  distance: ''
}, {
  name: 'KOI-156 d',
  radius: '2.53',
  distance: ''
}, {
  name: 'KOI-1563 b',
  radius: '3.61',
  distance: ''
}, {
  name: 'KOI-1563 c',
  radius: '3.30',
  distance: ''
}, {
  name: 'KOI-1576 c',
  radius: '2.80',
  distance: ''
}, {
  name: 'KOI-1676 b',
  radius: '3.20',
  distance: ''
}, {
  name: 'KOI-1781 b',
  radius: '1.88',
  distance: ''
}, {
  name: 'KOI-1843 b',
  radius: '0.58',
  distance: ''
}, {
  name: 'KOI-1873 b',
  radius: '2.31',
  distance: ''
}, {
  name: 'KOI-1873 c',
  radius: '5.41',
  distance: ''
}, {
  name: 'KOI-202 b',
  radius: '11.42',
  distance: ''
}, {
  name: 'KOI-2025 b',
  radius: '3.10',
  distance: ''
}, {
  name: 'KOI-2025 c',
  radius: '2.80',
  distance: ''
}, {
  name: 'KOI-206 b',
  radius: '7.84',
  distance: ''
}, {
  name: 'KOI-2672 b',
  radius: '3.47',
  distance: ''
}, {
  name: 'KOI-2672 c',
  radius: '5.26',
  distance: ''
}, {
  name: 'KOI-274 b',
  radius: '1.13',
  distance: ''
}, {
  name: 'KOI-274 c',
  radius: '1.13',
  distance: ''
}, {
  name: 'KOI-282 b',
  radius: '2.90',
  distance: ''
}, {
  name: 'KOI-285 b',
  radius: '3.52',
  distance: ''
}, {
  name: 'KOI-285 c',
  radius: '2.61',
  distance: ''
}, {
  name: 'KOI-370 b',
  radius: '2.65',
  distance: ''
}, {
  name: 'KOI-370 c',
  radius: '4.42',
  distance: ''
}, {
  name: 'KOI-523 b',
  radius: '2.90',
  distance: ''
}, {
  name: 'KOI-523 c',
  radius: '7.11',
  distance: ''
}, {
  name: 'KOI-680 b',
  radius: '7.28',
  distance: ''
}, {
  name: 'KOI-730 b',
  radius: '3.47',
  distance: ''
}, {
  name: 'KOI-730 c',
  radius: '2.58',
  distance: ''
}, {
  name: 'KOI-730 d',
  radius: '2.80',
  distance: ''
}, {
  name: 'KOI-730 e',
  radius: '2.02',
  distance: ''
}, {
  name: 'KOI-82 b',
  radius: '2.20',
  distance: ''
}, {
  name: 'KOI-82 c',
  radius: '1.34',
  distance: ''
}, {
  name: 'KOI-82 d',
  radius: '0.69',
  distance: ''
}, {
  name: 'KOI-834 b',
  radius: '5.61',
  distance: ''
}, {
  name: 'KOI-834 c',
  radius: '2.00',
  distance: ''
}, {
  name: 'ksi Aql b',
  radius: '13.46',
  distance: '62.70'
}, {
  name: 'LKCA 15 b',
  radius: '13.13',
  distance: '145.00'
}, {
  name: 'MOA-2007-BLG-192-L b',
  radius: '1.54',
  distance: '700.00'
}, {
  name: 'MOA-2007-BLG-400-L b',
  radius: '13.97',
  distance: '6000.00'
}, {
  name: 'MOA-2008-BLG-310-L b',
  radius: '10.07',
  distance: '6000.00'
}, {
  name: 'MOA-2008-BLG-379L b',
  radius: '13.17',
  distance: '3600.00'
}, {
  name: 'MOA-2009-BLG-266L b',
  radius: '3.38',
  distance: '3040.00'
}, {
  name: 'MOA-2009-BLG-319 b',
  radius: '8.14',
  distance: '6100.00'
}, {
  name: 'MOA-2009-BLG-387L b',
  radius: '13.50',
  distance: '5700.00'
}, {
  name: 'MOA-2010-BLG-328L b',
  radius: '3.42',
  distance: '810.00'
}, {
  name: 'MOA-2010-BLG-477L b',
  radius: '13.74',
  distance: '2300.00'
}, {
  name: 'MOA-2011-BLG-293L b',
  radius: '13.23',
  distance: '7700.00'
}, {
  name: 'MOA-2011-BLG-322 b',
  radius: '12.96',
  distance: '7740.00'
}, {
  name: 'MOA-bin-1 b',
  radius: '13.34',
  distance: '5100.00'
}, {
  name: 'mu Ara b',
  radius: '13.69',
  distance: '15.30'
}, {
  name: 'mu Ara c',
  radius: '3.41',
  distance: '15.30'
}, {
  name: 'mu Ara d',
  radius: '14.23',
  distance: '15.30'
}, {
  name: 'mu Ara e',
  radius: '13.66',
  distance: '15.30'
}, {
  name: 'NGC 2423 3 b',
  radius: '12.89',
  distance: '766.00'
}, {
  name: 'NGC 4349 No 127 b',
  radius: '12.63',
  distance: '2176.00'
}, {
  name: 'NN Ser(AB) c',
  radius: '13.07',
  distance: '500.00'
}, {
  name: 'NN Ser(AB) d',
  radius: '13.55',
  distance: '500.00'
}, {
  name: 'nu Oph b',
  radius: '12.55',
  distance: '46.80'
}, {
  name: 'nu Oph c',
  radius: '12.50',
  distance: '46.80'
}, {
  name: 'NY Vir b',
  radius: '13.49',
  distance: ''
}, {
  name: 'OGLE-05-071L b',
  radius: '13.37',
  distance: '3300.00'
}, {
  name: 'OGLE-05-169L b',
  radius: '3.78',
  distance: '2700.00'
}, {
  name: 'OGLE-05-390L b',
  radius: '1.94',
  distance: '6500.00'
}, {
  name: 'OGLE-06-109L b',
  radius: '14.07',
  distance: '1510.00'
}, {
  name: 'OGLE-06-109L c',
  radius: '11.04',
  distance: '1510.00'
}, {
  name: 'OGLE-2007-BLG-368L b',
  radius: '5.15',
  distance: '5900.00'
}, {
  name: 'OGLE-2009-BLG-151_MOA-2009-232 b',
  radius: '12.97',
  distance: '390.00'
}, {
  name: 'OGLE-2011-BLG-0251 b',
  radius: '13.88',
  distance: '4090.00'
}, {
  name: 'OGLE-2011-BLG-0420 b',
  radius: '12.88',
  distance: '1990.00'
}, {
  name: 'OGLE-2012-BLG-0026L b',
  radius: '7.22',
  distance: '4080.00'
}, {
  name: 'OGLE-2012-BLG-0026L c',
  radius: '14.04',
  distance: '4080.00'
}, {
  name: 'OGLE-2012-BLG-0358L b',
  radius: '13.58',
  distance: '1760.00'
}, {
  name: 'OGLE-2012-BLG-0406L b',
  radius: '13.41',
  distance: '4970.00'
}, {
  name: 'OGLE-TR-10 b',
  radius: '19.26',
  distance: '1500.00'
}, {
  name: 'OGLE-TR-111 b',
  radius: '12.06',
  distance: '1500.00'
}, {
  name: 'OGLE-TR-113 b',
  radius: '12.43',
  distance: '1500.00'
}, {
  name: 'OGLE-TR-132 b',
  radius: '13.78',
  distance: '1500.00'
}, {
  name: 'OGLE-TR-182 b',
  radius: '16.46',
  distance: ''
}, {
  name: 'OGLE-TR-211 b',
  radius: '14.11',
  distance: ''
}, {
  name: 'OGLE-TR-56 b',
  radius: '13.44',
  distance: '1500.00'
}, {
  name: 'OGLE2-TR-L9 b',
  radius: '18.08',
  distance: '900.00'
}, {
  name: 'OGLE235-MOA53 b',
  radius: '13.50',
  distance: '5200.00'
}, {
  name: 'ome Ser b',
  radius: '13.62',
  distance: '80.60'
}, {
  name: 'omi CrB b',
  radius: '13.68',
  distance: '84.00'
}, {
  name: 'omi UMa b',
  radius: '13.23',
  distance: '56.30'
}, {
  name: 'Oph 11 b',
  radius: '12.60',
  distance: '145.00'
}, {
  name: 'PH1-Kepler-64 b',
  radius: '6.19',
  distance: ''
}, {
  name: 'POTS-1 b',
  radius: '10.54',
  distance: ''
}, {
  name: 'Pr0201 c',
  radius: '14.14',
  distance: ''
}, {
  name: 'Pr0211 b',
  radius: '13.59',
  distance: ''
}, {
  name: 'PSR 1257 12 b',
  radius: '0.30',
  distance: '710.00'
}, {
  name: 'PSR 1257 12 c',
  radius: '1.72',
  distance: '710.00'
}, {
  name: 'PSR 1257 12 d',
  radius: '1.66',
  distance: '710.00'
}, {
  name: 'PSR 1719-14 b',
  radius: '4.48',
  distance: '1200.00'
}, {
  name: 'PSR B1620-26 b',
  radius: '13.51',
  distance: '3800.00'
}, {
  name: 'Qatar-1 b',
  radius: '13.04',
  distance: ''
}, {
  name: 'Qatar-2 b',
  radius: '12.81',
  distance: ''
}, {
  name: 'Ross 458(AB) c',
  radius: '12.98',
  distance: '114.00'
}, {
  name: 'ROXs 42B b',
  radius: '12.83',
  distance: '135.00'
}, {
  name: 'RR Cae b',
  radius: '13.22',
  distance: ''
}, {
  name: 'SR 12 AB c',
  radius: '12.80',
  distance: '125.00'
}, {
  name: 'SWEEPS-04b',
  radius: '9.07',
  distance: '8500.00'
}, {
  name: 'SWEEPS-11b',
  radius: '12.66',
  distance: '8500.00'
}, {
  name: 'tau Boo b',
  radius: '13.14',
  distance: '15.60'
}, {
  name: 'tau Gem b',
  radius: '12.55',
  distance: '98.40'
}, {
  name: 'TrES-1b',
  radius: '12.31',
  distance: '157.00'
}, {
  name: 'TrES-2b',
  radius: '13.09',
  distance: '220.00'
}, {
  name: 'TrES-3b',
  radius: '14.62',
  distance: ''
}, {
  name: 'TrES-4b',
  radius: '19.11',
  distance: '479.00'
}, {
  name: 'TrES-5b',
  radius: '13.54',
  distance: '360.00'
}, {
  name: 'ups And b',
  radius: '14.15',
  distance: '13.47'
}, {
  name: 'ups And c',
  radius: '13.66',
  distance: '13.47'
}, {
  name: 'ups And d',
  radius: '12.91',
  distance: '13.47'
}, {
  name: 'ups And e',
  radius: '13.90',
  distance: '13.47'
}, {
  name: 'USco1602-2401 b',
  radius: '12.22',
  distance: ''
}, {
  name: 'USco1610-1913 b',
  radius: '12.56',
  distance: ''
}, {
  name: 'USco1612-1800 b',
  radius: '12.46',
  distance: ''
}, {
  name: 'UScoCTIO 108 b',
  radius: '12.72',
  distance: '145.00'
}, {
  name: 'UZ For(ab) d',
  radius: '12.96',
  distance: ''
}, {
  name: 'V391 Peg b',
  radius: '13.41',
  distance: '1400.00'
}, {
  name: 'WASP-1 b',
  radius: '16.62',
  distance: ''
}, {
  name: 'WASP-10 b',
  radius: '12.10',
  distance: '90.00'
}, {
  name: 'WASP-100 b',
  radius: '18.93',
  distance: ''
}, {
  name: 'WASP-101 b',
  radius: '15.79',
  distance: ''
}, {
  name: 'WASP-11-HAT-P-10 b',
  radius: '11.70',
  distance: '125.00'
}, {
  name: 'WASP-12 b',
  radius: '19.44',
  distance: '427.00'
}, {
  name: 'WASP-13 b',
  radius: '15.29',
  distance: '156.00'
}, {
  name: 'WASP-14 b',
  radius: '14.35',
  distance: '160.00'
}, {
  name: 'WASP-15 b',
  radius: '15.99',
  distance: '308.00'
}, {
  name: 'WASP-16 b',
  radius: '11.29',
  distance: ''
}, {
  name: 'WASP-17 b',
  radius: '22.30',
  distance: ''
}, {
  name: 'WASP-18 b',
  radius: '13.05',
  distance: '100.00'
}, {
  name: 'WASP-19 b',
  radius: '15.62',
  distance: ''
}, {
  name: 'WASP-2 b',
  radius: '12.08',
  distance: '144.00'
}, {
  name: 'WASP-20 b',
  radius: '10.08',
  distance: ''
}, {
  name: 'WASP-21 b',
  radius: '13.55',
  distance: '230.00'
}, {
  name: 'WASP-22 b',
  radius: '12.97',
  distance: '300.00'
}, {
  name: 'WASP-23 b',
  radius: '10.77',
  distance: ''
}, {
  name: 'WASP-24 b',
  radius: '12.36',
  distance: '330.00'
}, {
  name: 'WASP-25 b',
  radius: '14.11',
  distance: '169.00'
}, {
  name: 'WASP-26 b',
  radius: '14.35',
  distance: '250.00'
}, {
  name: 'WASP-28 b',
  radius: '12.54',
  distance: '334.00'
}, {
  name: 'WASP-29 b',
  radius: '9.42',
  distance: '80.00'
}, {
  name: 'WASP-3 b',
  radius: '16.28',
  distance: '223.00'
}, {
  name: 'WASP-31 b',
  radius: '17.21',
  distance: '400.00'
}, {
  name: 'WASP-32 b',
  radius: '13.22',
  distance: ''
}, {
  name: 'WASP-33 b',
  radius: '16.11',
  distance: '116.00'
}, {
  name: 'WASP-34 b',
  radius: '13.66',
  distance: '120.00'
}, {
  name: 'WASP-35 b',
  radius: '14.78',
  distance: ''
}, {
  name: 'WASP-36 b',
  radius: '14.21',
  distance: '450.00'
}, {
  name: 'WASP-37 b',
  radius: '12.72',
  distance: '338.00'
}, {
  name: 'WASP-38 b',
  radius: '12.08',
  distance: '110.00'
}, {
  name: 'WASP-39 b',
  radius: '14.22',
  distance: '230.00'
}, {
  name: 'WASP-4 b',
  radius: '15.62',
  distance: '300.00'
}, {
  name: 'WASP-41 b',
  radius: '13.55',
  distance: '180.00'
}, {
  name: 'WASP-42 b',
  radius: '12.10',
  distance: ''
}, {
  name: 'WASP-43 b',
  radius: '11.60',
  distance: ''
}, {
  name: 'WASP-44 b',
  radius: '12.77',
  distance: ''
}, {
  name: 'WASP-45 b',
  radius: '12.99',
  distance: ''
}, {
  name: 'WASP-46 b',
  radius: '14.67',
  distance: ''
}, {
  name: 'WASP-47 b',
  radius: '12.88',
  distance: '200.00'
}, {
  name: 'WASP-48 b',
  radius: '18.70',
  distance: ''
}, {
  name: 'WASP-49 b',
  radius: '12.49',
  distance: ''
}, {
  name: 'WASP-5 b',
  radius: '13.12',
  distance: '297.00'
}, {
  name: 'WASP-50 b',
  radius: '12.75',
  distance: '230.00'
}, {
  name: 'WASP-52 b',
  radius: '14.22',
  distance: '140.00'
}, {
  name: 'WASP-53 b',
  radius: '13.44',
  distance: ''
}, {
  name: 'WASP-54 b',
  radius: '15.68',
  distance: ''
}, {
  name: 'WASP-55 b',
  radius: '14.56',
  distance: '330.00'
}, {
  name: 'WASP-56 b',
  radius: '13.44',
  distance: ''
}, {
  name: 'WASP-57 b',
  radius: '12.32',
  distance: ''
}, {
  name: 'WASP-58 b',
  radius: '15.34',
  distance: '300.00'
}, {
  name: 'WASP-59 b',
  radius: '10.08',
  distance: '125.00'
}, {
  name: 'WASP-6 b',
  radius: '13.71',
  distance: '307.00'
}, {
  name: 'WASP-60 b',
  radius: '10.08',
  distance: '400.00'
}, {
  name: 'WASP-61 b',
  radius: '13.89',
  distance: '480.00'
}, {
  name: 'WASP-62 b',
  radius: '15.57',
  distance: '160.00'
}, {
  name: 'WASP-63 b',
  radius: '16.02',
  distance: '330.00'
}, {
  name: 'WASP-64 b',
  radius: '7.84',
  distance: ''
}, {
  name: 'WASP-65 b',
  radius: '12.45',
  distance: '310.00'
}, {
  name: 'WASP-66 b',
  radius: '15.57',
  distance: '380.00'
}, {
  name: 'WASP-67 b',
  radius: '15.68',
  distance: '225.00'
}, {
  name: 'WASP-68 b',
  radius: '10.08',
  distance: ''
}, {
  name: 'WASP-69 b',
  radius: '11.20',
  distance: ''
}, {
  name: 'WASP-7 b',
  radius: '14.90',
  distance: '140.00'
}, {
  name: 'WASP-70 b',
  radius: '8.96',
  distance: ''
}, {
  name: 'WASP-71 b',
  radius: '16.80',
  distance: '200.00'
}, {
  name: 'WASP-72 b',
  radius: '14.22',
  distance: ''
}, {
  name: 'WASP-75 b',
  radius: '14.22',
  distance: '260.00'
}, {
  name: 'WASP-76 b',
  radius: '20.50',
  distance: '120.00'
}, {
  name: 'WASP-77A b',
  radius: '13.55',
  distance: ''
}, {
  name: 'WASP-78 b',
  radius: '19.60',
  distance: '550.00'
}, {
  name: 'WASP-79 b',
  radius: '19.04',
  distance: '240.00'
}, {
  name: 'WASP-8 b',
  radius: '11.63',
  distance: '87.00'
}, {
  name: 'WASP-80 b',
  radius: '10.66',
  distance: '60.00'
}, {
  name: 'WASP-82 b',
  radius: '18.70',
  distance: '200.00'
}, {
  name: 'WASP-84 b',
  radius: '10.55',
  distance: '120.00'
}, {
  name: 'WASP-90 b',
  radius: '18.26',
  distance: '340.00'
}, {
  name: 'WASP-95 b',
  radius: '13.55',
  distance: ''
}, {
  name: 'WASP-96 b',
  radius: '13.44',
  distance: ''
}, {
  name: 'WASP-97 b',
  radius: '12.66',
  distance: ''
}, {
  name: 'WASP-98 b',
  radius: '12.32',
  distance: ''
}, {
  name: 'WASP-99 b',
  radius: '12.32',
  distance: ''
}, {
  name: 'WD 0806-661B b',
  radius: '13.01',
  distance: '19.20'
}, {
  name: 'WISE 1217+16A b',
  radius: '11.20',
  distance: '10.00'
}, {
  name: 'WISE 1711+3500 b',
  radius: '12.74',
  distance: '19.00'
}, {
  name: 'WTS-1 b',
  radius: '16.69',
  distance: '3200.00'
}, {
  name: 'WTS-2 b',
  radius: '14.56',
  distance: '1000.00'
}, {
  name: 'XO-1 b',
  radius: '13.26',
  distance: '200.00'
}, {
  name: 'XO-2 b',
  radius: '10.90',
  distance: '149.00'
}, {
  name: 'XO-3 b',
  radius: '13.63',
  distance: '260.00'
}, {
  name: 'XO-4 b',
  radius: '15.01',
  distance: '293.00'
}, {
  name: 'XO-5 b',
  radius: '11.54',
  distance: '255.00'
}];

var planets = [{
  name: 'Jupiter',
  radius: '10.97',
  distance: '0'
}, {
  name: 'Saturn',
  radius: '9.14',
  distance: '0'
}, {
  name: 'Uranus',
  radius: '3.98',
  distance: '0'
}, {
  name: 'Neptune',
  radius: '3.86',
  distance: '0'
}, {
  name: 'Earth',
  radius: '1',
  distance: '0'
}, {
  name: 'Venus',
  radius: '0.950',
  distance: '0'
}, {
  name: 'Mars',
  radius: '0.532',
  distance: '0'
}, {
  name: 'Mercury',
  radius: '0.383',
  distance: '0'
}, {
  name: 'Pluto',
  radius: '0.181',
  distance: '0'
}];

var shakespeare = [{
  id: 'Shakespeare',
  parent: null,
  size: 0
}, {
  id: 'Comedies',
  parent: 'Shakespeare',
  size: null
}, {
  id: 'Tragedies',
  parent: 'Shakespeare',
  size: null
}, {
  id: 'Histories',
  parent: 'Shakespeare',
  size: null
}, {
  id: 'As You Like It',
  parent: 'Comedies',
  size: null
}, {
  id: 'Adam',
  parent: 'As You Like It',
  size: 10
}, {
  id: 'Amiens',
  parent: 'As You Like It',
  size: 10
}, {
  id: 'Audrey',
  parent: 'As You Like It',
  size: 12
}, {
  id: 'Celia',
  parent: 'As You Like It',
  size: 108
}, {
  id: 'Charles',
  parent: 'As You Like It',
  size: 8
}, {
  id: 'Corin',
  parent: 'As You Like It',
  size: 24
}, {
  id: 'Dennis',
  parent: 'As You Like It',
  size: 2
}, {
  id: 'Duke',
  parent: 'As You Like It',
  size: 32
}, {
  id: 'Frederick',
  parent: 'As You Like It',
  size: 20
}, {
  id: 'Hymen',
  parent: 'As You Like It',
  size: 1
}, {
  id: 'Jaques (lord)',
  parent: 'As You Like It',
  size: 57
}, {
  id: 'Jaques (son)',
  parent: 'As You Like It',
  size: 2
}, {
  id: 'Le Beau',
  parent: 'As You Like It',
  size: 14
}, {
  id: 'Oliver',
  parent: 'As You Like It',
  size: 37
}, {
  id: 'Orlando',
  parent: 'As You Like It',
  size: 120
}, {
  id: 'Phebe',
  parent: 'As You Like It',
  size: 23
}, {
  id: 'Rosalind',
  parent: 'As You Like It',
  size: 201
}, {
  id: 'Silvius',
  parent: 'As You Like It',
  size: 24
}, {
  id: 'Sir Oliver Martext',
  parent: 'As You Like It',
  size: 3
}, {
  id: 'Touchstone',
  parent: 'As You Like It',
  size: 74
}, {
  id: 'William',
  parent: 'As You Like It',
  size: 11
}, {
  id: 'Comedy Of Errors',
  parent: 'Comedies',
  size: null
}, {
  id: 'Adriana',
  parent: 'Comedy Of Errors',
  size: 79
}, {
  id: 'Aegeon',
  parent: 'Comedy Of Errors',
  size: 17
}, {
  id: 'Aemilia',
  parent: 'Comedy Of Errors',
  size: 16
}, {
  id: 'Angelo',
  parent: 'Comedy Of Errors',
  size: 31
}, {
  id: 'Antipholus of Ephesus',
  parent: 'Comedy Of Errors',
  size: 76
}, {
  id: 'Antipholus of Syracuse',
  parent: 'Comedy Of Errors',
  size: 103
}, {
  id: 'Balthazar',
  parent: 'Comedy Of Errors',
  size: 5
}, {
  id: 'Courtezan',
  parent: 'Comedy Of Errors',
  size: 11
}, {
  id: 'Dromio of Ephesus',
  parent: 'Comedy Of Errors',
  size: 63
}, {
  id: 'Dromio of Syracuse',
  parent: 'Comedy Of Errors',
  size: 99
}, {
  id: 'Luce',
  parent: 'Comedy Of Errors',
  size: 7
}, {
  id: 'Luciana',
  parent: 'Comedy Of Errors',
  size: 43
}, {
  id: 'Pinch',
  parent: 'Comedy Of Errors',
  size: 6
}, {
  id: 'Solinus',
  parent: 'Comedy Of Errors',
  size: 22
}, {
  id: 'Merchant Of Venice',
  parent: 'Comedies',
  size: null
}, {
  id: 'Antonio',
  parent: 'Merchant Of Venice',
  size: 47
}, {
  id: 'Balthasar',
  parent: 'Merchant Of Venice',
  size: 1
}, {
  id: 'Bassanio',
  parent: 'Merchant Of Venice',
  size: 73
}, {
  id: 'Duke (of Venice)',
  parent: 'Merchant Of Venice',
  size: 18
}, {
  id: 'Gratiano',
  parent: 'Merchant Of Venice',
  size: 48
}, {
  id: 'Jessica',
  parent: 'Merchant Of Venice',
  size: 26
}, {
  id: 'Launcelot Gobbo',
  parent: 'Merchant Of Venice',
  size: 44
}, {
  id: 'Leonardo',
  parent: 'Merchant Of Venice',
  size: 2
}, {
  id: 'Lorenzo',
  parent: 'Merchant Of Venice',
  size: 47
}, {
  id: 'Nerissa',
  parent: 'Merchant Of Venice',
  size: 36
}, {
  id: 'Old Gobbo',
  parent: 'Merchant Of Venice',
  size: 19
}, {
  id: 'Portia',
  parent: 'Merchant Of Venice',
  size: 117
}, {
  id: 'Prince of Arragon',
  parent: 'Merchant Of Venice',
  size: 4
}, {
  id: 'Prince of Morocco',
  parent: 'Merchant Of Venice',
  size: 7
}, {
  id: 'Salanio',
  parent: 'Merchant Of Venice',
  size: 18
}, {
  id: 'Salarino',
  parent: 'Merchant Of Venice',
  size: 27
}, {
  id: 'Salerio',
  parent: 'Merchant Of Venice',
  size: 6
}, {
  id: 'Shylock',
  parent: 'Merchant Of Venice',
  size: 79
}, {
  id: 'Stephano',
  parent: 'Merchant Of Venice',
  size: 3
}, {
  id: 'Tubal',
  parent: 'Merchant Of Venice',
  size: 8
}, {
  id: "Midsummer Night's Dream",
  parent: 'Comedies',
  size: null
}, {
  id: 'Bottom',
  parent: "Midsummer Night's Dream",
  size: 59
}, {
  id: 'Cobweb',
  parent: "Midsummer Night's Dream",
  size: 4
}, {
  id: 'Demetrius',
  parent: "Midsummer Night's Dream",
  size: 48
}, {
  id: 'Egeus',
  parent: "Midsummer Night's Dream",
  size: 7
}, {
  id: 'Fairy',
  parent: "Midsummer Night's Dream",
  size: 4
}, {
  id: 'Flute',
  parent: "Midsummer Night's Dream",
  size: 18
}, {
  id: 'Helena',
  parent: "Midsummer Night's Dream",
  size: 36
}, {
  id: 'Hermia',
  parent: "Midsummer Night's Dream",
  size: 48
}, {
  id: 'Hippolyta',
  parent: "Midsummer Night's Dream",
  size: 14
}, {
  id: 'Lysander',
  parent: "Midsummer Night's Dream",
  size: 50
}, {
  id: 'Moth',
  parent: "Midsummer Night's Dream",
  size: 2
}, {
  id: 'Mustardseed',
  parent: "Midsummer Night's Dream",
  size: 5
}, {
  id: 'Oberon',
  parent: "Midsummer Night's Dream",
  size: 29
}, {
  id: 'Peaseblossom',
  parent: "Midsummer Night's Dream",
  size: 4
}, {
  id: 'Philostrate',
  parent: "Midsummer Night's Dream",
  size: 6
}, {
  id: 'Puck',
  parent: "Midsummer Night's Dream",
  size: 33
}, {
  id: 'Quince',
  parent: "Midsummer Night's Dream",
  size: 40
}, {
  id: 'Snout',
  parent: "Midsummer Night's Dream",
  size: 9
}, {
  id: 'Snug',
  parent: "Midsummer Night's Dream",
  size: 4
}, {
  id: 'Starveling',
  parent: "Midsummer Night's Dream",
  size: 7
}, {
  id: 'Theseus',
  parent: "Midsummer Night's Dream",
  size: 48
}, {
  id: 'Titania',
  parent: "Midsummer Night's Dream",
  size: 23
}, {
  id: 'Taming Of The Shrew',
  parent: 'Comedies',
  size: null
}, {
  id: 'Baptista Minola',
  parent: 'Taming Of The Shrew',
  size: 68
}, {
  id: 'Bianca',
  parent: 'Taming Of The Shrew',
  size: 29
}, {
  id: 'Biondello',
  parent: 'Taming Of The Shrew',
  size: 39
}, {
  id: 'Christopher Sly',
  parent: 'Taming Of The Shrew',
  size: 24
}, {
  id: 'Curtis',
  parent: 'Taming Of The Shrew',
  size: 20
}, {
  id: 'Gremio',
  parent: 'Taming Of The Shrew',
  size: 58
}, {
  id: 'Grumio',
  parent: 'Taming Of The Shrew',
  size: 63
}, {
  id: 'Haberdasher',
  parent: 'Taming Of The Shrew',
  size: 1
}, {
  id: 'Hortensio',
  parent: 'Taming Of The Shrew',
  size: 70
}, {
  id: 'Joseph',
  parent: 'Taming Of The Shrew',
  size: 1
}, {
  id: 'Katherina',
  parent: 'Taming Of The Shrew',
  size: 82
}, {
  id: 'Lucentio',
  parent: 'Taming Of The Shrew',
  size: 61
}, {
  id: 'Nathaniel',
  parent: 'Taming Of The Shrew',
  size: 4
}, {
  id: 'Nicholas',
  parent: 'Taming Of The Shrew',
  size: 1
}, {
  id: 'Peter',
  parent: 'Taming Of The Shrew',
  size: 2
}, {
  id: 'Petruchio',
  parent: 'Taming Of The Shrew',
  size: 158
}, {
  id: 'Philip',
  parent: 'Taming Of The Shrew',
  size: 1
}, {
  id: 'Tranio',
  parent: 'Taming Of The Shrew',
  size: 90
}, {
  id: 'Vincentio',
  parent: 'Taming Of The Shrew',
  size: 23
}, {
  id: 'The Tempest',
  parent: 'Comedies',
  size: null
}, {
  id: 'Adrian',
  parent: 'The Tempest',
  size: 9
}, {
  id: 'Alonso',
  parent: 'The Tempest',
  size: 40
}, {
  id: 'Antonio, duke of Milan',
  parent: 'The Tempest',
  size: 57
}, {
  id: 'Ariel',
  parent: 'The Tempest',
  size: 45
}, {
  id: 'Caliban',
  parent: 'The Tempest',
  size: 50
}, {
  id: 'Ceres',
  parent: 'The Tempest',
  size: 4
}, {
  id: 'Ferdinand',
  parent: 'The Tempest',
  size: 31
}, {
  id: 'Francisco',
  parent: 'The Tempest',
  size: 2
}, {
  id: 'Gonzalo',
  parent: 'The Tempest',
  size: 52
}, {
  id: 'Iris',
  parent: 'The Tempest',
  size: 4
}, {
  id: 'Juno',
  parent: 'The Tempest',
  size: 2
}, {
  id: 'Master',
  parent: 'The Tempest',
  size: 2
}, {
  id: 'Miranda',
  parent: 'The Tempest',
  size: 50
}, {
  id: 'Nymphs',
  parent: 'The Tempest',
  size: 0
}, {
  id: 'Prospero',
  parent: 'The Tempest',
  size: 114
}, {
  id: 'Reapers',
  parent: 'The Tempest',
  size: 0
}, {
  id: 'Sebastian',
  parent: 'The Tempest',
  size: 67
}, {
  id: 'Stephano (Servant to Portia)',
  parent: 'The Tempest',
  size: 60
}, {
  id: 'Trinculo',
  parent: 'The Tempest',
  size: 39
}, {
  id: 'Henry VIII',
  parent: 'Histories',
  size: null
}, {
  id: 'Anne Bullen',
  parent: 'Henry VIII',
  size: 18
}, {
  id: 'Archbishop Cranmer',
  parent: 'Henry VIII',
  size: 21
}, {
  id: 'Bishop Lincoln',
  parent: 'Henry VIII',
  size: 2
}, {
  id: 'Brandon',
  parent: 'Henry VIII',
  size: 6
}, {
  id: 'Capucius',
  parent: 'Henry VIII',
  size: 5
}, {
  id: 'Cardinal Campeius',
  parent: 'Henry VIII',
  size: 14
}, {
  id: 'Cardinal Wolsey',
  parent: 'Henry VIII',
  size: 79
}, {
  id: 'Cromwell',
  parent: 'Henry VIII',
  size: 21
}, {
  id: 'Doctor Butts',
  parent: 'Henry VIII',
  size: 4
}, {
  id: 'Duke of Buckingham',
  parent: 'Henry VIII',
  size: 26
}, {
  id: 'Duke of Norfolk',
  parent: 'Henry VIII',
  size: 48
}, {
  id: 'Duke of Suffolk',
  parent: 'Henry VIII',
  size: 30
}, {
  id: 'Earl of Surrey',
  parent: 'Henry VIII',
  size: 24
}, {
  id: 'First Secretary to Wolsey',
  parent: 'Henry VIII',
  size: 2
}, {
  id: 'Gardiner',
  parent: 'Henry VIII',
  size: 22
}, {
  id: 'Garter',
  parent: 'Henry VIII',
  size: 1
}, {
  id: 'Griffith',
  parent: 'Henry VIII',
  size: 13
}, {
  id: 'King Henry VIII',
  parent: 'Henry VIII',
  size: 81
}, {
  id: 'Lord Abergavenny',
  parent: 'Henry VIII',
  size: 5
}, {
  id: 'Lord Chamberlain',
  parent: 'Henry VIII',
  size: 38
}, {
  id: 'Lord Chancellor',
  parent: 'Henry VIII',
  size: 7
}, {
  id: 'Lord Sands',
  parent: 'Henry VIII',
  size: 17
}, {
  id: 'Old Lady',
  parent: 'Henry VIII',
  size: 14
}, {
  id: 'Patience',
  parent: 'Henry VIII',
  size: 3
}, {
  id: 'Porter (door-keeper of the Council-chamber)',
  parent: 'Henry VIII',
  size: 10
}, {
  id: 'Queen Katharine',
  parent: 'Henry VIII',
  size: 50
}, {
  id: 'Sir Anthony Denny',
  parent: 'Henry VIII',
  size: 3
}, {
  id: 'Sir Henry Guildford',
  parent: 'Henry VIII',
  size: 1
}, {
  id: 'Sir Nicholas Vaux',
  parent: 'Henry VIII',
  size: 1
}, {
  id: 'Sir Thomas Lovell',
  parent: 'Henry VIII',
  size: 21
}, {
  id: 'Surveyor to the Duke of Buckingham',
  parent: 'Henry VIII',
  size: 9
}, {
  id: 'History Of King John',
  parent: 'Histories',
  size: null
}, {
  id: 'Arthur Duke of Bretagne',
  parent: 'History Of King John',
  size: 23
}, {
  id: 'Blanch',
  parent: 'History Of King John',
  size: 9
}, {
  id: 'Cardinal Pandulph',
  parent: 'History Of King John',
  size: 23
}, {
  id: 'Chatillon',
  parent: 'History Of King John',
  size: 5
}, {
  id: 'Constance',
  parent: 'History Of King John',
  size: 36
}, {
  id: 'Essex',
  parent: 'History Of King John',
  size: 1
}, {
  id: 'Faulconbridge',
  parent: 'History Of King John',
  size: 4
}, {
  id: 'Hubert de Burgh',
  parent: 'History Of King John',
  size: 52
}, {
  id: 'James Gurney',
  parent: 'History Of King John',
  size: 1
}, {
  id: 'King John',
  parent: 'History Of King John',
  size: 95
}, {
  id: 'King Phillip',
  parent: 'History Of King John',
  size: 43
}, {
  id: 'Lady Faulconbridge',
  parent: 'History Of King John',
  size: 5
}, {
  id: 'Lewis the Dauphin',
  parent: 'History Of King John',
  size: 29
}, {
  id: 'Lord Bigot',
  parent: 'History Of King John',
  size: 6
}, {
  id: 'Lymoges duke of Austria',
  parent: 'History Of King John',
  size: 16
}, {
  id: 'Melun',
  parent: 'History Of King John',
  size: 3
}, {
  id: 'Pembroke earl of Pembroke',
  parent: 'History Of King John',
  size: 20
}, {
  id: 'Peter of Pomfret',
  parent: 'History Of King John',
  size: 1
}, {
  id: 'Philip the Bastard',
  parent: 'History Of King John',
  size: 89
}, {
  id: 'Prince Henry',
  parent: 'History Of King John',
  size: 8
}, {
  id: 'Queen Elinor',
  parent: 'History Of King John',
  size: 22
}, {
  id: 'Salisbury earl of Salisbury',
  parent: 'History Of King John',
  size: 36
}, {
  id: 'Antony And Cleopatra',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Agrippa',
  parent: 'Antony And Cleopatra',
  size: 28
}, {
  id: 'Alexas',
  parent: 'Antony And Cleopatra',
  size: 15
}, {
  id: 'Antony',
  parent: 'Antony And Cleopatra',
  size: 202
}, {
  id: 'Canidius',
  parent: 'Antony And Cleopatra',
  size: 10
}, {
  id: 'Captain',
  parent: 'Antony And Cleopatra',
  size: 1
}, {
  id: 'Charmian',
  parent: 'Antony And Cleopatra',
  size: 63
}, {
  id: 'Cleopatra',
  parent: 'Antony And Cleopatra',
  size: 204
}, {
  id: 'Demetrius (Friend to Antony)',
  parent: 'Antony And Cleopatra',
  size: 2
}, {
  id: 'Dercetas',
  parent: 'Antony And Cleopatra',
  size: 5
}, {
  id: 'Diomedes',
  parent: 'Antony And Cleopatra',
  size: 7
}, {
  id: 'Dolabella',
  parent: 'Antony And Cleopatra',
  size: 23
}, {
  id: 'Domitius Enobarus',
  parent: 'Antony And Cleopatra',
  size: 113
}, {
  id: 'Egyptian',
  parent: 'Antony And Cleopatra',
  size: 2
}, {
  id: 'Eros',
  parent: 'Antony And Cleopatra',
  size: 27
}, {
  id: 'Euphronius',
  parent: 'Antony And Cleopatra',
  size: 5
}, {
  id: 'Gallus',
  parent: 'Antony And Cleopatra',
  size: 1
}, {
  id: 'Iras',
  parent: 'Antony And Cleopatra',
  size: 18
}, {
  id: 'Lepidus',
  parent: 'Antony And Cleopatra',
  size: 30
}, {
  id: 'Mardian',
  parent: 'Antony And Cleopatra',
  size: 7
}, {
  id: 'Mecaenas',
  parent: 'Antony And Cleopatra',
  size: 16
}, {
  id: 'Menas',
  parent: 'Antony And Cleopatra',
  size: 35
}, {
  id: 'Menecrates',
  parent: 'Antony And Cleopatra',
  size: 2
}, {
  id: 'Octavia',
  parent: 'Antony And Cleopatra',
  size: 13
}, {
  id: 'Octavius',
  parent: 'Antony And Cleopatra',
  size: 98
}, {
  id: 'Philo',
  parent: 'Antony And Cleopatra',
  size: 2
}, {
  id: 'Pompey',
  parent: 'Antony And Cleopatra',
  size: 41
}, {
  id: 'Proculeius',
  parent: 'Antony And Cleopatra',
  size: 10
}, {
  id: 'Scarus',
  parent: 'Antony And Cleopatra',
  size: 12
}, {
  id: 'Seleucus',
  parent: 'Antony And Cleopatra',
  size: 3
}, {
  id: 'Silius',
  parent: 'Antony And Cleopatra',
  size: 3
}, {
  id: 'Taurus',
  parent: 'Antony And Cleopatra',
  size: 1
}, {
  id: 'Thyreus',
  parent: 'Antony And Cleopatra',
  size: 12
}, {
  id: 'Varrius',
  parent: 'Antony And Cleopatra',
  size: 1
}, {
  id: 'Ventidius',
  parent: 'Antony And Cleopatra',
  size: 4
}, {
  id: 'Coriolanus',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Aedile',
  parent: 'Coriolanus',
  size: 10
}, {
  id: 'Cominius',
  parent: 'Coriolanus',
  size: 67
}, {
  id: 'Coriolanus (Caius Marcius Coriolanus)',
  parent: 'Coriolanus',
  size: 189
}, {
  id: 'Junius Brutus',
  parent: 'Coriolanus',
  size: 91
}, {
  id: 'Lieutenant',
  parent: 'Coriolanus',
  size: 4
}, {
  id: 'Menenius Agrippa',
  parent: 'Coriolanus',
  size: 162
}, {
  id: 'Patrician',
  parent: 'Coriolanus',
  size: 3
}, {
  id: 'Roman',
  parent: 'Coriolanus',
  size: 10
}, {
  id: 'Sicinius Velutus',
  parent: 'Coriolanus',
  size: 117
}, {
  id: 'Titus Lartius',
  parent: 'Coriolanus',
  size: 23
}, {
  id: 'Tullus Aufidius',
  parent: 'Coriolanus',
  size: 45
}, {
  id: 'Valeria',
  parent: 'Coriolanus',
  size: 14
}, {
  id: 'Virgilia',
  parent: 'Coriolanus',
  size: 26
}, {
  id: 'Volsce',
  parent: 'Coriolanus',
  size: 9
}, {
  id: 'Volumnia',
  parent: 'Coriolanus',
  size: 57
}, {
  id: 'Young Coriolanus',
  parent: 'Coriolanus',
  size: 1
}, {
  id: 'Cymbeline',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Arviragus',
  parent: 'Cymbeline',
  size: 46
}, {
  id: 'Belarius',
  parent: 'Cymbeline',
  size: 58
}, {
  id: 'Caius Lucius',
  parent: 'Cymbeline',
  size: 25
}, {
  id: 'Cloten',
  parent: 'Cymbeline',
  size: 77
}, {
  id: 'Cornelius (physician)',
  parent: 'Cymbeline',
  size: 13
}, {
  id: 'Cymbeline, King of Britain',
  parent: 'Cymbeline',
  size: 81
}, {
  id: 'Guiderius',
  parent: 'Cymbeline',
  size: 62
}, {
  id: 'Helen',
  parent: 'Cymbeline',
  size: 0
}, {
  id: 'Iachimo',
  parent: 'Cymbeline',
  size: 77
}, {
  id: 'Imogen',
  parent: 'Cymbeline',
  size: 118
}, {
  id: 'Jupiter',
  parent: 'Cymbeline',
  size: 1
}, {
  id: 'Philario',
  parent: 'Cymbeline',
  size: 14
}, {
  id: 'Pisanio',
  parent: 'Cymbeline',
  size: 58
}, {
  id: 'Posthumus Leonatus',
  parent: 'Cymbeline',
  size: 77
}, {
  id: 'Queen',
  parent: 'Cymbeline',
  size: 27
}, {
  id: 'Roman Captain',
  parent: 'Cymbeline',
  size: 4
}, {
  id: 'Sicilius Leonatus',
  parent: 'Cymbeline',
  size: 7
}, {
  id: 'The Tragedy of Hamlet, Prince of Denmark',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Bernardo',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 19
}, {
  id: 'Claudius, King of Denmark',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 102
}, {
  id: 'Cornelius',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 1
}, {
  id: "Father's Ghost",
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 15
}, {
  id: 'Fortinbras',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 6
}, {
  id: 'Francisco ',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 8
}, {
  id: 'Gertrude',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 69
}, {
  id: 'Guildenstern',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 29
}, {
  id: 'Hamlet',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 358
}, {
  id: 'Horatio',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 109
}, {
  id: 'Laertes',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 62
}, {
  id: 'Lucianus',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 0
}, {
  id: 'Marcellus',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 37
}, {
  id: 'Ophelia',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 58
}, {
  id: 'Osric',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 25
}, {
  id: 'Polonius',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 86
}, {
  id: 'Reynaldo',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 13
}, {
  id: 'Rosencrantz',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 48
}, {
  id: 'Voltemand',
  parent: 'The Tragedy of Hamlet, Prince of Denmark',
  size: 1
}, {
  id: 'Julius Caesar',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Antony (Marcus Antonius)',
  parent: 'Julius Caesar',
  size: 51
}, {
  id: 'Artemidorus of Cnidos',
  parent: 'Julius Caesar',
  size: 4
}, {
  id: 'Brutus (Marcus Brutus)',
  parent: 'Julius Caesar',
  size: 194
}, {
  id: 'Caesar (Julius Caesar)',
  parent: 'Julius Caesar',
  size: 42
}, {
  id: 'Calpurnia',
  parent: 'Julius Caesar',
  size: 6
}, {
  id: 'Casca',
  parent: 'Julius Caesar',
  size: 39
}, {
  id: 'Cassius',
  parent: 'Julius Caesar',
  size: 140
}, {
  id: 'Cicero',
  parent: 'Julius Caesar',
  size: 4
}, {
  id: 'Cinna',
  parent: 'Julius Caesar',
  size: 11
}, {
  id: 'Cinna the Poet',
  parent: 'Julius Caesar',
  size: 8
}, {
  id: 'Claudius',
  parent: 'Julius Caesar',
  size: 2
}, {
  id: 'Clitus',
  parent: 'Julius Caesar',
  size: 8
}, {
  id: 'Dardanius',
  parent: 'Julius Caesar',
  size: 3
}, {
  id: 'Decius Brutus',
  parent: 'Julius Caesar',
  size: 12
}, {
  id: 'Flavius',
  parent: 'Julius Caesar',
  size: 5
}, {
  id: 'Lepidus (Marcus Antonius Lepidus)',
  parent: 'Julius Caesar',
  size: 3
}, {
  id: 'Ligarius',
  parent: 'Julius Caesar',
  size: 5
}, {
  id: 'Lucilius',
  parent: 'Julius Caesar',
  size: 10
}, {
  id: 'Lucius',
  parent: 'Julius Caesar',
  size: 24
}, {
  id: 'Marullus',
  parent: 'Julius Caesar',
  size: 6
}, {
  id: 'Messala',
  parent: 'Julius Caesar',
  size: 20
}, {
  id: 'Metellus Cimber',
  parent: 'Julius Caesar',
  size: 5
}, {
  id: 'Octavius (Octavius Caesar)',
  parent: 'Julius Caesar',
  size: 19
}, {
  id: 'Pindarus',
  parent: 'Julius Caesar',
  size: 5
}, {
  id: 'Popilius (Popilius Lena)',
  parent: 'Julius Caesar',
  size: 2
}, {
  id: 'Portia (wife of Brutus)',
  parent: 'Julius Caesar',
  size: 16
}, {
  id: 'Publius',
  parent: 'Julius Caesar',
  size: 2
}, {
  id: 'Strato',
  parent: 'Julius Caesar',
  size: 4
}, {
  id: 'Tintinius',
  parent: 'Julius Caesar',
  size: 10
}, {
  id: 'Trebonius',
  parent: 'Julius Caesar',
  size: 4
}, {
  id: 'Varro',
  parent: 'Julius Caesar',
  size: 6
}, {
  id: 'Volumnius',
  parent: 'Julius Caesar',
  size: 3
}, {
  id: 'Young Cato',
  parent: 'Julius Caesar',
  size: 3
}, {
  id: 'King Lear',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Cordelia',
  parent: 'King Lear',
  size: 31
}, {
  id: 'Curan',
  parent: 'King Lear',
  size: 4
}, {
  id: 'Duke of Albany',
  parent: 'King Lear',
  size: 58
}, {
  id: 'Duke of Burgundy',
  parent: 'King Lear',
  size: 5
}, {
  id: 'Duke of Cornwall',
  parent: 'King Lear',
  size: 53
}, {
  id: 'Earl of Gloucester',
  parent: 'King Lear',
  size: 118
}, {
  id: 'Earl of Kent',
  parent: 'King Lear',
  size: 127
}, {
  id: 'Edgar',
  parent: 'King Lear',
  size: 98
}, {
  id: 'Edmund',
  parent: 'King Lear',
  size: 79
}, {
  id: 'Goneril',
  parent: 'King Lear',
  size: 53
}, {
  id: 'King of France',
  parent: 'King Lear',
  size: 5
}, {
  id: 'Lear',
  parent: 'King Lear',
  size: 188
}, {
  id: 'Oswald',
  parent: 'King Lear',
  size: 38
}, {
  id: 'Regan',
  parent: 'King Lear',
  size: 73
}, {
  id: 'The Tragedy Of Macbeth',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Angus',
  parent: 'The Tragedy Of Macbeth',
  size: 4
}, {
  id: 'Banquo',
  parent: 'The Tragedy Of Macbeth',
  size: 33
}, {
  id: 'Caithness',
  parent: 'The Tragedy Of Macbeth',
  size: 3
}, {
  id: 'Donalbain',
  parent: 'The Tragedy Of Macbeth',
  size: 3
}, {
  id: 'Duncan',
  parent: 'The Tragedy Of Macbeth',
  size: 18
}, {
  id: 'Fleance',
  parent: 'The Tragedy Of Macbeth',
  size: 2
}, {
  id: 'Hecate',
  parent: 'The Tragedy Of Macbeth',
  size: 2
}, {
  id: 'Lady Macbeth',
  parent: 'The Tragedy Of Macbeth',
  size: 59
}, {
  id: 'Lady Macduff',
  parent: 'The Tragedy Of Macbeth',
  size: 19
}, {
  id: 'Lennox',
  parent: 'The Tragedy Of Macbeth',
  size: 21
}, {
  id: 'Macbeth',
  parent: 'The Tragedy Of Macbeth',
  size: 146
}, {
  id: 'Macduff',
  parent: 'The Tragedy Of Macbeth',
  size: 59
}, {
  id: 'Malcolm',
  parent: 'The Tragedy Of Macbeth',
  size: 40
}, {
  id: 'Menteith',
  parent: 'The Tragedy Of Macbeth',
  size: 5
}, {
  id: 'Porter',
  parent: 'The Tragedy Of Macbeth',
  size: 4
}, {
  id: 'Ross',
  parent: 'The Tragedy Of Macbeth',
  size: 39
}, {
  id: 'Seyton',
  parent: 'The Tragedy Of Macbeth',
  size: 5
}, {
  id: 'Siward',
  parent: 'The Tragedy Of Macbeth',
  size: 11
}, {
  id: "Son (Macduff's son)",
  parent: 'The Tragedy Of Macbeth',
  size: 14
}, {
  id: 'Young Siward',
  parent: 'The Tragedy Of Macbeth',
  size: 4
}, {
  id: 'The Tragedy Of Othello',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Bianca (Mistress to Cassio)',
  parent: 'The Tragedy Of Othello',
  size: 15
}, {
  id: 'Brabantio',
  parent: 'The Tragedy Of Othello',
  size: 30
}, {
  id: 'Cassio',
  parent: 'The Tragedy Of Othello',
  size: 110
}, {
  id: 'Desdemona',
  parent: 'The Tragedy Of Othello',
  size: 165
}, {
  id: 'Duke of Venice',
  parent: 'The Tragedy Of Othello',
  size: 25
}, {
  id: 'Emilia',
  parent: 'The Tragedy Of Othello',
  size: 103
}, {
  id: 'Gratiano (Brother to Brabantio)',
  parent: 'The Tragedy Of Othello',
  size: 20
}, {
  id: 'Iago',
  parent: 'The Tragedy Of Othello',
  size: 272
}, {
  id: 'Lodovico',
  parent: 'The Tragedy Of Othello',
  size: 33
}, {
  id: 'Montano',
  parent: 'The Tragedy Of Othello',
  size: 24
}, {
  id: 'Othello',
  parent: 'The Tragedy Of Othello',
  size: 274
}, {
  id: 'Roderigo',
  parent: 'The Tragedy Of Othello',
  size: 59
}, {
  id: 'Romeo And Juliet',
  parent: 'Tragedies',
  size: null
}, {
  id: 'Abraham',
  parent: 'Romeo And Juliet',
  size: 5
}, {
  id: 'Balthasar (Servant to Romeo)',
  parent: 'Romeo And Juliet',
  size: 12
}, {
  id: 'Benvolio',
  parent: 'Romeo And Juliet',
  size: 64
}, {
  id: 'Capulet',
  parent: 'Romeo And Juliet',
  size: 51
}, {
  id: 'Friar John',
  parent: 'Romeo And Juliet',
  size: 4
}, {
  id: 'Friar Laurence',
  parent: 'Romeo And Juliet',
  size: 55
}, {
  id: 'Gregory',
  parent: 'Romeo And Juliet',
  size: 15
}, {
  id: 'Juliet',
  parent: 'Romeo And Juliet',
  size: 118
}, {
  id: 'Lady Capulet',
  parent: 'Romeo And Juliet',
  size: 45
}, {
  id: 'Lady Montague',
  parent: 'Romeo And Juliet',
  size: 2
}, {
  id: 'Mercutio',
  parent: 'Romeo And Juliet',
  size: 62
}, {
  id: 'Montague',
  parent: 'Romeo And Juliet',
  size: 10
}, {
  id: 'Paris',
  parent: 'Romeo And Juliet',
  size: 23
}, {
  id: "Peter (Servant to Juliet's Nurse)",
  parent: 'Romeo And Juliet',
  size: 13
}, {
  id: 'Prince Escalus',
  parent: 'Romeo And Juliet',
  size: 16
}, {
  id: 'Romeo',
  parent: 'Romeo And Juliet',
  size: 163
}, {
  id: 'Sampson',
  parent: 'Romeo And Juliet',
  size: 20
}, {
  id: 'Tybalt',
  parent: 'Romeo And Juliet',
  size: 17
}];

export { genDateValue, genPoints as genRandomNormalPoints, genBin, genBins, genStats, appleStock, letterFrequency, browserUsage, groupDateValue, cityTemperature, lesMiserables, exoplanets, planets, shakespeare };



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/@vx/mock-data/dist/vx-mock-data.es.js
// module id = mkHX
// module chunks = 0